import { mapGetters } from 'vuex';

export default {
  data: () => ({
    i18n_mode: process.env.VUE_APP_LANG_MODE,
    i18n_message: {
      '発送するカード': {
        'en': 'card to send',
        'it': 'carta da inviare',
        'de': 'Karte zum Versenden',
        'es': 'tarjeta para enviar',
        'fr': 'carte à envoyer',
        'ko': '발송할 카드',
        'zh': '待寄送的賀卡',
        'zh-TW': '待寄送的贺卡',
      },
      '登録情報': {
        'en': 'Registration information',
        'it': 'Informazioni sulla registrazione',
        'de': 'Anmeldeinformationen',
        'es': 'Información de registro',
        'fr': 'Informations d\'inscription',
        'ko': '등록정보',
        'zh': '註冊資訊',
        'zh-TW': '注册信息',
      },
      '個人情報': {
        'en': 'personal information',
        'it': 'informazioni personali',
        'de': 'persönliche Informationen',
        'es': 'información personal',
        'fr': 'informations personnelles',
        'ko': '개인정보',
        'zh': '個人資訊',
        'zh-TW': '个人信息',
      },
      'パスワード変更': {
        'en': 'Change password',
        'it': 'Cambiare la password',
        'de': 'Kennwort ändern',
        'es': 'Cambiar la contraseña',
        'fr': 'Changer le mot de passe',
        'ko': '비밀번호 변경',
        'zh': '更改密碼',
        'zh-TW': '更改密码',
      },
      '戻る': {
        'en': 'Return',
        'it': 'Ritorno',
        'de': 'Zurückkehren',
        'es': 'Devolver',
        'fr': 'Retour',
        'ko': '뒤로',
        'zh': '返回',
        'zh-TW': '返回',
      },
      '最終確認': {
        'en': 'Final confirmation',
        'it': 'Conferma finale',
        'de': 'Endgültige Bestätigung',
        'es': 'Confirmación final',
        'fr': 'Confirmation finale',
        'ko': '최종 확인',
        'zh': '最終確認',
        'zh-TW': '最终确认',
      },
      '選択したものでお間違いないでしょうか？': {
        'en': 'Are you sure about the ',
        'it': 'Sei sicuro di quello ',
        'de': 'Sind Sie sicher, ',
        'es': '¿Estás seguro del ',
        'fr': 'Etes-vous sûr de celui que ',
        'ko': '당신이 선택한 것에 ',
        'zh': '你確定你選擇的',
        'zh-TW': '你确定你选择的',
      },
      '(※確定後の変更はできません)': {
        'en': 'one you chose?',
        'it': 'che hai scelto?',
        'de': 'welches Sie gewählt haben?',
        'es': 'que elegiste?',
        'fr': 'vous avez choisi ?',
        'ko': '틀림없습니까?',
        'zh': '那個嗎？',
        'zh-TW': '那个吗？',
      },
      'キャンセル': {
        'en': 'Cancel',
        'it': 'Cancellare',
        'de': 'Stornieren',
        'es': 'Cancelar',
        'fr': 'Annuler',
        'ko': '취소',
        'zh': '取消',
        'zh-TW': '取消',
      },
      'はい': {
        'en': 'Yes',
        'it': 'SÌ',
        'de': 'Ja',
        'es': 'Sí',
        'fr': 'Oui',
        'ko': '예',
        'zh': '是的',
        'zh-TW': '是的',
      },
      '同じガチャを買う': {
        'en': 'Buy the same gacha',
        'it': 'Compra lo stesso gacha',
        'de': 'Kaufe die gleiche Gacha',
        'es': 'Comprar la misma gacha',
        'fr': 'Acheter le même gacha',
        'ko': '같은 가챠를 사',
        'zh': '購買同一款扭蛋',
        'zh-TW': '购买同一款扭蛋',
      },
      'Xmarketリストへ': {
        'en': 'Go to my Xmarket list',
        'it': 'Vai alla mia lista Xmarket',
        'de': 'Gehen Sie zu meiner Xmarket-Liste',
        'es': 'Ir a mi lista de Xmarket',
        'fr': 'Accédez à ma liste Xmarket',
        'ko': '내 Xmarket 목록에',
        'zh': '前往我的 Xmarket 名單',
        'zh-TW': '前往我的 Xmarket 列表',
      },
      'TOPページへ': {
        'en': 'Go to TOP page',
        'it': 'Vai alla pagina TOP',
        'de': 'Gehen Sie zur TOP-Seite',
        'es': 'Ir a la página SUPERIOR',
        'fr': 'Aller à la page TOP',
        'ko': 'TOP 페이지로',
        'zh': '回到頂部',
        'zh-TW': '返回顶部',
      },
      '会員登録完了': {
        'en': 'Membership registration completed',
        'it': 'Registrazione adesione completata',
        'de': 'Registrierung der Mitgliedschaft abgeschlossen',
        'es': 'Registro de membresía completado',
        'fr': 'Inscription des membres terminée',
        'ko': '회원 등록 완료',
        'zh': '會員註冊完成',
        'zh-TW': '会员注册完成',
      },
      '会員登録ありがとうございます！': {
        'en': 'Thank you for registering as a member!',
        'it': 'Grazie per esserti registrato come membro!',
        'de': 'Vielen Dank für Ihre Registrierung als Mitglied!',
        'es': '¡Gracias por registrarse como miembro!',
        'fr': 'Merci de votre inscription en tant que membre !',
        'ko': '회원 등록 감사합니다!',
        'zh': '感謝您的註冊！',
        'zh-TW': '感谢您的注册！',
      },
      '引き続きガチャの購入をお楽しみください': {
        'en': 'Please continue to enjoy purchasing gacha.',
        'it': 'Continua a divertirti acquistando Gacha.',
        'de': 'Viel Spaß beim Kauf von Gacha.',
        'es': 'Continúe disfrutando comprando gacha.',
        'fr': 'Veuillez continuer à profiter de l\'achat de gacha.',
        'ko': '계속 가챠 구매를 즐기세요',
        'zh': '請繼續享受購買扭蛋道具的樂趣。',
        'zh-TW': '请继续享受购买扭蛋道具的乐趣。',
      },
      '確認': {
        'en': 'confirmation',
        'it': 'conferma',
        'de': 'Bestätigung',
        'es': 'confirmación',
        'fr': 'confirmation',
        'ko': '확인',
        'zh': '確認',
        'zh-TW': '确认',
      },
      '友達紹介コードの登録が完了しました': {
        'en': 'Your friend referral code registration is complete.',
        'it': 'La registrazione del tuo codice di invito amico è completa.',
        'de': 'Die Registrierung Ihres Freundesempfehlungscodes ist abgeschlossen.',
        'es': 'El registro de tu código de referencia de amigo se ha completado.',
        'fr': 'L\'enregistrement de votre code de parrainage est terminé.',
        'ko': '친구 소개 코드 등록이 완료되었습니다.',
        'zh': '您的好友推薦碼註冊已完成。',
        'zh-TW': '您的好友推荐码注册已完成。',
      },
      '友達紹介コードを入力してください': {
        'en': 'Please enter the friend referral code.',
        'it': 'Inserisci il codice di invito amico.',
        'de': 'Bitte geben Sie den Freundesempfehlungscode ein.',
        'es': 'Por favor, introduce el código de referencia de tu amigo.',
        'fr': 'Veuillez saisir le code de parrainage de votre ami.',
        'ko': '친구 추천 코드를 입력하세요.',
        'zh': '請輸入好友推薦碼。',
        'zh-TW': '请输入好友推荐码。',
      },
      '購入内容確認': {
        'en': 'Confirm purchase details',
        'it': 'Conferma i dettagli dell\'acquisto',
        'de': 'Bestätigen Sie die Kaufdetails',
        'es': 'Confirmar detalles de compra',
        'fr': 'Confirmer les détails de l\'achat',
        'ko': '구매 내용 확인',
        'zh': '購買詳情確認',
        'zh-TW': '购买详情确认',
      },
      '購入商品名': {
        'en': 'Purchased product name',
        'it': 'Nome del prodotto acquistato',
        'de': 'Name des gekauften Produkts',
        'es': 'Nombre del producto comprado',
        'fr': 'Nom du produit acheté',
        'ko': '구매상품명',
        'zh': '購買的產品名稱',
        'zh-TW': '购买的产品名称',
      },
      '消費コイン': {
        'en': 'Consumption coins',
        'it': 'Monete di consumo',
        'de': 'Konsummünzen',
        'es': 'Monedas de consumo',
        'fr': 'Pièces de consommation',
        'ko': '소비 동전',
        'zh': '消費幣',
        'zh-TW': '消费币',
      },
      'を消費し': {
        'en': 'consume',
        'it': 'consumare',
        'de': 'verbrauchen',
        'es': 'consumir',
        'fr': 'consommer',
        'ko': '소비',
        'zh': '消耗',
        'zh-TW': '消耗',
      },
      '回ガチャを引く': {
        'en': 'Draw a gacha',
        'it': 'Disegna un gacha',
        'de': 'Zeichne ein Gacha-Spiel',
        'es': 'Dibuja un gacha',
        'fr': 'Dessine un gacha',
        'ko': '한 번 뽑기를 당기다',
        'zh': '畫一個扭蛋',
        'zh-TW': '画一个扭蛋',
      },
      '所持コイン': {
        'en': 'Holder coins',
        'it': 'Monete portamonete',
        'de': 'Inhabermünzen',
        'es': 'Monederos',
        'fr': 'Pièces porteuses',
        'ko': '소지 코인',
        'zh': '持有硬幣',
        'zh-TW': '持有硬币',
      },
      'よろしいですか？': {
        'en': 'Are you sure?',
        'it': 'Sei sicuro?',
        'de': 'Bist du sicher?',
        'es': '¿Está seguro?',
        'fr': 'Es-tu sûr?',
        'ko': '괜찮습니까?',
        'zh': '這樣可以嗎？',
        'zh-TW': '这样可以吗？',
      },
      '商品ページに戻る': {
        'en': 'Return to product page',
        'it': 'Ritorna alla pagina del prodotto',
        'de': 'Zurück zur Produktseite',
        'es': 'Volver a la página del producto',
        'fr': 'Retour à la page produit',
        'ko': '상품 페이지로 돌아가기',
        'zh': '返回產品頁面',
        'zh-TW': '返回产品页面',
      },
      'いいえ': {
        'en': 'no',
        'it': 'NO',
        'de': 'NEIN',
        'es': 'No',
        'fr': 'Non',
        'ko': '아니오',
        'zh': '不',
        'zh-TW': '不',
      },
      'コインが不足しています': {
        'en': 'running out of coins',
        'it': 'a corto di monete',
        'de': 'Die Münzen gehen aus',
        'es': 'quedarse sin monedas',
        'fr': 'à court de pièces',
        'ko': '동전 부족',
        'zh': '我們硬幣不夠用了。',
        'zh-TW': '我们硬币不够用了。',
      },
      'コイン購入': {
        'en': 'Purchase coins',
        'it': 'acquistare monete',
        'de': 'Münzen kaufen',
        'es': 'comprar monedas',
        'fr': 'acheter des pièces',
        'ko': '동전 구매',
        'zh': '購買金幣',
        'zh-TW': '购买金币',
      },
      '購入コイン': {
        'en': 'Purchase coins',
        'it': 'acquistare monete',
        'de': 'Münzen kaufen',
        'es': 'comprar monedas',
        'fr': 'acheter des pièces',
        'ko': '구매 코인',
        'zh': '購買金幣',
        'zh-TW': '购买金币',
      },
      'お支払い金額': {
        'en': 'Payment amount',
        'it': 'Importo del pagamento',
        'de': 'Zahlungsbetrag',
        'es': 'Monto del pago',
        'fr': 'Montant du paiement',
        'ko': '지불 금액',
        'zh': '付款金額',
        'zh-TW': '付款金额',
      },
      '購入する': {
        'en': 'buy',
        'it': 'acquistare',
        'de': 'kaufen',
        'es': 'comprar',
        'fr': 'acheter',
        'ko': '구매',
        'zh': '買',
        'zh-TW': '买',
      },
      '決済が成功し、コインが反映しました。': {
        'en': 'The payment was successful and the coins have been credited to your account.',
        'it': 'Il pagamento è andato a buon fine e le monete sono state accreditate sul tuo account.',
        'de': 'Die Zahlung war erfolgreich und die Coins wurden Ihrem Konto gutgeschrieben.',
        'es': 'El pago se realizó correctamente y las monedas se han abonado en su cuenta.',
        'fr': 'Le paiement a été effectué avec succès et les pièces ont été créditées sur votre compte.',
        'ko': '결제가 성공하고 동전이 반영했습니다.',
        'zh': '付款成功，金幣已存入您的帳戶。',
        'zh-TW': '付款成功，金币已存入您的账户。',
      },
      '決済が失敗しました。クレジットカードの状態をご確認ください。\n原因不明な場合は、クレジットカード会社にお問い合わせください。': {
        'en': 'Payment failed. Please check the status of your credit card. \nIf you are unsure of the status, please contact your credit card company.',
        'it': 'Pagamento non riuscito. Ti invitiamo a verificare lo stato della tua carta di credito. \nSe non sei sicuro dello stato, contatta la società della tua carta di credito.',
        'de': 'Die Zahlung ist fehlgeschlagen. Bitte überprüfen Sie den Status Ihrer Kreditkarte. \nWenn Sie sich über den Status nicht sicher sind, wenden Sie sich bitte an Ihr Kreditkartenunternehmen.',
        'es': 'El pago falló. Por favor verifique el estado de su tarjeta de crédito. \nSi no está seguro del estado, comuníquese con la compañía de su tarjeta de crédito.',
        'fr': 'Le paiement a échoué. Veuillez vérifier l\'état de votre carte de crédit. \nSi vous n\'êtes pas sûr du statut, veuillez contacter la société émettrice de votre carte de crédit.',
        'ko': '결제가 실패했습니다. 신용 카드 상태를 확인하십시오. \n 상태가 알려지지 않은 경우 신용 카드 회사에 문의하십시오.',
        'zh': '付款失敗。請檢查您的信用卡狀態。如果原因不明，請聯絡您的信用卡公司。',
        'zh-TW': '付款失败。请检查您的信用卡状态。如果原因不明，请联系您的信用卡公司。',
      },
      'ご入力いただいたカード情報が確認できませんでした。\n再度ご入力内容をご確認ください。': {
        'en': 'The card information you entered could not be confirmed. \nPlease check the information you entered again.',
        'it': 'Non è stato possibile confermare le informazioni sulla carta inserite. \nControlla nuovamente le informazioni inserite.',
        'de': 'Die von Ihnen eingegebenen Karteninformationen konnten nicht bestätigt werden. \nBitte überprüfen Sie die von Ihnen eingegebenen Informationen noch einmal.',
        'es': 'No se pudo confirmar la información de la tarjeta que ingresó. \nPor favor verifique la información que ingresó nuevamente.',
        'fr': 'Les informations de carte que vous avez saisies n\'ont pas pu être confirmées. \nVeuillez vérifier à nouveau les informations que vous avez saisies.',
        'ko': '입력하신 카드 정보를 확인할 수 없습니다.\n다시 입력 내용을 확인해 주십시오.',
        'zh': '您輸入的銀行卡資訊無法驗證，請再次核對。',
        'zh-TW': '您输入的银行卡信息无法验证，请再次核对。',
      },
      'カード番号': {
        'en': 'Card number',
        'it': 'Numero della carta',
        'de': 'Kartennummer',
        'es': 'Número de tarjeta',
        'fr': 'Numéro de carte',
        'ko': '카드 번호',
        'zh': '卡號',
        'zh-TW': '卡号',
      },
      'カード(年月)': {
        'en': 'Card (year/month)',
        'it': 'Carta (year/month)',
        'de': 'Karte (year/month)',
        'es': 'Tarjeta (year/month)',
        'fr': 'Carte (year/month)',
        'ko': '카드(year/month)',
        'zh': '卡(year/month)',
        'zh-TW': '卡(year/month)',
      },
      'カード(セキュリティコード)': {
        'en': 'Card (security code)',
        'it': 'Carta (codice di sicurezza)',
        'de': 'Karte (Sicherheitscode)',
        'es': 'Tarjeta (código de seguridad)',
        'fr': 'Carte (code de sécurité)',
        'ko': '카드 (보안 코드)',
        'zh': '卡（安全碼）',
        'zh-TW': '卡（安全码）',
      },
      'カード名義': {
        'en': 'Card holder name',
        'it': 'Nome del titolare',
        'de': 'Name des Karteninhabers',
        'es': 'Nombre del titular de la tarjeta',
        'fr': 'Nom du titulaire de la carte',
        'ko': '카드 명의',
        'zh': '持卡人姓名',
        'zh-TW': '持卡人姓名',
      },
      'システムメンテナンス': {
        'en': 'system maintenance',
        'it': 'manutenzione del sistema',
        'de': 'Systemwartung',
        'es': 'mantenimiento del sistema',
        'fr': 'entretien du système',
        'ko': '시스템 유지보수',
        'zh': '系統維​​護',
        'zh-TW': '系统维护',
      },
      '通信エラー': {
        'en': 'Communication error',
        'it': 'Errore di comunicazione',
        'de': 'Kommunikationsfehler',
        'es': 'Error de comunicación',
        'fr': 'Erreur de communication',
        'ko': '통신 오류',
        'zh': '通訊錯誤',
        'zh-TW': '通信错误',
      },
      'その他': {
        'en': 'others',
        'it': 'altri',
        'de': 'andere',
        'es': 'otros',
        'fr': 'autres',
        'ko': '기타',
        'zh': '其他的',
        'zh-TW': '其他的',
      },
      'が不正です': {
        'en': 'is incorrect',
        'it': 'non è corretto',
        'de': 'ist falsch',
        'es': 'es incorrecto',
        'fr': 'est incorrect',
        'ko': '불법입니다.',
        'zh': '這是違法的。',
        'zh-TW': '这是违法的。',
      },
      '仮パスワード発行': {
        'en': 'Temporary password issued',
        'it': 'Password temporanea rilasciata',
        'de': 'Temporäres Passwort ausgegeben',
        'es': 'Contraseña temporal emitida',
        'fr': 'Mot de passe temporaire émis',
        'ko': '임시 비밀번호 발급',
        'zh': '已發布臨時密碼',
        'zh-TW': '已发布临时密码',
      },
      '登録されたメールアドレスに仮パスワードを送信します。': {
        'en': 'A temporary password will be sent to the registered email address.',
        'it': 'Una password temporanea verrà inviata all\'indirizzo email registrato.',
        'de': 'Ein temporäres Passwort wird an die registrierte E-Mail-Adresse gesendet.',
        'es': 'Se enviará una contraseña temporal a la dirección de correo electrónico registrada.',
        'fr': 'Un mot de passe temporaire sera envoyé à l\'adresse e-mail enregistrée.',
        'ko': '등록된 이메일 주소에 임시 비밀번호를 보냅니다.',
        'zh': '臨時密碼將發送到您註冊的郵箱地址。',
        'zh-TW': '临时密码将发送到您注册的邮箱地址。',
      },
      'メール送信': {
        'en': 'Send email',
        'it': 'Invia e-mail',
        'de': 'E-Mail senden',
        'es': 'Enviar correo electrónico',
        'fr': 'Envoyer un e-mail',
        'ko': '메일 보내기',
        'zh': '傳送電子郵件',
        'zh-TW': '发送电子邮件',
      },
      '購入日': {
        'en': 'Purchase date',
        'it': 'Data di acquisto',
        'de': 'Kaufdatum',
        'es': 'Fecha de compra',
        'fr': 'Date d\'achat',
        'ko': '구매일',
        'zh': '購買日期',
        'zh-TW': '购买日期',
      },
      '履歴': {
        'en': 'History',
        'it': 'storia',
        'de': 'Geschichte',
        'es': 'historia',
        'fr': 'histoire',
        'ko': '히스토리',
        'zh': '歷史',
        'zh-TW': '历史',
      },
      '日付': {
        'en': 'date',
        'it': 'data',
        'de': 'Datum',
        'es': 'fecha',
        'fr': 'date',
        'ko': '날짜',
        'zh': '日期',
        'zh-TW': '日期',
      },
      '商品名': {
        'en': 'Item name',
        'it': 'Nome dell\'articolo',
        'de': 'Artikelname',
        'es': 'Item name',
        'fr': 'Nom de l\'article',
        'ko': '품목 이름',
        'zh': '品項名稱',
        'zh-TW': '项目名称',
      },
      '発送状況': {
        'en': 'Shipping status',
        'it': 'Stato della spedizione',
        'de': 'Versandstatus',
        'es': 'Estado de envío',
        'fr': 'Statut d\'expédition',
        'ko': '배송 상황',
        'zh': '出貨狀態',
        'zh-TW': '发货状态',
      },
      'コイン購入完了': {
        'en': 'Coin purchase completed',
        'it': 'Acquisto monete completato',
        'de': 'Münzkauf abgeschlossen',
        'es': 'Compra de monedas completada',
        'fr': 'Achat de pièces terminé',
        'ko': '코인 구매 완료',
        'zh': '硬幣購買完成',
        'zh-TW': '硬币购买完成',
      },
      '購入失敗': {
        'en': 'Purchase failure',
        'it': 'Fallimento nell\'acquisto',
        'de': 'Kauffehler',
        'es': 'Fallo de compra',
        'fr': 'Échec d\'achat',
        'ko': '구매 실패',
        'zh': '購買失敗',
        'zh-TW': '购买失败',
      },
      'コインのご購入ありがとうございました。': {
        'en': 'Thank you for purchasing coins.',
        'it': 'Grazie per aver acquistato monete.',
        'de': 'Vielen Dank für den Kauf von Münzen.',
        'es': 'Gracias por comprar monedas.',
        'fr': 'Merci d\'avoir acheté des pièces.',
        'ko': '동전을 구입해 주셔서 감사합니다.',
        'zh': '感謝您購買這些紀念幣。',
        'zh-TW': '感谢您购买这些纪念币。',
      },
      '引き続きGTCHAX Onlineをお楽しみください。': {
        'en': 'Please continue to enjoy GTCHAX Online.',
        'it': 'Continuate a utilizzare GTCHAX Online.',
        'de': 'Viel Spaß weiterhin mit GTCHAX Online!',
        'es': 'Por favor, continúen disfrutando de GTCHAX Online.',
        'fr': 'Nous espérons que vous continuerez à apprécier GTCHAX Online.',
        'ko': '계속 GTCHAX Online을 즐길 수 있습니다.',
        'zh': '請繼續暢玩 GTCHAX Online。',
        'zh-TW': '请继续畅玩 GTCHAX Online。',
      },
      '決済に失敗しました。': {
        'en': 'Payment failed.',
        'it': 'Pagamento non riuscito.',
        'de': 'Die Zahlung ist fehlgeschlagen.',
        'es': 'El pago falló.',
        'fr': 'Le paiement a échoué.',
        'ko': '결제에 실패했습니다.',
        'zh': '付款失敗。',
        'zh-TW': '付款失败。',
      },
      '他の決済方法をご利用ください。': {
        'en': 'Please use another payment method.',
        'it': 'Utilizza un altro metodo di pagamento.',
        'de': 'Bitte verwenden Sie eine andere Zahlungsmethode.',
        'es': 'Utilice otro método de pago.',
        'fr': 'Veuillez utiliser un autre mode de paiement.',
        'ko': '다른 결제 방법을 이용하십시오.',
        'zh': '請使用其他付款方式。',
        'zh-TW': '请使用其他付款方式。',
      },
      'HOMEへ戻る': {
        'en': 'Return to HOME',
        'it': 'Ritorno a CASA',
        'de': 'Kehren Sie nach Hause zurück',
        'es': 'Regresar a INICIO',
        'fr': 'Retour à la MAISON',
        'ko': 'HOME으로 돌아가기',
        'zh': '回首頁',
        'zh-TW': '返回首页',
      },
      '名前': {
        'en': 'Name',
        'it': 'Nome',
        'de': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'ko': '이름',
        'zh': '姓名',
        'zh-TW': '姓名',
      },
      '国': {
        'en': 'Country',
        'it': 'Paese',
        'de': 'Land',
        'es': 'País',
        'fr': 'Pays',
        'ko': '국가',
        'zh': '國家',
        'zh-TW': '国家',
      },
      '郵便番号': {
        'en': 'Post code',
        'it': 'Codice postale',
        'de': 'Postleitzahl',
        'es': 'Código postal',
        'fr': 'Code postal',
        'ko': '우편번호',
        'zh': '郵遞區號',
        'zh-TW': '邮政编码',
      },
      '都道府県': {
        'en': 'State',
        'it': 'Regione',
        'de': 'Bundesländer',
        'es': 'Comunidades Autónomas / Provincias',
        'fr': 'Département',
        'ko': '특별시・광역시・도・특별자치도',
        'zh': '直轄市・県・市（省轄市）',
        'zh-TW': '省・直辖市・自治区・特别行政区',
      },
      '市区町村': {
        'en': 'City / Town / Municipality',
        'it': 'Provincia',
        'de': 'Gemeinde / Stadt',
        'es': 'Municipios',
        'fr': 'Commune',
        'ko': '시・군・구',
        'zh': '區・鎮・鄉・市',
        'zh-TW': '区・縣（县）・県級市・郷（乡）・鎮',
      },
      '番地': {
        'en': 'Street address',
        'it': 'Indirizzo stradale',
        'de': 'Straßenadresse',
        'es': 'Dirección postal',
        'fr': 'Adresse de la rue',
        'ko': '번지',
        'zh': '街道地址',
        'zh-TW': '街道地址',
      },
      '建物名': {
        'en': 'Building name',
        'it': 'Nome dell\'edificio',
        'de': 'Gebäudename',
        'es': 'Nombre del edificio',
        'fr': 'Nom du bâtiment',
        'ko': '건물명',
        'zh': '建築物名稱',
        'zh-TW': '建筑物名称',
      },
      '電話番号': {
        'en': 'Telephone number',
        'it': 'Numero di telefono',
        'de': 'Telefonnummer',
        'es': 'Número telefónico',
        'fr': 'Numéro de téléphone',
        'ko': '전화번호',
        'zh': '電話號碼',
        'zh-TW': '电话号码',
      },
      'SMS認証': {
        'en': 'SMS authentication',
        'it': 'Autenticazione tramite SMS',
        'de': 'SMS-Authentifizierung',
        'es': 'Autenticación por SMS',
        'fr': 'Authentification SMS',
        'ko': 'SMS 인증',
        'zh': '簡訊認證',
        'zh-TW': '短信认证',
      },
      'メールアドレス': {
        'en': 'Email address',
        'it': 'Indirizzo e-mail',
        'de': 'E-Mail-Adresse',
        'es': 'Dirección de correo electrónico',
        'fr': 'Adresse email',
        'ko': '이메일 주소',
        'zh': '電子郵件',
        'zh-TW': '电子邮件',
      },
      '友達紹介コード': {
        'en': 'Friend referral code',
        'it': 'Codice di invito amico',
        'de': 'Freundesempfehlungscode',
        'es': 'Código de recomendación de amigos',
        'fr': 'Code de parrainage d\'un ami',
        'ko': '친구 소개 코드',
        'zh': '好友推薦碼',
        'zh-TW': '好友推荐码',
      },
      '個人情報を変更するには、お問い合わせください。': {
        'en': 'To change your personal information, please contact us.',
        'it': 'Per modificare le tue informazioni personali, contattaci.',
        'de': 'Um Ihre persönlichen Daten zu ändern, kontaktieren Sie uns bitte.',
        'es': 'Para cambiar su información personal, por favor contáctenos.',
        'fr': 'Pour modifier vos informations personnelles, veuillez nous contacter.',
        'ko': '개인정보를 변경하려면 문의하시기 바랍니다.',
        'zh': '如需更改您的個人訊息，請聯絡我們。',
        'zh-TW': '如需更改您的个人信息，请联系我们。',
      },
      '初めて配送を選択する際に、この情報を入力できます。': {
        'en': 'You can enter this information the first time you select shipping.',
        'it': 'Puoi inserire queste informazioni la prima volta che selezioni la spedizione.',
        'de': 'Sie können diese Informationen eingeben, wenn Sie zum ersten Mal den Versand auswählen.',
        'es': 'Puede ingresar esta información la primera vez que seleccione envío.',
        'fr': 'Vous pouvez saisir ces informations la première fois que vous sélectionnez l\'expédition.',
        'ko': '처음 배송을 선택할 때 이 정보를 입력할 수 있습니다.',
        'zh': '您可以在首次選擇配送方式時輸入此資訊。',
        'zh-TW': '您可以在首次选择配送方式时输入此信息。',
      },
      'お問い合わせ': {
        'en': 'inquiry',
        'it': 'inchiesta',
        'de': 'Anfrage',
        'es': 'consulta',
        'fr': 'enquête',
        'ko': '문의',
        'zh': '詢問',
        'zh-TW': '询问',
      },
      '変更が完了しました': {
        'en': 'Changes completed',
        'it': 'Modifiche completate',
        'de': 'Änderungen abgeschlossen',
        'es': 'Cambios completados',
        'fr': 'Modifications terminées',
        'ko': '변경이 완료되었습니다.',
        'zh': '修改已完成。',
        'zh-TW': '修改已完成。',
      },
      'SMSコードを送信しますか？': {
        'en': 'Would you like to send an SMS code?',
        'it': 'Vuoi inviare un codice SMS?',
        'de': 'Möchten Sie einen SMS-Code senden?',
        'es': '¿Quieres enviar un código SMS?',
        'fr': 'Souhaitez-vous envoyer un code SMS ?',
        'ko': 'SMS 코드를 보내시겠습니까?',
        'zh': '你想讓我傳簡訊給你驗證碼嗎？',
        'zh-TW': '你想让我给你发短信验证码吗？',
      },
      'お知らせ': {
        'en': 'Notice',
        'it': 'avviso',
        'de': 'beachten',
        'es': 'aviso',
        'fr': 'avis',
        'ko': '공지',
        'zh': '注意',
        'zh-TW': '注意',
      },
      '大切なお知らせ': {
        'en': 'Important notice',
        'it': 'Avviso importante',
        'de': 'Wichtiger Hinweis',
        'es': 'Aviso importante',
        'fr': 'Avis important',
        'ko': '소중한 소식',
        'zh': '重要公告',
        'zh-TW': '重要公告',
      },
      '確認コードを入力': {
        'en': 'Enter verification code',
        'it': 'Inserisci il codice di verifica',
        'de': 'Geben Sie den Bestätigungscode ein',
        'es': 'Ingrese el código de verificación',
        'fr': 'Entrez le code de vérification',
        'ko': '확인 코드 입력',
        'zh': '請輸入驗證碼',
        'zh-TW': '请输入验证码',
      },
      'メールで送信された確認コードを入力してください。': {
        'en': 'Please enter the verification code sent to you via email.',
        'it': 'Inserisci il codice di verifica che ti è stato inviato via email.',
        'de': 'Bitte geben Sie den Bestätigungscode ein, den Sie per E-Mail erhalten haben.',
        'es': 'Ingrese el código de verificación que se le envió por correo electrónico.',
        'fr': 'Veuillez saisir le code de vérification qui vous a été envoyé par e-mail.',
        'ko': '이메일로 전송된 인증 코드를 입력하세요.',
        'zh': '請輸入透過電子郵件傳送給您的驗證碼。',
        'zh-TW': '请输入通过电子邮件发送给您的验证码。',
      },
      '動画を見てコインを獲得': {
        'en': 'Watch videos and get coins',
        'it': 'Guarda i video e ottieni monete',
        'de': 'Schauen Sie sich Videos an und erhalten Sie Münzen',
        'es': 'Mira vídeos y consigue monedas.',
        'fr': 'Regardez des vidéos et obtenez des pièces',
        'ko': '동영상을 보고 Coin을 Get',
        'zh': '觀看影片賺取金幣',
        'zh-TW': '观看视频赚取金币',
      },
      '視聴済み': {
        'en': 'Already watched',
        'it': 'Già guardato',
        'de': 'Schon angeschaut',
        'es': 'Ya visto',
        'fr': 'Déjà regardé',
        'ko': '시청됨',
        'zh': '觀看',
        'zh-TW': '观看',
      },
      '引換履歴&コイン履歴': {
        'en': 'Exchange history & coin history',
        'it': 'Cronologia degli scambi e cronologia delle monete',
        'de': 'Börsengeschichte und Münzgeschichte',
        'es': 'Historial de intercambio e historial de monedas',
        'fr': 'Historique des échanges et historique des pièces',
        'ko': '교환 이력 & 코인 이력',
        'zh': '交易所歷史與硬幣歷史',
        'zh-TW': '交易所历史与硬币历史',
      },
      '取引日': {
        'en': 'trading date',
        'it': 'data di negoziazione',
        'de': 'Handelsdatum',
        'es': 'fecha de negociación',
        'fr': 'date de négociation',
        'ko': '거래일',
        'zh': '交易日期',
        'zh-TW': '交易日期',
      },
      '取引内容': {
        'en': 'Transaction details',
        'it': 'Dettagli della transazione',
        'de': 'Transaktionsdetails',
        'es': 'Detalles de la transacción',
        'fr': 'Détails de la transaction',
        'ko': '거래 내용',
        'zh': '交易詳情',
        'zh-TW': '交易详情',
      },
      '引換・付与コイン': {
        'en': 'Exchange/grant coins',
        'it': 'Scambia/concede monete',
        'de': 'Münzen tauschen/gewähren',
        'es': 'Intercambiar/conceder monedas',
        'fr': 'Échanger/accorder des pièces',
        'ko': '교환·부여 코인',
        'zh': '可兌換/授予的代幣',
        'zh-TW': '可兑换/授予的代币',
      },
      '引換履歴&コイン履歴がありません。': {
        'en': 'There is no exchange history or coin history.',
        'it': 'Non esiste una cronologia degli scambi o delle monete.',
        'de': 'Es gibt keine Börsenhistorie oder Münzhistorie.',
        'es': 'No hay historial de intercambio ni historial de monedas.',
        'fr': 'Il n’y a pas d’historique d’échange ni d’historique de pièces.',
        'ko': '교환 이력 & 코인 이력이 없습니다.',
        'zh': '沒有交易記錄，也沒有硬幣歷史記錄。',
        'zh-TW': '没有交易记录，也没有硬币历史记录。',
      },
      '円': {
        'en': 'yen',
        'it': 'yen',
        'de': 'Yen',
        'es': 'yen',
        'fr': 'yen',
        'ko': 'yen',
        'zh': '圓圈',
        'zh-TW': '圆圈',
      },
      '仮パスワード送信完了': {
        'en': 'Temporary password sent successfully',
        'it': 'Password temporanea inviata con successo',
        'de': 'Temporäres Passwort erfolgreich gesendet',
        'es': 'Contraseña temporal enviada exitosamente',
        'fr': 'Mot de passe temporaire envoyé avec succès',
        'ko': '임시 비밀번호 전송 완료',
        'zh': '臨時密碼已發送。',
        'zh-TW': '临时密码已发送。',
      },
      '登録されたメールアドレスに仮パスワードを送信しました。': {
        'en': 'A temporary password has been sent to your registered email address.',
        'it': 'Una password temporanea è stata inviata al tuo indirizzo email registrato.',
        'de': 'Ein temporäres Passwort wurde an Ihre registrierte E-Mail-Adresse gesendet.',
        'es': 'Se ha enviado una contraseña temporal a su dirección de correo electrónico registrada.',
        'fr': 'Un mot de passe temporaire a été envoyé à votre adresse e-mail enregistrée.',
        'ko': '등록된 이메일 주소에 임시 비밀번호를 보냈습니다.',
        'zh': '臨時密碼已寄至您的註冊信箱。',
        'zh-TW': '临时密码已发送至您的注册邮箱。',
      },
      'メールを確認してください。': {
        'en': 'Please check your email.',
        'it': 'Per favore controlla la tua email.',
        'de': 'Bitte überprüfen Sie Ihre E-Mails.',
        'es': 'Por favor revisa tu correo electrónico.',
        'fr': 'Veuillez vérifier votre courrier électronique.',
        'ko': '이메일을 확인하십시오.',
        'zh': '請查收您的電子郵件。',
        'zh-TW': '请查收您的电子邮件。',
      },
      'ログイン': {
        'en': 'Login',
        'it': 'Login',
        'de': 'Login',
        'es': 'Acceso',
        'fr': 'Se connecter',
        'ko': '로그인',
        'zh': '登入',
        'zh-TW': '登录',
      },
      '日にち': {
        'en': 'Date',
        'it': 'Data',
        'de': 'Datum',
        'es': 'Fecha',
        'fr': 'Date',
        'ko': '하루',
        'zh': '日期',
        'zh-TW': '日期',
      },
      'コイン': {
        'en': 'coin',
        'it': 'coniare',
        'de': 'Münze',
        'es': 'acuñar',
        'fr': 'pièce de monnaie',
        'ko': '동전',
        'zh': '硬幣',
        'zh-TW': '硬币',
      },
      '金額': {
        'en': 'Price',
        'it': 'Prezzo',
        'de': 'Preis',
        'es': 'Precio',
        'fr': 'Prix',
        'ko': '가격',
        'zh': '價格',
        'zh-TW': '价格',
      },
      '備考': {
        'en': 'remarks',
        'it': 'osservazioni',
        'de': 'Bemerkungen',
        'es': 'comentarios',
        'fr': 'remarques',
        'ko': '비고',
        'zh': '評論',
        'zh-TW': '评论',
      },
      '次へ': {
        'en': 'to the next',
        'it': 'al successivo',
        'de': 'zum nächsten',
        'es': 'al siguiente',
        'fr': 'au prochain',
        'ko': '다음',
        'zh': '到下一個',
        'zh-TW': '到下一个',
      },
      '配送コード': {
        'en': 'shipping code',
        'it': 'codice di spedizione',
        'de': 'Versandcode',
        'es': 'código de envío',
        'fr': 'code d\'expédition',
        'ko': '배송 코드',
        'zh': '運費代碼',
        'zh-TW': '运费代码',
      },
      '一覧に戻る': {
        'en': 'Return to list',
        'it': 'Ritorna all\'elenco',
        'de': 'Zurück zur Liste',
        'es': 'Volver a la lista',
        'fr': 'Retour à la liste',
        'ko': '목록으로 돌아가기',
        'zh': '返回列表',
        'zh-TW': '返回列表',
      },
      'ラインナップ': {
        'en': 'Lineup',
        'it': 'Formazione',
        'de': 'Aufstellung',
        'es': 'Lineup',
        'fr': 'Composition',
        'ko': '상품 라인업',
        'zh': '產品陣容',
        'zh-TW': '产品阵容',
      },
      '販売開始まで': {
        'en': 'Until sales start',
        'it': 'Fino all\'inizio delle vendite',
        'de': 'Bis zum Verkaufsstart',
        'es': 'Hasta que comiencen las rebajas',
        'fr': 'Jusqu\'au début des soldes',
        'ko': '판매 개시까지',
        'zh': '直到銷售開始',
        'zh-TW': '直到销售开始',
      },
      '新しいパスワード': {
        'en': 'New Password',
        'it': 'Nuova parola d\'ordine',
        'de': 'Neues Passwort',
        'es': 'Nueva contraseña',
        'fr': 'Nouveau mot de passe',
        'ko': '새로운 비밀번호',
        'zh': '新密碼',
        'zh-TW': '新密码',
      },
      '半角英数字15文字以内': {
        'en': 'Up to 15 half-width alphanumeric characters',
        'it': 'Fino a 15 caratteri alfanumerici a mezza larghezza',
        'de': 'Bis zu 15 alphanumerische Zeichen halber Breite',
        'es': 'Hasta 15 caracteres alfanuméricos de ancho medio',
        'fr': 'Jusqu\'à 15 caractères alphanumériques demi-chasse',
        'ko': '반각 영숫자 15자 이내',
        'zh': '最多 15 個字母數字字符',
        'zh-TW': '最多 15 个字母数字字符',
      },
      '新しいパスワード確認用': {
        'en': 'To confirm new password',
        'it': 'Per confermare la nuova password',
        'de': 'Um das neue Passwort zu bestätigen',
        'es': 'Para confirmar la nueva contraseña',
        'fr': 'Pour confirmer le nouveau mot de passe',
        'ko': '새로운 비밀번호 확인용',
        'zh': '新密碼確認',
        'zh-TW': '新密码确认',
      },
      '変更する': {
        'en': 'Change',
        'it': 'Modifica',
        'de': 'Ändern',
        'es': 'Cambiar',
        'fr': 'Changement',
        'ko': '변경하다',
        'zh': '改變',
        'zh-TW': '改变',
      },
      '発送': {
        'en': 'Shipping',
        'it': 'Spedizione',
        'de': 'Versand',
        'es': 'Envío',
        'fr': 'Expédition',
        'ko': '발송',
        'zh': '船運',
        'zh-TW': '船运',
      },
      '発送のみ': {
        'en': 'Shipping only',
        'it': 'Solo spedizione',
        'de': 'Versand nur',
        'es': 'Solo envíos',
        'fr': 'Expédition uniquement',
        'ko': '배송만',
        'zh': '僅限配送',
        'zh-TW': '仅限配送',
      },
      'コインのみ': {
        'en': 'Coin only',
        'it': 'Solo moneta',
        'de': 'Nur Münze',
        'es': 'Solo moneda',
        'fr': 'Pièce seulement',
        'ko': '코인 전용',
        'zh': '僅限硬幣',
        'zh-TW': '仅限硬币',
      },
      'Xmarketへ出品': {
        'en': 'Listing on Xmarket',
        'it': 'Annuncio su Xmarket',
        'de': 'Eintrag auf Xmarket',
        'es': 'Listado en Xmarket',
        'fr': 'Annonce sur Xmarket',
        'ko': 'Xmarket에 출품',
        'zh': 'Xmarket上的商品列表',
        'zh-TW': 'Xmarket上的商品列表',
      },
      '登録': {
        'en': 'Registration',
        'it': 'Registrazione',
        'de': 'Anmeldung',
        'es': 'Registro',
        'fr': 'Inscription',
        'ko': '등록',
        'zh': '登記',
        'zh-TW': '登记',
      },
      'コインへ': {
        'en': 'To coins',
        'it': 'Per le monete',
        'de': 'Zu Münzen',
        'es': 'A monedas',
        'fr': 'Aux pièces de monnaie',
        'ko': '동전으로',
        'zh': '硬幣',
        'zh-TW': '硬币',
      },
      'Xmarketへ販売': {
        'en': 'Sell ​​to Xmarket',
        'it': 'Vendi su Xmarket',
        'de': 'Verkauf an Xmarket',
        'es': 'Vender a Xmarket',
        'fr': 'Vendre sur Xmarket',
        'ko': 'Xmarket에 판매',
        'zh': '賣給 Xmarket',
        'zh-TW': '卖给 Xmarket',
      },
      '1タップで「発送依頼」、2タップで「Xmarketへ出品」となります。': {
        'en': 'One tap will initiate a shipping request, and two taps will initiate a listing on Xmarket.',
        'it': 'Un singolo tocco avvierà una richiesta di spedizione, mentre due tocchi avvieranno la pubblicazione dell\'annuncio su Xmarket.',
        'de': 'Einmaliges Tippen löst eine Versandanfrage aus, zweimaliges Tippen startet ein Angebot auf Xmarket.',
        'es': 'Un toque iniciará una solicitud de envío y dos toques iniciarán la publicación de un anuncio en Xmarket.',
        'fr': 'Un clic lancera une demande d\'expédition, et deux clics lanceront une annonce sur Xmarket.',
        'ko': '1 탭으로 「발송 의뢰」, 2 탭으로 「Xmarket에 출품」이 됩니다.',
        'zh': '點擊一次即可發起出貨請求，點擊兩次即可在 Xmarket 上發起商品上架。',
        'zh-TW': '点击一次即可发起发货请求，点击两次即可在 Xmarket 上发起商品上架。',
      },
      'コインへの合計還元数': {
        'en': 'Total number of returns to Coin',
        'it': 'Numero totale di resi su Coin',
        'de': 'Gesamtzahl der Rückgaben an Coin',
        'es': 'Número total de devoluciones a Coin',
        'fr': 'Nombre total de retours sur Coin',
        'ko': 'Coin에 대한 총 환원 수',
        'zh': '已兌換硬幣總數',
        'zh-TW': '已兑换硬币总数',
      },
      'Xmarketへ出品ボタンが押された商品は、出品リストに表示されます。そこで販売価格を決定してXmarketへ出品してください。': {
        'en': 'Products for which the "List on Xmarket" button has been pressed will appear in the listing list. There, you can determine the selling price and list the item on Xmarket.',
        'it': 'I prodotti per i quali è stato premuto il pulsante "Metti in vendita su Xmarket" appariranno nell\'elenco degli articoli in vendita. Lì potrai impostare il prezzo di vendita e mettere in vendita l\'articolo su Xmarket.',
        'de': 'Produkte, bei denen der Button „Auf Xmarket anbieten“ gedrückt wurde, erscheinen in der Angebotsliste. Dort können Sie den Verkaufspreis festlegen und den Artikel auf Xmarket einstellen.',
        'es': 'Los productos para los que se haya pulsado el botón "Publicar en Xmarket" aparecerán en la lista de productos. Allí podrá determinar el precio de venta y publicar el artículo en Xmarket.',
        'fr': 'Les produits pour lesquels vous avez cliqué sur le bouton « Mettre en vente sur Xmarket » apparaîtront dans la liste des annonces. Vous pourrez alors fixer le prix de vente et mettre l\'article en vente sur Xmarket.',
        'ko': 'Xmarket에 전시 버튼이 눌러진 상품은 전시 리스트에 표시됩니다. 그래서 판매 가격을 결정하고 Xmarket에 출품하십시오.',
        'zh': '已點擊「在 Xmarket 上架」按鈕的商品將會出現在商品清單中。您可以在清單中設定售價並將商品發佈到 Xmarket。',
        'zh-TW': '已点击“在 Xmarket 上架”按钮的商品将出现在商品列表中。您可以在列表中设置售价并将商品发布到 Xmarket。',
      },
      '最終確認へ': {
        'en': 'Go to final confirmation',
        'it': 'Vai alla conferma finale',
        'de': 'Gehen Sie zur endgültigen Bestätigung',
        'es': 'Ir a la confirmación final',
        'fr': 'Aller à la confirmation finale',
        'ko': '최종 확인에',
        'zh': '進入最終確認階段',
        'zh-TW': '进入最终确认阶段',
      },
      '支払方法を選択': {
        'en': 'Select payment method',
        'it': 'Seleziona il metodo di pagamento',
        'de': 'Zahlungsart auswählen',
        'es': 'Selecciona el método de pago',
        'fr': 'Sélectionnez le mode de paiement',
        'ko': '지불 방법 선택',
        'zh': '選擇付款方式',
        'zh-TW': '选择付款方式',
      },
      '有効期限': {
        'en': 'date of expiry',
        'it': 'Data di scadenza',
        'de': 'Ablaufdatum',
        'es': 'fecha de vencimiento',
        'fr': 'Date d\'expiration',
        'ko': '만료일',
        'zh': '到期日期',
        'zh-TW': '到期日期',
      },
      'セキュリティコード': {
        'en': 'security code',
        'it': 'codice di sicurezza',
        'de': 'Sicherheitscode',
        'es': 'codigo de seguridad',
        'fr': 'code de sécurité',
        'ko': '보안 코드',
        'zh': '安全碼',
        'zh-TW': '安全码',
      },
      '住所1': {
        'en': 'Address Line 1',
        'it': 'Indirizzo Linea 1',
        'de': 'Adresszeile 1',
        'es': 'Dirección Línea 1',
        'fr': 'Adresse Ligne 1',
        'ko': '주소 1',
        'zh': '地址第一行',
        'zh-TW': '地址第一行',
      },
      '住所2': {
        'en': 'Address 2',
        'it': 'Indirizzo 2',
        'de': 'Adresse 2',
        'es': 'Dirección 2',
        'fr': 'Adresse 2',
        'ko': '주소 2',
        'zh': '地址 2',
        'zh-TW': '地址 2',
      },
      '会員登録': {
        'en': 'Member registration',
        'it': 'Registrazione del membro',
        'de': 'Mitgliederregistrierung',
        'es': 'Registro de miembros',
        'fr': 'Inscription des membres',
        'ko': '회원등록',
        'zh': '會員註冊',
        'zh-TW': '会员注册',
      },
      '枚セット': {
        'en': 'set of sheets',
        'it': 'set di lenzuola',
        'de': 'Satz Blätter',
        'es': 'juego de sábanas',
        'fr': 'ensemble de feuilles',
        'ko': '매 세트',
        'zh': '一套 1',
        'zh-TW': '一套 1',
      },
      '申し込みへ': {
        'en': 'Go to application',
        'it': 'Vai all\'applicazione',
        'de': 'Gehen Sie zur Bewerbung',
        'es': 'Ir a la aplicación',
        'fr': 'Aller à l\'application',
        'ko': '신청에',
        'zh': '立即申請',
        'zh-TW': '立即申请',
      },
      '会員ID': {
        'en': 'Member ID',
        'it': 'ID membro',
        'de': 'Mitglieds-ID',
        'es': 'ID de miembro',
        'fr': 'Identifiant de membre',
        'ko': '회원 ID',
        'zh': '會員編號',
        'zh-TW': '会员编号',
      },
      '会員ランク': {
        'en': 'Membership Rank',
        'it': 'Grado di appartenenza',
        'de': 'Mitgliedschaftsrang',
        'es': 'Rango de membresía',
        'fr': 'Rang de membre',
        'ko': '회원 순위',
        'zh': '會員等級',
        'zh-TW': '会员等级',
      },
      '次のランクまで': {
        'en': 'Up to next rank',
        'it': 'Fino al grado successivo',
        'de': 'Bis zum nächsten Rang',
        'es': 'Hasta el siguiente rango',
        'fr': 'Jusqu\'au rang suivant',
        'ko': '다음 순위까지',
        'zh': '升至下一級',
        'zh-TW': '升至下一级',
      },
      '※ランクに応じた各種特典が受けられます': {
        'en': '*Bonuses based on rank',
        'it': '*Bonus basati sul grado',
        'de': '*Rangabhängige Boni',
        'es': '*Bonificaciones basadas en el rango',
        'fr': '*Bonus basés sur le rang',
        'ko': '*등급에 따른 보너스',
        'zh': '*基於職級的獎金',
        'zh-TW': '*基于等级的奖励',
      },
      '詳細': {
        'en': 'Detail',
        'it': 'dettaglio',
        'de': 'Detail',
        'es': 'detalle',
        'fr': 'détail',
        'ko': '상세',
        'zh': '細節',
        'zh-TW': '细节',
      },
      '友達紹介': {
        'en': 'Refer-a-friend',
        'it': 'Invita un amico',
        'de': 'Einen Freund empfehlen',
        'es': 'Recomendar a un amigo',
        'fr': 'Parrainer un ami',
        'ko': '친구 소개',
        'zh': '推薦朋友',
        'zh-TW': '推荐朋友',
      },
      'あと': {
        'en': 'After',
        'it': 'Dopo',
        'de': 'Nach',
        'es': 'Después',
        'fr': 'Après',
        'ko': '나중에',
        'zh': '後',
        'zh-TW': '后',
      },
      '人紹介可能': {
        'en': ' friends you can refer',
        'it': ' Può presentare le persone',
        'de': ' Kann Leute vorstellen',
        'es': ' Puede presentar personas',
        'fr': ' Peut présenter des gens',
        'ko': '사람 소개 가능',
        'zh': '可以介紹人',
        'zh-TW': '可以介绍人',
      },
      '紹介コード': {
        'en': 'Referral code',
        'it': 'Codice di riferimento',
        'de': 'Empfehlungscode',
        'es': 'Código de referencia',
        'fr': 'Code de parrainage',
        'ko': '추천 코드',
        'zh': '推薦碼',
        'zh-TW': '推荐码',
      },
      'コピー': {
        'en': 'Copy',
        'it': 'Copia',
        'de': 'Kopie',
        'es': 'Copiar',
        'fr': 'Copie',
        'ko': '복사',
        'zh': '複製',
        'zh-TW': '复制',
      },
      'あなたも友達も 500コインがもらえる': {
        'en': 'You and your friend will both receive 500 coins.',
        'it': 'Tu e il tuo amico riceverete entrambi 500 monete.',
        'de': 'Du und dein Freund erhaltet beide 500 Münzen.',
        'es': 'Tú y tu amigo recibiréis 500 monedas cada uno.',
        'fr': 'Vous et votre ami recevrez tous deux 500 pièces.',
        'ko': '당신과 친구 모두 500 동전을받을 수 있습니다.',
        'zh': '你和你的朋友都將獲得500枚金幣。',
        'zh-TW': '你和你的朋友都将获得500枚金币。',
      },
      '友達に会員登録をしてもらうとき、': {
        'en': 'Your friends has to enter your code',
        'it': 'I tuoi amici devono inserire il tuo codice',
        'de': 'Deine Freunde müssen deinen Code eingeben',
        'es': 'Tus amigos tienen que introducir tu código.',
        'fr': 'Vos amis doivent entrer votre code',
        'ko': '친구가 귀하의 코드를 입력해야 합니다.',
        'zh': '您的朋友必須輸入您的代碼',
        'zh-TW': '您的朋友必须输入您的代码',
      },
      'あなたのコードを入力してもらう': {
        'en': 'when he or she registers as a member and then',
        'it': 'quando lui o lei si registra come membro e poi',
        'de': 'wenn er oder sie sich als Mitglied registriert und dann',
        'es': 'cuando se registra como miembro y luego',
        'fr': 'lorsqu\'il s\'inscrit en tant que membre et ensuite',
        'ko': '회원으로 등록한 후',
        'zh': '當他或她註冊為會員時，然後',
        'zh-TW': '当他或她注册为会员时，然后',
      },
      'その友達が': {
        'en': 'That friend completes',
        'it': 'Quell\'amico completa',
        'de': 'Dieser Freund ist fertig',
        'es': 'ese amigo completa',
        'fr': 'Cet ami termine',
        'ko': '그 친구가 완성했어요',
        'zh': '這位朋友完成了',
        'zh-TW': '这位朋友完成了',
      },
      'コインの購入': {
        'en': 'purchasing Coins',
        'it': 'Acquisto di monete',
        'de': 'Münzen kaufen',
        'es': 'Comprar monedas',
        'fr': 'Acheter des pièces',
        'ko': '코인 구매',
        'zh': '購買金幣',
        'zh-TW': '购买金币',
      },
      'クーポン': {
        'en': 'Coupon',
        'it': 'Buono',
        'de': 'Coupon',
        'es': 'Cupón',
        'fr': 'Coupon',
        'ko': '쿠폰',
        'zh': '優惠券',
        'zh-TW': '优惠券',
      },
      'お知らせなどで配布': {
        'en': 'Distributed via Instagram and Notice',
        'it': 'Distribuito tramite Instagram e Notice',
        'de': 'Über Instagram und Notice verteilt',
        'es': 'Distribuerad via Instagram och Notice',
        'fr': 'Distribué via Instagram et Notice',
        'ko': '인스타그램 및 공지를 통해 배포됨',
        'zh': '通過 Instagram 和 Notice 分發',
        'zh-TW': '通过 Instagram 和 Notice 分发',
      },
      'クーポンコードを入力してください': {
        'en': 'Coupon code',
        'it': 'Codice coupon',
        'de': 'Gutscheincode',
        'es': 'Kupongkod',
        'fr': 'Code promo',
        'ko': '쿠폰 코드',
        'zh': '優惠代碼',
        'zh-TW': '优惠码',
      },
      '適用': {
        'en': 'Apply',
        'it': 'Applica',
        'de': 'Anwenden',
        'es': 'Ansök',
        'fr': 'Appliquer',
        'ko': '적용',
        'zh': '申請',
        'zh-TW': '申请',
      },
      '動画を見てコインをもらう': {
        'en': 'Watch videos and get coins',
        'it': 'Guarda i video e ottieni monete',
        'de': 'Schauen Sie sich Videos an und erhalten Sie Münzen',
        'es': 'Mira vídeos y consigue monedas.',
        'fr': 'Regardez des vidéos et obtenez des pièces',
        'ko': '동영상을 보고 코인을 받으세요',
        'zh': '觀看影片即可獲得金幣',
        'zh-TW': '观看视频即可获得金币',
      },
      'Xmarket 出品リスト': {
        'en': 'My Xmarket list',
        'it': 'La mia lista Xmarket',
        'de': 'Meine Xmarket-Liste',
        'es': 'Mi lista de Xmarket',
        'fr': 'Ma liste Xmarket',
        'ko': '내 Xmarket 목록',
        'zh': '我的 Xmarket 列表',
        'zh-TW': '我的 Xmarket 列表',
      },
      'Appleとの連携に失敗しました。もう一度お試しください。': {
        'en': 'Failed to cooperate with Apple. Please try again.',
        'it': 'Impossibile collaborare con Apple. Per favore riprova.',
        'de': 'Die Zusammenarbeit mit Apple ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
        'es': 'No se pudo cooperar con Apple. Por favor inténtalo de nuevo.',
        'fr': 'Échec de la coopération avec Apple. Veuillez réessayer.',
        'ko': 'Apple과의 협력에 실패했습니다. 다시 시도해 주세요.',
        'zh': '與蘋果設備的連線失敗，請重試。',
        'zh-TW': '与苹果设备的连接失败，请重试。',
      },
      '以下のURLから当サイト情報との紐付けを削除し再度お試し下さい。': {
        'en': 'Please remove the link to this site information from the URL below and try again.',
        'it': 'Rimuovi il collegamento alle informazioni su questo sito dall\'URL riportato di seguito e riprova.',
        'de': 'Bitte entfernen Sie den Link zu diesen Website-Informationen von der unten stehenden URL und versuchen Sie es erneut.',
        'es': 'Elimine el enlace a la información de este sitio de la siguiente URL e inténtelo de nuevo.',
        'fr': 'Veuillez supprimer le lien vers les informations de ce site de l\'URL ci-dessous et réessayer.',
        'ko': '아래 URL에서 사이트 정보와의 연결을 삭제하고 다시 시도하십시오.',
        'zh': '請從以下網址中移除指向我們網站的鏈接，然後重試。',
        'zh-TW': '请从以下网址中移除指向我们网站的链接，然后重试。',
      },
      'このアカウントは既に登録されています。ログインしてお楽しみください。': {
        'en': 'This account is already registered. Please log in and enjoy.',
        'it': 'Questo account è già registrato. Per favore accedi e divertiti.',
        'de': 'Dieses Konto ist bereits registriert. Bitte loggen Sie sich ein und genießen Sie es.',
        'es': 'Esta cuenta ya está registrada. Por favor inicia sesión y disfruta.',
        'fr': 'Ce compte est déjà enregistré. Veuillez vous connecter et profiter.',
        'ko': '이 계정은 이미 등록되어 있습니다.',
        'zh': '此帳號已註冊。請登入以查看內容。',
        'zh-TW': '此账号已注册。请登录以查看内容。',
      },
      'メールアドレスまたはパスワードが一致しません。': {
        'en': 'Email addresses or passwords do not match.',
        'it': 'Gli indirizzi email o le password non corrispondono.',
        'de': 'E-Mail-Adressen oder Passwörter stimmen nicht überein.',
        'es': 'Las direcciones de correo electrónico o las contraseñas no coinciden.',
        'fr': 'Les adresses e-mail ou les mots de passe ne correspondent pas.',
        'ko': '이메일 주소 또는 비밀번호가 일치하지 않습니다.',
        'zh': '電子郵件地址或密碼不符。',
        'zh-TW': '电子邮件地址或密码不匹配。',
      },
      '利用規約': {
        'en': 'Terms of service',
        'it': 'Termini di servizio',
        'de': 'Nutzungsbedingungen',
        'es': 'Términos de servicio',
        'fr': 'Conditions de service',
        'ko': '이용 약관',
        'zh': '服務條款',
        'zh-TW': '服务条款',
      },
      'に同意し、会員登録をします': {
        'en': 'I agree and register as a member.',
        'it': 'Accetto e mi registro come membro.',
        'de': 'Ich stimme zu und melde mich als Mitglied an.',
        'es': 'Acepto y me registro como miembro.',
        'fr': 'J\'accepte et m\'inscris en tant que membre.',
        'ko': '동의하고 회원 등록',
        'zh': '我同意，並將註冊成為會員。',
        'zh-TW': '我同意，并将注册成为会员。',
      },
      '住所は、「発送依頼」をされた際にご登録いただきます。': {
        'en': 'Please enter your address when you make your first shipping request.',
        'it': 'Inserisci il tuo indirizzo quando effettui la prima richiesta di spedizione.',
        'de': 'Bitte geben Sie bei Ihrer ersten Versandanfrage Ihre Adresse ein.',
        'es': 'Ingrese su dirección cuando realice su primera solicitud de envío.',
        'fr': 'Veuillez saisir votre adresse lors de votre première demande d\'expédition.',
        'ko': '주소는, 최초의 「발송 의뢰」를 되었을 때에 입력해 주십니다.',
        'zh': '當您提交「出貨請求」時，您的地址將被登記。',
        'zh-TW': '当您提交“发货请求”时，您的地址将被登记。',
      },
      '利用規約に同意してください': {
        'en': 'Please agree to the terms of use',
        'it': 'Si prega di accettare i termini di utilizzo',
        'de': 'Bitte stimmen Sie den Nutzungsbedingungen zu',
        'es': 'Por favor acepta los términos de uso.',
        'fr': 'Veuillez accepter les conditions d\'utilisation',
        'ko': '이용 약관에 동의하십시오.',
        'zh': '請同意服務條款。',
        'zh-TW': '请同意服务条款。',
      },
      '会社概要': {
        'en': 'Company Profile',
        'it': 'Profilo Aziendale',
        'de': 'Unternehmensprofil',
        'es': 'Perfil de la empresa',
        'fr': 'Profil de l\'entreprise',
        'ko': '회사개요',
        'zh': '公司簡介',
        'zh-TW': '公司简介',
      },
      '資金決済法': {
        'en': 'Fund settlement law',
        'it': 'Legge sulla liquidazione dei fondi',
        'de': 'Fondsabwicklungsrecht',
        'es': 'Ley de liquidación de fondos',
        'fr': 'Loi sur la liquidation des fonds',
        'ko': '자금결제법',
        'zh': '支付服務法案',
        'zh-TW': '支付服务法案',
      },
      '特定商取引法': {
        'en': 'Specified Commercial Transactions Law',
        'it': 'Legge sulle transazioni commerciali specificate',
        'de': 'Spezifiziertes Handelsverkehrsrecht',
        'es': 'Ley de transacciones comerciales específicas',
        'fr': 'Loi sur les transactions commerciales spécifiées',
        'ko': '특정 상거래법',
        'zh': '特定商業交易法',
        'zh-TW': '特定商业交易法',
      },
      'ご利用ガイド': {
        'en': 'User guide',
        'it': 'Guida per l\'utente',
        'de': 'Benutzerhandbuch',
        'es': 'guía de usuario',
        'fr': 'Guide d\'utilisation',
        'ko': '이용 가이드',
        'zh': '使用者指南',
        'zh-TW': '用户指南',
      },
      '個人情報保護ポリシー': {
        'en': 'Privacy policy',
        'it': 'Politica sulla riservatezza',
        'de': 'Datenschutzrichtlinie',
        'es': 'Política de privacidad',
        'fr': 'Politique de confidentialité',
        'ko': '개인 정보 보호 정책',
        'zh': '隱私權政策',
        'zh-TW': '隐私政策',
      },
      '申し込み': {
        'en': 'application',
        'it': 'applicazione',
        'de': 'Anwendung',
        'es': 'solicitud',
        'fr': 'application',
        'ko': '신청',
        'zh': '應用',
        'zh-TW': '应用',
      },
      'マイページ': {
        'en': 'My page',
        'it': 'La mia pagina',
        'de': 'Meine Seite',
        'es': 'mi pagina',
        'fr': 'Ma page',
        'ko': '내 페이지',
        'zh': '我的頁面',
        'zh-TW': '我的页面',
      },
      'コイン履歴': {
        'en': 'Coin history',
        'it': 'storia della moneta',
        'de': 'Münzgeschichte',
        'es': 'historia de la moneda',
        'fr': 'histoire des pièces de monnaie',
        'ko': '동전 이력',
        'zh': '硬幣歷史',
        'zh-TW': '硬币历史',
      },
      '商品購入履歴': {
        'en': 'Product purchase history',
        'it': 'Cronologia degli acquisti del prodotto',
        'de': 'Produktkaufhistorie',
        'es': 'Historial de compra de productos',
        'fr': 'Historique des achats de produits',
        'ko': '상품 구매 이력',
        'zh': '產品購買歷史',
        'zh-TW': '产品购买历史',
      },
      'ログアウト': {
        'en': 'Logout',
        'it': 'Esci',
        'de': 'Abmelden',
        'es': 'Cerrar sesión',
        'fr': 'Déconnexion',
        'ko': '로그아웃',
        'zh': '登出登入',
        'zh-TW': '退出登录',
      },
      'コイン利用規約': {
        'en': 'Coin Terms of Use',
        'it': 'Termini di utilizzo della moneta',
        'de': 'Nutzungsbedingungen der Kryptowährung',
        'es': 'Condiciones de uso de Coin',
        'fr': 'Conditions d\'utilisation de Coin',
        'ko': '코인 이용 약관',
        'zh': '硬幣使用條款',
        'zh-TW': '硬币使用条款',
      },
      '資金決済法に基づく表記': {
        'en': 'Description based on the Payment Services Act',
        'it': 'Descrizione basata sulla legge sui servizi di pagamento',
        'de': 'Beschreibung basierend auf dem Zahlungsdienstegesetz',
        'es': 'Descripción basada en la Ley de Servicios de Pago',
        'fr': 'Description basée sur la loi sur les services de paiement',
        'ko': '자금결제법에 따른 표기',
        'zh': '根據《支付服務法》進行資訊揭露',
        'zh-TW': '根据《支付服务法》进行信息披露',
      },
      '特定商取引法に基づく表記': {
        'en': 'Description based on Specified Commercial Transactions Law',
        'it': 'Descrizione basata sulla legge sulle transazioni commerciali specifiche',
        'de': 'Beschreibung basierend auf dem Gesetz über bestimmte Handelstransaktionen',
        'es': 'Descripción basada en la Ley de Transacciones Comerciales Específicas',
        'fr': 'Description basée sur la loi sur les transactions commerciales spécifiées',
        'ko': '특정 상거래법에 근거한 표기',
        'zh': '根據《特定商業交易法》進行揭露',
        'zh-TW': '根据《特定商业交易法》进行披露',
      },
      '会員登録 / ログイン': {
        'en': 'Register / Log in',
        'it': 'Registrati / Accedi',
        'de': 'Registrieren / Anmelden',
        'es': 'Registrarse / Iniciar sesión',
        'fr': 'S\'inscrire / Se connecter',
        'ko': '등록 / 로그인',
        'zh': '註冊/登入',
        'zh-TW': '注册/登录',
      },
      'ガチャ': {
        'en': 'Gacha',
        'it': 'Gacha',
        'de': 'Gacha',
        'es': 'Gacha',
        'fr': 'Gacha',
        'ko': '가챠',
        'zh': '扭蛋',
        'zh-TW': '扭蛋',
      },
      '買取': {
        'en': 'Sold',
        'it': 'Venduto',
        'de': 'Verkauft',
        'es': 'Vendido',
        'fr': 'Vendu',
        'ko': '판매',
        'zh': '賣',
        'zh-TW': '卖',
      },
      '発送待ち': {
        'en': 'Waiting for shipment',
        'it': 'In attesa di spedizione',
        'de': 'Warten auf Versand',
        'es': 'Esperando envío',
        'fr': 'En attente d\'expédition',
        'ko': '배송 대기',
        'zh': '等待發貨',
        'zh-TW': '等待发货',
      },
      '身分証(表)を設定してください': {
        'en': 'Please set your ID (front)',
        'it': 'Per favore imposta il tuo ID (fronte)',
        'de': 'Bitte geben Sie Ihren Ausweis ein (vorne)',
        'es': 'Por favor configura tu ID (frente)',
        'fr': 'Veuillez définir votre identifiant (recto)',
        'ko': '신분증(표)을 설정해 주세요',
        'zh': '請填寫您的身分證件（正面）。',
        'zh-TW': '请填写您的身份证件（正面）。',
      },
      '身分証(裏)を設定してください': {
        'en': 'Please set your ID (back)',
        'it': 'Per favore imposta il tuo ID (indietro)',
        'de': 'Bitte setzen Sie Ihre ID (zurück)',
        'es': 'Por favor configura tu ID (atrás)',
        'fr': 'Veuillez définir votre identifiant (retour)',
        'ko': '신분증(뒤)을 설정해 주세요',
        'zh': '請將身分證背面放好。',
        'zh-TW': '请将身份证背面放好。',
      },
      'お申し込みありがとうございます。お品物が到着次第、ご連絡いたします。引き続きどうぞよろしくお願いいたします。': {
        'en': 'Thank you for your application. We will contact you as soon as the item arrives. Thank you for your continued support.',
        'it': 'Grazie per la tua candidatura Ti contatteremo non appena arriverà l\'articolo. Grazie per il vostro continuo supporto.',
        'de': 'Vielen Dank für Ihre Bewerbung. Wir werden Sie kontaktieren, sobald der Artikel bei Ihnen eintrifft. Vielen Dank für Ihre anhaltende Unterstützung.',
        'es': 'Gracias por tu solicitud. Nos comunicaremos con usted tan pronto como llegue el artículo. Gracias por su continuo apoyo.',
        'fr': 'Merci pour votre candidature. Nous vous contacterons dès l\'arrivée de l\'article. Merci pour votre soutien continu.',
        'ko': '신청해 주셔서 감사합니다. 물건이 도착하는 대로 연락 드리겠습니다.',
        'zh': '感謝您的訂購。商品到貨後，我們會立即與您聯繫。期待繼續為您服務。',
        'zh-TW': '感谢您的订购。商品到货后，我们会立即与您联系。期待继续为您服务。',
      },
      '価格帯': {
        'en': 'price range',
        'it': 'fascia di prezzo',
        'de': 'Preisklasse',
        'es': 'gama de precios',
        'fr': 'fourchette de prix',
        'ko': '가격대',
        'zh': '價格範圍',
        'zh-TW': '价格范围',
      },
      'タイトル': {
        'en': 'title',
        'it': 'titolo',
        'de': 'Titel',
        'es': 'título',
        'fr': 'titre',
        'ko': '제목',
        'zh': '標題',
        'zh-TW': '标题',
      },
      '検索結果': {
        'en': 'Search results',
        'it': 'Risultati della ricerca',
        'de': 'Suchergebnisse',
        'es': 'Resultados de la búsqueda',
        'fr': 'Résultats de la recherche',
        'ko': '검색결과',
        'zh': '搜尋結果',
        'zh-TW': '搜索结果',
      },
      '手順確認': {
        'en': 'Check procedure',
        'it': 'Procedura di controllo',
        'de': 'Vorgehensweise prüfen',
        'es': 'Procedimiento de verificación',
        'fr': 'Procédure de vérification',
        'ko': '절차 확인',
        'zh': '程式確認',
        'zh-TW': '程序确认',
      },
      '買取申込': {
        'en': 'Purchase application',
        'it': 'Applicazione di acquisto',
        'de': 'Kaufantrag',
        'es': 'Solicitud de compra',
        'fr': 'Demande d\'achat',
        'ko': '구매 신청',
        'zh': '購買申請',
        'zh-TW': '购买申请',
      },
      '買取詳細履歴': {
        'en': 'Purchase details history',
        'it': 'Cronologia dei dettagli dell\'acquisto',
        'de': 'Verlauf der Kaufdetails',
        'es': 'Historial de detalles de compra',
        'fr': 'Historique des détails d\'achat',
        'ko': '구매 상세 내역',
        'zh': '購買歷史',
        'zh-TW': '购买历史',
      },
      '追跡番号': {
        'en': 'tracking number',
        'it': 'numero di identificazione',
        'de': 'Tracking-Nummer',
        'es': 'el número de rastreo',
        'fr': 'numéro de suivi',
        'ko': '추적 번호',
        'zh': '追蹤號碼',
        'zh-TW': '追踪号码',
      },
      '発送業者': {
        'en': 'Shipping method',
        'it': 'Metodo di spedizione',
        'de': 'Versandart',
        'es': 'Método de envío',
        'fr': 'Méthode d\'expédition',
        'ko': '배송 방법',
        'zh': '航運公司',
        'zh-TW': '航运公司',
      },
      '発送枚数': {
        'en': 'Number of shipments',
        'it': 'Numero di spedizioni',
        'de': 'Anzahl der Sendungen',
        'es': 'Número de envíos',
        'fr': 'Nombre d\'envois',
        'ko': '배송 수',
        'zh': '待出貨商品數量',
        'zh-TW': '待发货商品数量',
      },
      '受け取り方法': {
        'en': 'How to receive',
        'it': 'Come ricevere',
        'de': 'Wie man erhält',
        'es': 'Cómo recibir',
        'fr': 'Comment recevoir',
        'ko': '수령 방법',
        'zh': '如何接收',
        'zh-TW': '如何接收',
      },
      '口座情報': {
        'en': 'Account information',
        'it': 'Informazioni sull\'account',
        'de': 'Kontoinformationen',
        'es': 'Información de la cuenta',
        'fr': 'Informations sur le compte',
        'ko': '계좌 정보',
        'zh': '帳號資訊',
        'zh-TW': '账户信息',
      },
      '銀行名': {
        'en': 'bank name',
        'it': 'nome della banca',
        'de': 'Bankname',
        'es': 'nombre del banco',
        'fr': 'nom de la banque',
        'ko': '은행 이름',
        'zh': '銀行名稱',
        'zh-TW': '银行名称',
      },
      '支店名': {
        'en': 'Branch name',
        'it': 'Nome della filiale',
        'de': 'Filialname',
        'es': 'Nombre de la sucursal',
        'fr': 'Nom de la succursale',
        'ko': '지점명',
        'zh': '分支名稱',
        'zh-TW': '分支名称',
      },
      '支店番号': {
        'en': 'Branch number',
        'it': 'Numero della filiale',
        'de': 'Filialnummer',
        'es': 'Número de sucursal',
        'fr': 'Numéro de succursale',
        'ko': '지점 번호',
        'zh': '分行號',
        'zh-TW': '分行号',
      },
      '口座種別': {
        'en': 'Account type',
        'it': 'Tipo di conto',
        'de': 'Kontotyp',
        'es': 'Tipo de cuenta',
        'fr': 'Type de compte',
        'ko': '계좌 유형',
        'zh': '帳戶類型',
        'zh-TW': '账户类型',
      },
      '当座': {
        'en': 'current',
        'it': 'attuale',
        'de': 'aktuell',
        'es': 'actual',
        'fr': 'actuel',
        'ko': '당좌',
        'zh': '目前的',
        'zh-TW': '当前的',
      },
      '名義': {
        'en': 'Name',
        'it': 'Nome',
        'de': 'Name',
        'es': 'Nombre',
        'fr': 'Nom',
        'ko': '명의',
        'zh': '姓名',
        'zh-TW': '姓名',
      },
      '身分証アップロード': {
        'en': 'ID card upload',
        'it': 'Caricamento carta d\'identità',
        'de': 'Ausweis hochladen',
        'es': 'cargar tarjeta de identificación',
        'fr': 'Téléchargement de la carte d\'identité',
        'ko': '신분증 업로드',
        'zh': '上傳您的身分證',
        'zh-TW': '上传您的身份证',
      },
      '表': {
        'en': 'table',
        'it': 'tavolo',
        'de': 'Tisch',
        'es': 'mesa',
        'fr': 'tableau',
        'ko': '표',
        'zh': '桌子',
        'zh-TW': '桌子',
      },
      '裏(マイナンバーは表面のみ)': {
        'en': 'back',
        'it': 'Indietro',
        'de': 'zurück',
        'es': 'atrás',
        'fr': 'dos',
        'ko': '뒤',
        'zh': '背面（我的號碼只在正面）',
        'zh-TW': '背面（我的号码只在正面）',
      },
      '買取フローを確認しました。その全てに同意します。': {
        'en': 'I have confirmed the purchase flow. I agree with all of that.',
        'it': 'Ho confermato il flusso di acquisto. Sono d\'accordo con tutto ciò.',
        'de': 'Ich habe den Kaufvorgang bestätigt. Ich stimme dem alles zu.',
        'es': 'He confirmado el flujo de compra. Estoy de acuerdo con todo eso.',
        'fr': 'J\'ai confirmé le flux d\'achat. Je suis d\'accord avec tout cela.',
        'ko': '구매 흐름을 확인했습니다. 그 모든 것에 동의합니다.',
        'zh': '我已仔細閱讀購買流程，並同意所有條款。',
        'zh-TW': '我已仔细阅读购买流程，并同意所有条款。',
      },
      '買取表': {
        'en': 'Purchase Price List',
        'it': 'Listino prezzi',
        'de': 'Einkaufspreisliste',
        'es': 'Lista de precios de compra',
        'fr': 'Liste de prix d\'achat',
        'ko': '매입표',
        'zh': '採購價格表',
        'zh-TW': '采购价格表',
      },
      '閉じる': {
        'en': 'close',
        'it': 'vicino',
        'de': 'schließen',
        'es': 'cerca',
        'fr': 'fermer',
        'ko': '닫다',
        'zh': '關閉',
        'zh-TW': '关闭',
      },
      '買取手順': {
        'en': 'Purchase procedure',
        'it': 'Procedura di acquisto',
        'de': 'Kaufvorgang',
        'es': 'Procedimiento de compra',
        'fr': 'Procédure d\'achat',
        'ko': '구매 절차',
        'zh': '採購流程',
        'zh-TW': '采购流程',
      },
      '弊社へ査定依頼品の発送(発払い) & 買取申込フォームの送信': {
        'en': 'Send the items you wish to have appraised to our company (prepaid) & submit the purchase request form.',
        'it': 'Inviate gli oggetti che desiderate far valutare alla nostra azienda (spedizione prepagata) e compilate il modulo di richiesta di acquisto.',
        'de': 'Senden Sie die Gegenstände, die Sie schätzen lassen möchten, an unser Unternehmen (frankiert) und reichen Sie das Kaufanforderungsformular ein.',
        'es': 'Envíe los artículos que desea que se tasen a nuestra empresa (con el envío prepagado) y complete el formulario de solicitud de compra.',
        'fr': 'Envoyez à notre société les articles que vous souhaitez faire évaluer (affranchissement prépayé) et soumettez le formulaire de demande d\'achat.',
        'ko': '당사에 사정 의뢰품의 발송(발불) & 매입 신청 폼의 송신',
        'zh': '請將您希望估價的物品寄送至我公司（預付郵資），並提交購買申請表。',
        'zh-TW': '请将您希望估价的物品寄送至我公司（预付邮资），并提交购买申请表。',
      },
      'メールにて査定結果の送信(到着後2営業日以内)': {
        'en': 'We will send you the appraisal results by email (within 2 business days of receiving your item).',
        'it': 'Vi invieremo i risultati della valutazione via e-mail (entro 2 giorni lavorativi dal ricevimento dell\'oggetto).',
        'de': 'Wir senden Ihnen die Ergebnisse der Begutachtung per E-Mail (innerhalb von 2 Werktagen nach Erhalt Ihres Artikels).',
        'es': 'Le enviaremos los resultados de la tasación por correo electrónico (en un plazo de 2 días hábiles a partir de la recepción de su artículo).',
        'fr': 'Nous vous enverrons les résultats de l\'évaluation par courriel (dans les 2 jours ouvrables suivant la réception de votre article).',
        'ko': '메일로 평가 결과 송신 (도착 후 2 영업일 이내)',
        'zh': '我們將在收到您的物品後 2 個工作天內透過電子郵件向您發送鑑定結果。',
        'zh-TW': '我们将在收到您的物品后 2 个工作日内通过电子邮件向您发送鉴定结果。',
      },
      'お振込(査定結果へのご同意後2営業日以内)': {
        'en': 'Payment will be made via bank transfer (within 2 business days after you agree to the assessment results).',
        'it': 'Il pagamento verrà effettuato tramite bonifico bancario (entro 2 giorni lavorativi dall\'accettazione dei risultati della valutazione).',
        'de': 'Die Zahlung erfolgt per Banküberweisung (innerhalb von 2 Werktagen nach Ihrer Zustimmung zu den Bewertungsergebnissen).',
        'es': 'El pago se realizará mediante transferencia bancaria (en un plazo de 2 días hábiles después de que usted acepte los resultados de la evaluación).',
        'fr': 'Le paiement sera effectué par virement bancaire (dans les 2 jours ouvrables suivant votre acceptation des résultats de l\'évaluation).',
        'ko': '송금 (사정 결과에 동의 한 후 2 영업일 이내)',
        'zh': '付款將透過銀行轉帳進行（在您同意評估結果後的 2 個工作天內）。',
        'zh-TW': '付款将通过银行转账进行（在您同意评估结果后的 2 个工作日内）。',
      },
      'ご留意事項': {
        'en': 'Notes',
        'it': 'Note',
        'de': 'Notizen',
        'es': 'Notas',
        'fr': 'Remarques',
        'ko': '유의사항',
        'zh': '重要提示',
        'zh-TW': '重要提示',
      },
      '1）買取表に掲載しているカードのみ買取可能です。': {
        'en': '1) We only buy cards that are listed on our buyback price list.',
        'it': '1) Acquistiamo solo carte presenti nel nostro listino prezzi di riacquisto.',
        'de': '1) Wir kaufen nur Karten, die auf unserer Rückkaufpreisliste aufgeführt sind.',
        'es': '1) Solo compramos tarjetas que figuran en nuestra lista de precios de recompra.',
        'fr': '1) Nous n\'achetons que les cartes qui figurent sur notre liste de prix de rachat.',
        'ko': '1) 매입표에 게재하고 있는 카드만 매입 가능합니다.',
        'zh': '1）我們只收購我們回購價格表上的卡片。',
        'zh-TW': '1）我们只收购我们回购价格表上的卡片。',
      },
      '2）身分証は「運転免許証」「パスポート」「マイナンバー」のいずれかでお願いいたします。': {
        'en': '2) Please provide one of the following forms of identification: driver\'s license, passport, or My Number card.',
        'it': '2) Si prega di fornire uno dei seguenti documenti di identificazione: patente di guida, passaporto o carta My Number.',
        'de': '2) Bitte legen Sie einen der folgenden Ausweise vor: Führerschein, Reisepass oder My Number-Karte.',
        'es': '2) Por favor, proporcione uno de los siguientes documentos de identificación: licencia de conducir, pasaporte o tarjeta My Number.',
        'fr': '2) Veuillez fournir l\'une des pièces d\'identité suivantes : permis de conduire, passeport ou carte My Number.',
        'ko': '2) 신분증은 「운전 면허증」 「여권」 「마이 넘버」중 하나로 부탁드립니다.',
        'zh': '2）請提供以下身分證明之一：駕駛證、護照或我的號碼卡。',
        'zh-TW': '2）请提供以下身份证明之一：驾驶证、护照或我的号码卡。',
      },
      '3）100枚までの発送、同名同種のカードは5枚まででお願いいたします。': {
        'en': '3) We can ship up to 100 cards, and please limit the number of cards of the same name and type to 5.',
        'it': '3) Possiamo spedire fino a 100 biglietti, ma vi preghiamo di limitare a 5 il numero di biglietti con lo stesso nome e tipo.',
        'de': '3) Wir können bis zu 100 Karten versenden. Bitte beschränken Sie die Anzahl der Karten mit demselben Namen und Typ auf 5.',
        'es': '3) Podemos enviar hasta 100 tarjetas, y por favor, limite el número de tarjetas del mismo nombre y tipo a 5.',
        'fr': '3) Nous pouvons expédier jusqu\'à 100 cartes, et veuillez limiter le nombre de cartes du même nom et du même type à 5.',
        'ko': '3) 100장까지의 발송, 동명 동종의 카드는 5장까지로 부탁드리겠습니다.',
        'zh': '3）我們最多可以寄送 100 張卡片，請將同名同類型的卡片數量限制在 5 張以內。',
        'zh-TW': '3）我们最多可以寄送 100 张卡片，请将同名同类型的卡片数量限制在 5 张以内。',
      },
      '4）偽物・状態が著しく悪いカード・買取表に掲載のないカードは査定不可となります。': {
        'en': '4) Counterfeit cards, cards in extremely poor condition, and cards not listed in the buyback price list cannot be appraised.',
        'it': '4) Le carte contraffatte, le carte in condizioni estremamente precarie e le carte non incluse nel listino prezzi di riacquisto non possono essere valutate.',
        'de': '4) Gefälschte Karten, Karten in extrem schlechtem Zustand und Karten, die nicht in der Rückkaufpreisliste aufgeführt sind, können nicht bewertet werden.',
        'es': '4) Las tarjetas falsificadas, las tarjetas en muy mal estado y las tarjetas que no figuran en la lista de precios de recompra no pueden ser tasadas.',
        'fr': '4) Les cartes contrefaites, les cartes en très mauvais état et les cartes non répertoriées dans la liste des prix de rachat ne peuvent pas être évaluées.',
        'ko': '4) 가짜·상태가 현저하게 나쁜 카드·매입표에 게재가 없는 카드는 사정 불가가 됩니다.',
        'zh': '4) 假卡、品相極差的卡片、未列入回購價格表的卡片不能進行估價。',
        'zh-TW': '4) 假卡、品相极差的卡以及未列入回购价格表的卡不能进行估价。',
      },
      '5）返送をご希望の場合は、着払いにてご返送いたします。': {
        'en': '5) If you wish to have the item returned, we will send it back to you via cash on delivery.',
        'it': '5) Se desideri che l\'articolo venga restituito, te lo rispediremo tramite pagamento in contrassegno.',
        'de': '5) Falls Sie den Artikel zurücksenden möchten, senden wir ihn Ihnen per Nachnahme zurück.',
        'es': '5) Si desea que le devolvamos el artículo, se lo enviaremos de vuelta contra reembolso.',
        'fr': '5) Si vous souhaitez que l\'article soit retourné, nous vous le renverrons en contre-remboursement.',
        'ko': '5) 반송을 희망하시는 경우는, 수취인 지불로 반송하겠습니다.',
        'zh': '5) 如果您希望退貨，我們將以貨到付款的方式將商品寄回給您。',
        'zh-TW': '5) 如果您希望退货，我们将通过货到付款的方式将商品寄回给您。',
      },
      '6）査定額は、到着時の価格となります。発送時にご確認いただいた価格と異なってしまう場合がございます。': {
        'en': '6) The appraisal amount will be the price at the time of arrival. This may differ from the price you confirmed at the time of shipping.',
        'it': '6) L\'importo della valutazione sarà il prezzo al momento dell\'arrivo. Questo potrebbe differire dal prezzo da voi confermato al momento della spedizione.',
        'de': '6) Der Schätzwert entspricht dem Preis zum Zeitpunkt der Ankunft. Dieser kann von dem Preis abweichen, den Sie zum Zeitpunkt des Versands bestätigt haben.',
        'es': '6) El importe de la tasación será el precio vigente en el momento de la llegada. Este precio puede diferir del precio que usted confirmó en el momento del envío.',
        'fr': '6) Le montant de l\'évaluation correspondra au prix au moment de la livraison. Ce prix peut différer de celui que vous avez confirmé lors de l\'expédition.',
        'ko': '6) 평가 금액은 도착시 가격입니다. 배송시 확인하신 가격과 다를 수 있습니다.',
        'zh': '6) 估價金額將以到貨時的價格為準。這可能與您在出貨時確認的價格有所不同。',
        'zh-TW': '6) 估价金额将以到货时的价格为准。这可能与您在发货时确认的价格有所不同。',
      },
      '確認コードを入力してください': {
        'en': 'Please enter your verification code',
        'it': 'Inserisci il tuo codice di verifica',
        'de': 'Bitte geben Sie Ihren Bestätigungscode ein',
        'es': 'Por favor ingresa tu código de verificación',
        'fr': 'Veuillez entrer votre code de vérification',
        'ko': '확인 코드를 입력하세요.',
        'zh': '請輸入驗證碼。',
        'zh-TW': '请输入验证码。',
      },
      '発送依頼日': {
        'en': 'Shipping request date',
        'it': 'Data richiesta spedizione',
        'de': 'Datum der Versandanfrage',
        'es': 'Fecha de solicitud de envío',
        'fr': 'Date de demande d\'expédition',
        'ko': '배송 요청일',
        'zh': '出貨請求日期',
        'zh-TW': '发货请求日期',
      },
      '今月の課金額が {amount} 円未満のため、ご利用いただけません。': {
        'en': 'Cannot be used because this month\'s billing amount is less than {amount} yen.',
        'it': 'Non può essere utilizzato perché l\'importo della fatturazione di questo mese è inferiore a {amount} yen.',
        'de': 'Kann nicht verwendet werden, da der Rechnungsbetrag dieses Monats weniger als {amount} Yen beträgt.',
        'es': 'No se puede utilizar porque el monto de facturación de este mes es inferior a {amount} yenes.',
        'fr': 'Ne peut pas être utilisé, car le montant facturé pour ce mois-ci est inférieur à {amount} yens.',
        'ko': '이달의 요금이 {amount} 엔 미만이므로 사용할 수 없습니다.',
        'zh': '由於本月的帳單金額少於 {amount} 日元，因此無法使用。',
        'zh-TW': '由于本月的账单金额少于 {amount} 日元，因此无法使用。',
      },
      'ユーザーエラー': {
        'en': 'User error',
        'it': 'Errore dell\'utente',
        'de': 'Benutzerfehler',
        'es': 'Error del usuario',
        'fr': 'Erreur de l\'utilisateur',
        'ko': '사용자 오류',
        'zh': '使用者錯誤',
        'zh-TW': '用户错误',
      },
      '該当する商品が存在しません。': {
        'en': 'No matching products were found.',
        'it': 'Non sono stati trovati prodotti corrispondenti.',
        'de': 'Es wurden keine passenden Produkte gefunden.',
        'es': 'No se encontraron productos coincidentes.',
        'fr': 'Aucun produit correspondant n\'a été trouvé.',
        'ko': '해당 상품이 존재하지 않습니다.',
        'zh': '未找到匹配產品。',
        'zh-TW': '未找到匹配产品。',
      },
      '対象地域ではありません。': {
        'en': 'This area is not included in the target region.',
        'it': 'Quest\'area non è inclusa nella regione di destinazione.',
        'de': 'Dieses Gebiet ist nicht in der Zielregion enthalten.',
        'es': 'Esta zona no está incluida en la región objetivo.',
        'fr': 'Cette zone n\'est pas incluse dans la région cible.',
        'ko': '대상 지역이 아닙니다.',
        'zh': '該區域不屬於目標區域。',
        'zh-TW': '该区域不属于目标区域。',
      },
      'このガチャは、{rank}ランクの方はご購入できません。': {
        'en': 'This gacha cannot be purchased by those of {rank} rank.',
        'it': 'Questo gacha non può essere acquistato da coloro che hanno il rango {rank}.',
        'de': 'Dieses Gacha kann nicht von Personen mit dem Rang {rank} gekauft werden.',
        'es': 'Esta gacha no puede ser comprada por aquellos con rango {rank}.',
        'fr': 'Ce gacha ne peut pas être acheté par ceux de rang {rank}.',
        'ko': '이 가챠는 {rank} 랭크의 분은 구입할 수 없습니다.',
        'zh': '{rank} 等級的玩家無法購買此扭蛋。',
        'zh-TW': '{rank} 等级的玩家无法购买此扭蛋。',
      },
      'このガチャは総保有コインが{max_point_limit}コイン以上の場合は購入できません。\n※未選択のものも含みます。': {
        'en': 'This gacha cannot be purchased if the total coins you own are more than {max_point_limit}coins. \n*Includes unselected items.',
        'it': 'Questo gacha non può essere acquistato se il totale delle monete che possiedi è superiore a {max_point_limit} monete. \n*Include elementi non selezionati.',
        'de': 'Dieses Gacha kann nicht gekauft werden, wenn die Gesamtzahl der Münzen, die Sie besitzen, mehr als {max_point_limit} Münzen beträgt. \n*Enthält nicht ausgewählte Elemente.',
        'es': 'Esta gacha no se puede comprar si el total de monedas que posees supera las {max_point_limit}monedas. \n*Incluye elementos no seleccionados.',
        'fr': 'Ce gacha ne peut pas être acheté si le total de pièces que vous possédez est supérieur à {max_point_limit} pièces. \n*Inclut les éléments non sélectionnés.',
        'ko': '이 가챠는 총 보유 코인이 {max_point_limit}coins 이상인 경우는 구입할 수 없습니다.',
        'zh': '如果您擁有的金幣總數超過 {max_point_limit} 個金幣，則無法購買此扭蛋。 \n*包含未選擇的項目。',
        'zh-TW': '如果您拥有的金币总数超过 {max_point_limit} 个金币，则无法购买此扭蛋。 \n*包括未选择的项目。',
      },
      'お客様は本商品をご利用いただける条件を満たしていないため、ご利用いただけません。\n条件等の公開はいたしかねますこと、ご容赦くださいませ。': {
        'en': 'You are unable to use this product because you do not meet the eligibility requirements. We apologize that we cannot disclose the eligibility requirements.',
        'it': 'Non puoi utilizzare questo prodotto perché non soddisfi i requisiti di idoneità. Ci scusiamo, ma non possiamo divulgare i requisiti di idoneità.',
        'de': 'Sie können dieses Produkt nicht nutzen, da Sie die Teilnahmevoraussetzungen nicht erfüllen. Wir bedauern, dass wir Ihnen die Teilnahmevoraussetzungen nicht mitteilen können.',
        'es': 'No puedes usar este producto porque no cumples con los requisitos de elegibilidad. Lamentamos no poder revelar dichos requisitos.',
        'fr': 'Vous ne pouvez pas utiliser ce produit car vous ne remplissez pas les conditions d\'admissibilité. Nous regrettons de ne pouvoir divulguer ces conditions.',
        'ko': '고객은 본 제품을 이용하실 수 있는 조건을 충족하지 않으므로 이용하실 수 없습니다. \n조건등의 공개는 하기 어렵습니다, 용서해 주십시오.',
        'zh': '您無法使用此產品，因為您不符合資格要求。很抱歉，我們無法透露資格要求的具體內容。',
        'zh-TW': '您无法使用此产品，因为您不符合资格要求。很抱歉，我们无法透露资格要求的具体内容。',
      },
      'このガチャは1度までです。': {
        'en': 'You can only use this gacha once.',
        'it': 'Puoi utilizzare questo gacha una sola volta.',
        'de': 'Du kannst dieses Gacha-Element nur einmal verwenden.',
        'es': 'Solo puedes usar este gacha una vez.',
        'fr': 'Vous ne pouvez utiliser ce gacha qu\'une seule fois.',
        'ko': '이 뽑기는 1도까지입니다.',
        'zh': '這個扭蛋只能使用一次。',
        'zh-TW': '这个扭蛋只能使用一次。',
      },
      '{detetime}まで購入できません。': {
        'en': 'Purchases cannot be made until {detetime}.',
        'it': 'Non sarà possibile effettuare acquisti prima del {detetime}.',
        'de': 'Käufe können erst ab {detetime} getätigt werden.',
        'es': 'Las compras no se podrán realizar hasta el {detetime}.',
        'fr': 'Les achats ne peuvent être effectués avant le {detetime}.',
        'ko': '{detetime}까지 구매할 수 없습니다.',
        'zh': '在{detetime}之前無法進行購買。',
        'zh-TW': '在{detetime}之前无法进行购买。',
      },
      '購入可能数をオーバーしています。': {
        'en': 'You have exceeded the purchase limit.',
        'it': 'Hai superato il limite di acquisto.',
        'de': 'Sie haben das Kauflimit überschritten.',
        'es': 'Has superado el límite de compra.',
        'fr': 'Vous avez dépassé la limite d\'achat.',
        'ko': '구매 가능한 수를 초과했습니다.',
        'zh': '您已超出購買限額。',
        'zh-TW': '您已超出购买限额。',
      },
      '入力してください': {
        'en': 'Please enter your information.',
        'it': 'Inserisci i tuoi dati.',
        'de': 'Bitte geben Sie Ihre Daten ein.',
        'es': 'Por favor, introduzca su información.',
        'fr': 'Veuillez saisir vos informations.',
        'ko': '입력해주세요',
        'zh': '請填寫您的資料。',
        'zh-TW': '请填写您的信息。',
      },
      '形式が不正です': {
        'en': 'The format is invalid.',
        'it': 'Il formato non è valido.',
        'de': 'Das Format ist ungültig.',
        'es': 'El formato no es válido.',
        'fr': 'Le format est invalide.',
        'ko': '형식이 잘못되었습니다.',
        'zh': '格式無效。',
        'zh-TW': '格式无效。',
      },
      '半角英数字で入力してください': {
        'en': 'Please enter using half-width alphanumeric characters.',
        'it': 'Inserisci il testo utilizzando caratteri alfanumerici a larghezza dimezzata.',
        'de': 'Bitte geben Sie die Zeichen in halber Breite (alphanumerisch) ein.',
        'es': 'Introduzca la información utilizando caracteres alfanuméricos de ancho reducido.',
        'fr': 'Veuillez saisir les caractères alphanumériques en demi-largeur.',
        'ko': '반각 영숫자로 입력하세요.',
        'zh': '請使用半角字母數字字元輸入。',
        'zh-TW': '请使用半角字母数字字符输入。',
      },
      '半角英数記号で入力してください': {
        'en': 'Please enter using half-width alphanumeric characters and symbols.',
        'it': 'Inserisci il testo utilizzando caratteri alfanumerici e simboli a larghezza ridotta.',
        'de': 'Bitte geben Sie die Zeichen und Symbole in halber Breite ein.',
        'es': 'Introduzca la información utilizando caracteres alfanuméricos y símbolos de ancho reducido.',
        'fr': 'Veuillez saisir en utilisant des caractères alphanumériques et des symboles de demi-largeur.',
        'ko': '반각 영숫자 기호로 입력하십시오.',
        'zh': '請使用半角字母數字字元和符號輸入。',
        'zh-TW': '请使用半角字母数字字符和符号输入。',
      },
      '%d文字以内で入力してください': {
        'en': 'Please enter within %d characters.',
        'it': 'Inserisci il testo entro %d caratteri.',
        'de': 'Bitte geben Sie innerhalb von %d Zeichen ein.',
        'es': 'Por favor, introduzca un máximo de %d caracteres.',
        'fr': 'Veuillez saisir dans les %d caractères.',
        'ko': '%d자 이내로 입력하세요.',
        'zh': '請在 %d 個字元內輸入。',
        'zh-TW': '请在 %d 个字符内输入。',
      },
      '%d文字以上で入力してください': {
        'en': 'Please enter at least %d characters.',
        'it': 'Inserisci almeno %d caratteri.',
        'de': 'Bitte geben Sie mindestens %d Zeichen ein.',
        'es': 'Por favor, introduzca al menos %d caracteres.',
        'fr': 'Veuillez saisir au moins %d caractères.',
        'ko': '%d자 이상으로 입력하세요.',
        'zh': '請輸入至少 %d 個字元。',
        'zh-TW': '请输入至少 %d 个字符。',
      },
      '既に使われています': {
        'en': 'It is already in use.',
        'it': 'È già in uso.',
        'de': 'Es ist bereits im Einsatz.',
        'es': 'Ya está en uso.',
        'fr': 'Il est déjà utilisé.',
        'ko': '이미 사용 중',
        'zh': '它已經在使用了。',
        'zh-TW': '它已经在使用了。',
      },
      'カタカナで入力してください': {
        'en': 'Please enter in katakana.',
        'it': 'Inserisci il testo in katakana.',
        'de': 'Bitte in Katakana eingeben.',
        'es': 'Por favor, introduzca en katakana.',
        'fr': 'Veuillez saisir en katakana.',
        'ko': '카타카나로 입력해주세요',
        'zh': '請用片假名輸入。',
        'zh-TW': '请用片假名输入。',
      },
      'ひらがなで入力してください': {
        'en': 'Please enter in hiragana.',
        'it': 'Inserisci il testo in hiragana.',
        'de': 'Bitte geben Sie den Text in Hiragana ein.',
        'es': 'Por favor, escriba en hiragana.',
        'fr': 'Veuillez saisir en hiragana.',
        'ko': '히라가나로 입력하십시오.',
        'zh': '請用平假名輸入。',
        'zh-TW': '请用平假名输入。',
      },
      '%d以上で入力してください': {
        'en': 'Please enter a value of %d or greater.',
        'it': 'Inserisci un valore pari o superiore a %d.',
        'de': 'Bitte geben Sie einen Wert von %d oder größer ein.',
        'es': 'Introduzca un valor de %d o superior.',
        'fr': 'Veuillez saisir une valeur de %d ou plus.',
        'ko': '%d 이상으로 입력하세요.',
        'zh': '請輸入大於等於 %d 的值。',
        'zh-TW': '请输入大于等于 %d 的值。',
      },
      'コードが一致しません': {
        'en': 'The codes do not match.',
        'it': 'I codici non corrispondono.',
        'de': 'Die Codes stimmen nicht überein.',
        'es': 'Los códigos no coinciden.',
        'fr': 'Les codes ne correspondent pas.',
        'ko': '코드가 일치하지 않음',
        'zh': '代碼不匹配。',
        'zh-TW': '代码不匹配。',
      },
      '該当ユーザーなし': {
        'en': 'No matching users found.',
        'it': 'Nessun utente corrispondente trovato.',
        'de': 'Es wurden keine passenden Benutzer gefunden.',
        'es': 'No se encontraron usuarios coincidentes.',
        'fr': 'Aucun utilisateur correspondant trouvé.',
        'ko': '해당 사용자 없음',
        'zh': '未找到匹配用戶。',
        'zh-TW': '未找到匹配用户。',
      },
      'パスワードが一致しません': {
        'en': 'Passwords do not match.',
        'it': 'Le password non corrispondono.',
        'de': 'Die Passwörter stimmen nicht überein.',
        'es': 'Las contraseñas no coinciden.',
        'fr': 'Les mots de passe ne correspondent pas.',
        'ko': '비밀번호가 일치하지 않음',
        'zh': '密碼不符。',
        'zh-TW': '密码不匹配。',
      },
      '紹介コードが無効です': {
        'en': 'The referral code is invalid.',
        'it': 'Il codice di riferimento non è valido.',
        'de': 'Der Empfehlungscode ist ungültig.',
        'es': 'El código de referencia no es válido.',
        'fr': 'Le code de parrainage est invalide.',
        'ko': '추천 코드가 잘못되었습니다.',
        'zh': '推薦碼無效。',
        'zh-TW': '推荐码无效。',
      },
      '紹介コードを入力してください': {
        'en': 'Please enter the referral code.',
        'it': 'Inserisci il codice di riferimento.',
        'de': 'Bitte geben Sie den Empfehlungscode ein.',
        'es': 'Por favor, introduzca el código de referencia.',
        'fr': 'Veuillez saisir le code de parrainage.',
        'ko': '추천 코드를 입력하세요.',
        'zh': '請輸入推薦碼。',
        'zh-TW': '请输入推荐码。',
      },
      'パスワード確認用と一致しません': {
        'en': 'Password does not match the password used for confirmation.',
        'it': 'La password non corrisponde a quella utilizzata per la conferma.',
        'de': 'Das Passwort stimmt nicht mit dem zur Bestätigung verwendeten Passwort überein.',
        'es': 'La contraseña no coincide con la contraseña utilizada para la confirmación.',
        'fr': 'Le mot de passe ne correspond pas à celui utilisé pour la confirmation.',
        'ko': '비밀번호 확인과 일치하지 않음',
        'zh': '密碼與用於確認的密碼不符。',
        'zh-TW': '密码与用于确认的密码不匹配。',
      },
      'ユーザーが一致しません': {
        'en': 'Users do not match',
        'it': 'Gli utenti non corrispondono',
        'de': 'Die Benutzer passen nicht zusammen',
        'es': 'Los usuarios no coinciden',
        'fr': 'Les utilisateurs ne correspondent pas',
        'ko': '사용자가 일치하지 않음',
        'zh': '用戶不匹配',
        'zh-TW': '用户不匹配',
      },
      '支払い方法が一致しません': {
        'en': 'Payment methods do not match.',
        'it': 'I metodi di pagamento non corrispondono.',
        'de': 'Die Zahlungsmethoden stimmen nicht überein.',
        'es': 'Los métodos de pago no coinciden.',
        'fr': 'Les modes de paiement ne correspondent pas.',
        'ko': '결제 방법이 일치하지 않음',
        'zh': '付款方式不符。',
        'zh-TW': '付款方式不匹配。',
      },
      'この電話番号は既に登録されています': {
        'en': 'This phone number is already registered.',
        'it': 'Questo numero di telefono è già registrato.',
        'de': 'Diese Telefonnummer ist bereits registriert.',
        'es': 'Este número de teléfono ya está registrado.',
        'fr': 'Ce numéro de téléphone est déjà enregistré.',
        'ko': '이 전화번호는 이미 등록되어 있습니다.',
        'zh': '該電話號碼已註冊。',
        'zh-TW': '该电话号码已被注册。',
      },
      'この電話番号は利用できません。': {
        'en': 'This phone number is unavailable.',
        'it': 'Questo numero di telefono non è disponibile.',
        'de': 'Diese Telefonnummer ist nicht erreichbar.',
        'es': 'Este número de teléfono no está disponible.',
        'fr': 'Ce numéro de téléphone n\'est pas disponible.',
        'ko': '이 전화번호는 사용할 수 없습니다.',
        'zh': '此電話號碼無法接通。',
        'zh-TW': '此电话号码无法接通。',
      },
      'コードが一致しませんでした': {
        'en': 'The codes did not match.',
        'it': 'I codici non corrispondevano.',
        'de': 'Die Codes stimmten nicht überein.',
        'es': 'Los códigos no coincidían.',
        'fr': 'Les codes ne correspondaient pas.',
        'ko': '코드가 일치하지 않음',
        'zh': '代碼不匹配。',
        'zh-TW': '代码不匹配。',
      },
      '有効期限が切れています': {
        'en': 'The expiration date has passed.',
        'it': 'La data di scadenza è trascorsa.',
        'de': 'Das Ablaufdatum ist überschritten.',
        'es': 'La fecha de vencimiento ha pasado.',
        'fr': 'La date d\'expiration est dépassée.',
        'ko': '만료됨',
        'zh': '有效期限已過。',
        'zh-TW': '有效期已过。',
      },
      'コード認証に失敗しました': {
        'en': 'Code authentication failed.',
        'it': 'Autenticazione del codice non riuscita.',
        'de': 'Codeauthentifizierung fehlgeschlagen.',
        'es': 'Falló la autenticación del código.',
        'fr': 'L\'authentification du code a échoué.',
        'ko': '코드 인증에 실패했습니다.',
        'zh': '程式碼驗證失敗。',
        'zh-TW': '代码验证失败。',
      },
      '不正なリクエストです': {
        'en': 'Invalid request.',
        'it': 'Richiesta non valida.',
        'de': 'Ungültige Anfrage.',
        'es': 'Solicitud no válida.',
        'fr': 'Requête invalide.',
        'ko': '잘못된 요청입니다.',
        'zh': '無效請求。',
        'zh-TW': '无效请求。',
      },
      'エラーが発生しました': {
        'en': 'An error has occurred',
        'it': 'Si è verificato un errore',
        'de': 'Es ist ein Fehler aufgetreten',
        'es': 'Se ha producido un error.',
        'fr': 'Une erreur s\'est produite.',
        'ko': '오류가 발생했습니다.',
        'zh': '發生錯誤',
        'zh-TW': '发生错误',
      },
      '既にランクを維持しています': {
        'en': 'I\'m already maintaining my rank.',
        'it': 'Sto già mantenendo il mio grado.',
        'de': 'Ich halte meinen Rang bereits.',
        'es': 'Ya estoy manteniendo mi rango.',
        'fr': 'Je maintiens déjà mon grade.',
        'ko': '이미 순위를 유지하고 있습니다.',
        'zh': '我的軍階已經保持不變。',
        'zh-TW': '我的军衔已经保持不变。',
      },
      'ログインしてください。': {
        'en': 'Please log in.',
        'it': 'Effettua il login.',
        'de': 'Bitte melden Sie sich an.',
        'es': 'Por favor, inicie sesión.',
        'fr': 'Veuillez vous connecter.',
        'ko': '로그인하십시오.',
        'zh': '請登入。',
        'zh-TW': '请登录。',
      },
      'クーポンコードが間違っています。\n正しいコードを入力してください。': {
        'en': 'The coupon code is incorrect. Please enter the correct code.',
        'it': 'Il codice coupon non è corretto. Inserisci il codice corretto.',
        'de': 'Der Gutscheincode ist ungültig. Bitte geben Sie den korrekten Code ein.',
        'es': 'El código del cupón es incorrecto. Por favor, introduzca el código correcto.',
        'fr': 'Le code promo est incorrect. Veuillez saisir le code correct.',
        'ko': '쿠폰 코드가 잘못되었습니다. \n올바른 코드를 입력하세요.',
        'zh': '優惠券代碼錯誤，請重新輸入正確的代碼。',
        'zh-TW': '优惠券代码错误，请重新输入正确的代码。',
      },
      'クーポンコードの期限が切れています。\n正しいコードを入力してください。': {
        'en': 'Your coupon code has expired. Please enter the correct code.',
        'it': 'Il tuo codice coupon è scaduto. Inserisci il codice corretto.',
        'de': 'Ihr Gutscheincode ist abgelaufen. Bitte geben Sie den korrekten Code ein.',
        'es': 'Tu código de cupón ha caducado. Introduce el código correcto.',
        'fr': 'Votre code promo a expiré. Veuillez saisir le code correct.',
        'ko': '쿠폰 코드가 만료되었습니다. \n올바른 코드를 입력하세요.',
        'zh': '您的優惠券代碼已過期。請重新輸入正確的代碼。',
        'zh-TW': '您的优惠券代码已过期。请重新输入正确的代码。',
      },
      'クーポンコードの利用条件が満たされていません。\n正しいコードを入力してください。': {
        'en': 'The coupon code redemption conditions have not been met. Please enter the correct code.',
        'it': 'Le condizioni per l\'utilizzo del codice coupon non sono state soddisfatte. Inserisci il codice corretto.',
        'de': 'Die Einlösebedingungen für den Gutscheincode wurden nicht erfüllt. Bitte geben Sie den korrekten Code ein.',
        'es': 'No se cumplen las condiciones para canjear el código del cupón. Introduzca el código correcto.',
        'fr': 'Les conditions d\'utilisation du code promo ne sont pas remplies. Veuillez saisir le code correct.',
        'ko': '쿠폰 코드 이용 약관이 충족되지 않았습니다. \n올바른 코드를 입력하세요.',
        'zh': '優惠券代碼兌換條件未滿足。請重新輸入正確的代碼。',
        'zh-TW': '优惠券代码兑换条件未满足。请重新输入正确的代码。',
      },
      'クーポンコードの利用回数が上限に達しています。\n新しいコードを入力してください。': {
        'en': 'The coupon code has reached its usage limit. Please enter a new code.',
        'it': 'Il codice coupon ha raggiunto il limite di utilizzi. Inserisci un nuovo codice.',
        'de': 'Der Gutscheincode ist nicht mehr einlösbar. Bitte geben Sie einen neuen Code ein.',
        'es': 'El código de cupón ha alcanzado su límite de uso. Por favor, introduzca un nuevo código.',
        'fr': 'Ce code promo a atteint sa limite d\'utilisation. Veuillez saisir un nouveau code.',
        'ko': '쿠폰 코드 이용 횟수가 상한에 도달했습니다. \n새 코드를 입력하세요.',
        'zh': '優惠碼已達到使用次數上限，請輸入新的優惠碼。',
        'zh-TW': '优惠码已达到使用次数上限，请输入新的优惠码。',
      },
      '既に使用済みのクーポンコードです。\n新しいコードを入力してください。': {
        'en': 'This coupon code has already been used. Please enter a new code.',
        'it': 'Questo codice sconto è già stato utilizzato. Inserisci un nuovo codice.',
        'de': 'Dieser Gutscheincode wurde bereits verwendet. Bitte geben Sie einen neuen Code ein.',
        'es': 'Este código de cupón ya ha sido utilizado. Por favor, introduzca un nuevo código.',
        'fr': 'Ce code promo a déjà été utilisé. Veuillez saisir un nouveau code.',
        'ko': '이미 사용한 쿠폰 코드입니다. \n새 코드를 입력하세요.',
        'zh': '此優惠碼已使用，請輸入新的優惠碼。',
        'zh-TW': '此优惠码已被使用，请输入新的优惠码。',
      },
      'コインプレゼントが見つかりません': {
        'en': 'Coin gift not found.',
        'it': 'Regalo in monete non trovato.',
        'de': 'Münzgeschenk nicht gefunden.',
        'es': 'No se encontró la moneda de regalo.',
        'fr': 'Pièce de monnaie introuvable.',
        'ko': '동전 선물을 찾을 수 없습니다.',
        'zh': '未找到硬幣禮物。',
        'zh-TW': '未找到硬币礼物。',
      },
      'コインプレゼントが適用されていません': {
        'en': 'The coin gift has not been applied.',
        'it': 'Il bonus in monete non è stato applicato.',
        'de': 'Die Münzspende wurde nicht eingelöst.',
        'es': 'El obsequio de monedas no se ha aplicado.',
        'fr': 'Le cadeau en pièces n\'a pas été appliqué.',
        'ko': '코인 선물이 적용되지 않음',
        'zh': '贈送的硬幣尚未發放。',
        'zh-TW': '赠送的硬币尚未发放。',
      },
      '該当するガチャが存在しません': {
        'en': 'No matching gacha exists.',
        'it': 'Non esiste un gacha corrispondente.',
        'de': 'Es existiert kein passendes Gacha-Cha.',
        'es': 'No existe ningún gacha que coincida.',
        'fr': 'Aucun gacha correspondant n\'existe.',
        'ko': '해당 가챠가 존재하지 않습니다.',
        'zh': '沒有對應的扭蛋。',
        'zh-TW': '没有对应的扭蛋。',
      },
      '購入可能数をオーバーしています': {
        'en': 'You have exceeded the purchase limit.',
        'it': 'Hai superato il limite di acquisto.',
        'de': 'Sie haben das Kauflimit überschritten.',
        'es': 'Has superado el límite de compra.',
        'fr': 'Vous avez dépassé la limite d\'achat.',
        'ko': '구매 가능한 수를 초과했습니다.',
        'zh': '您已超出購買限額。',
        'zh-TW': '您已超出购买限额。',
      },
      '最大購入数を超えています': {
        'en': 'You have exceeded the maximum purchase limit.',
        'it': 'Hai superato il limite massimo di acquisto.',
        'de': 'Sie haben das maximale Kauflimit überschritten.',
        'es': 'Has superado el límite máximo de compra.',
        'fr': 'Vous avez dépassé la limite d\'achat maximale.',
        'ko': '최대 구매 수를 초과함',
        'zh': '您已超出最高購買限額。',
        'zh-TW': '您已超出最高购买限额。',
      },
      '購入データが見つかりませんでした': {
        'en': 'Purchase data not found.',
        'it': 'Dati di acquisto non trovati.',
        'de': 'Kaufdaten nicht gefunden.',
        'es': 'No se encontraron datos de compra.',
        'fr': 'Données d\'achat introuvables.',
        'ko': '구매 데이터를 찾을 수 없습니다.',
        'zh': '未找到購買資料。',
        'zh-TW': '未找到购买数据。',
      },
      '既に選択済みです': {
        'en': 'Already selected.',
        'it': 'Già selezionato.',
        'de': 'Bereits ausgewählt.',
        'es': 'Ya seleccionado.',
        'fr': 'Déjà sélectionné.',
        'ko': '이미 선택됨',
        'zh': '已選取。',
        'zh-TW': '已选中。',
      },
      '動画が見つかりません': {
        'en': 'No video found.',
        'it': 'Nessun video trovato.',
        'de': 'Kein Video gefunden.',
        'es': 'No se encontró ningún vídeo.',
        'fr': 'Aucune vidéo trouvée.',
        'ko': '동영상을 찾을 수 없음',
        'zh': '未找到影片。',
        'zh-TW': '未找到视频。',
      },
      '既に視聴済みです': {
        'en': 'I have already watched it.',
        'it': 'L\'ho già visto.',
        'de': 'Ich habe es bereits gesehen.',
        'es': 'Ya la he visto.',
        'fr': 'Je l\'ai déjà regardé.',
        'ko': '이미 시청됨',
        'zh': '我已經看過了。',
        'zh-TW': '我已经看过了。',
      },
      '販売者募集': {
        'en': 'Sellers Wanted',
        'it': 'Cercasi venditori',
        'de': 'Verkäufer gesucht',
        'es': 'Se buscan vendedores',
        'fr': 'Vendeurs recherchés',
        'ko': '판매자 모집',
        'zh': '誠招賣家',
        'zh-TW': '诚招卖家',
      },
      '遊び方': {
        'en': 'How to play',
        'it': 'Come giocare',
        'de': 'Spielanleitung',
        'es': 'Cómo jugar',
        'fr': 'Comment jouer',
        'ko': '놀이 방법',
        'zh': '如何玩',
        'zh-TW': '如何玩',
      },
      '残数': {
        'en': 'Residue',
        'it': 'Residuo',
        'de': 'Rückstand',
        'es': 'Residuo',
        'fr': 'Résidu',
        'ko': '잔여물',
        'zh': '渣滓',
        'zh-TW': '残渣',
      },
      'コインを': {
        'en': 'coin',
        'it': 'coniare',
        'de': 'Münze',
        'es': 'acuñar',
        'fr': 'pièce de monnaie',
        'ko': '동전',
        'zh': '硬幣',
        'zh-TW': '硬币',
      },
      '消費して': {
        'en': 'Consume',
        'it': 'Consumare',
        'de': 'Verbrauchen',
        'es': 'Consumir',
        'fr': 'Consommer',
        'ko': '소모하다',
        'zh': '消耗',
        'zh-TW': '消耗',
      },
      'Xmarketは近日公開致します': {
        'en': 'Xmarket will be launched soon.',
        'it': 'Xmarket verrà lanciato a breve.',
        'de': 'Xmarket wird in Kürze eingeführt.',
        'es': 'Xmarket se lanzará próximamente.',
        'fr': 'Xmarket sera bientôt lancé.',
        'ko': 'Xmarket은 곧 공개됩니다.',
        'zh': 'Xmarket即將上線。',
        'zh-TW': 'Xmarket即将上线。',
      },
      'お振込み': {
        'en': 'Bank transfer',
        'it': 'Bonifico bancario',
        'de': 'Banküberweisung',
        'es': 'Transferencia bancaria',
        'fr': 'Virement bancaire',
        'ko': '송금',
        'zh': '銀行轉帳',
        'zh-TW': '银行转账',
      },
      'コインで受け取り': {
        'en': 'Receive with coins',
        'it': 'Ricevi con monete',
        'de': 'Mit Münzen empfangen',
        'es': 'Recibir con monedas',
        'fr': 'Recevoir avec des pièces',
        'ko': '동전으로 수령',
        'zh': '用金幣領取',
        'zh-TW': '用金币领取',
      },
      '普通': {
        'en': 'usually',
        'it': 'Generalmente',
        'de': 'normalerweise',
        'es': 'generalmente',
        'fr': 'généralement',
        'ko': '보통',
        'zh': '通常',
        'zh-TW': '通常',
      },
      'ホワイト': {
        'en': 'white',
        'it': 'bianco',
        'de': 'Weiß',
        'es': 'blanco',
        'fr': 'blanc',
        'ko': '화이트',
        'zh': '白色的',
        'zh-TW': '白色的',
      },
      'ブロンズ': {
        'en': 'bronze',
        'it': 'bronzo',
        'de': 'Bronze',
        'es': 'bronce',
        'fr': 'bronze',
        'ko': '청동',
        'zh': '青銅',
        'zh-TW': '青铜',
      },
      'シルバー': {
        'en': 'Silver',
        'it': 'Argento',
        'de': 'Silber',
        'es': 'Plata',
        'fr': 'Argent',
        'ko': '실버',
        'zh': '銀',
        'zh-TW': '银',
      },
      'ゴールド': {
        'en': 'gold',
        'it': 'oro',
        'de': 'Gold',
        'es': 'oro',
        'fr': 'or',
        'ko': '금',
        'zh': '金子',
        'zh-TW': '金子',
      },
      'レインボー': {
        'en': 'Rainbow',
        'it': 'Arcobaleno',
        'de': 'Regenbogen',
        'es': 'Arcoíris',
        'fr': 'Arc-en-ciel',
        'ko': '레인보우',
        'zh': '彩虹',
        'zh-TW': '彩虹',
      },
      'ブラック': {
        'en': 'black',
        'it': 'nero',
        'de': 'Schwarz',
        'es': 'negro',
        'fr': 'noir',
        'ko': '블랙',
        'zh': '黑色的',
        'zh-TW': '黑色的',
      },
      'まで': {
        'en': 'to',
        'it': 'A',
        'de': 'Zu',
        'es': 'a',
        'fr': 'à',
        'ko': '까지',
        'zh': '到',
        'zh-TW': '到',
      },
      '画像ファイルのみアップロードできます。': {
        'en': 'Only image files can be uploaded.',
        'it': 'È possibile caricare solo file immagine.',
        'de': 'Es können nur Bilddateien hochgeladen werden.',
        'es': 'Solo se pueden subir archivos de imagen.',
        'fr': 'Seuls les fichiers image peuvent être téléchargés.',
        'ko': '이미지 파일만 업로드할 수 있습니다.',
        'zh': '僅支援上傳圖片檔案。',
        'zh-TW': '仅支持上传图片文件。',
      },
      '動画視聴': {
        'en': 'Watching videos',
        'it': 'Guardare video',
        'de': 'Videos ansehen',
        'es': 'Ver vídeos',
        'fr': 'Regarder des vidéos',
        'ko': '동영상 시청',
        'zh': '觀看影片',
        'zh-TW': '观看视频',
      },
      'コイン還元': {
        'en': 'Coin Cashback',
        'it': 'Coin Cashback',
        'de': 'Münz-Cashback',
        'es': 'Reembolso en efectivo de monedas',
        'fr': 'Remboursement en pièces',
        'ko': '동전 환원',
        'zh': 'Coin Cashback',
        'zh-TW': 'Coin Cashback',
      },
      '購入': {
        'en': 'Buy',
        'it': 'Compra',
        'de': 'Kaufen',
        'es': 'Köp',
        'fr': 'Acheter',
        'ko': '구매',
        'zh': '購買',
        'zh-TW': '购买',
      },
      '未選択': {
        'en': 'Not selected',
        'it': 'Non selezionato',
        'de': 'Nicht ausgewählt',
        'es': 'No seleccionado',
        'fr': 'Non sélectionné',
        'ko': '선택되지 않음',
        'zh': '未選擇',
        'zh-TW': '未选择',
      },
      '発送なし': {
        'en': 'No shipping',
        'it': 'Nessuna spedizione',
        'de': 'Kein Versand',
        'es': 'No se realizan envíos',
        'fr': 'Pas d\'expédition',
        'ko': '배송 없음',
        'zh': '不出貨',
        'zh-TW': '不发货',
      },
      '発送済み': {
        'en': 'Shipped',
        'it': 'Spedito',
        'de': 'Versand',
        'es': 'Enviado',
        'fr': 'Expédié',
        'ko': '배송됨',
        'zh': '已出貨',
        'zh-TW': '已发货',
      },
      '※発送先のご住所は初めて発送依頼いただく際にご登録いただきます': {
        'en': '*Your shipping address will be registered when you make your first shipping request.',
        'it': '*Il tuo indirizzo di spedizione verrà registrato al momento della prima richiesta di spedizione.',
        'de': '*Ihre Lieferadresse wird bei Ihrer ersten Lieferanfrage registriert.',
        'es': '*Tu dirección de envío quedará registrada cuando realices tu primera solicitud de envío.',
        'fr': '*Votre adresse de livraison sera enregistrée lors de votre première demande d\'expédition.',
        'ko': '※발송처의 주소는 처음 발송 의뢰할 때에 등록해 주십니다',
        'zh': '*您的收貨地址將在您首次提交出貨請求時登記。',
        'zh-TW': '*您的收货地址将在您首次提交发货请求时登记。',
      },
      '%d日': {
        'en': '%d days',
        'it': '%d giorni',
        'de': '%d Tage',
        'es': '%d días',
        'fr': '%d jours',
        'ko': '%d일',
        'zh': '%d 天',
        'zh-TW': '%d 天',
      },
      'まで販売': {
        'en': 'Sales until',
        'it': 'Saldi fino a',
        'de': 'Verkäufe bis',
        'es': 'Ventas hasta',
        'fr': 'Ventes jusqu\'à',
        'ko': '까지 판매',
        'zh': '銷售至',
        'zh-TW': '销售至',
      },
      '{year}/{month}/{day} まで販売': {
        'en': 'On sale until {month}/{day}/{year} JST',
        'it': 'Saldi fino al {day}/{month}/{year} JST',
        'de': 'Verkauf bis {day}/{month}/{year} JST',
        'es': 'Oferta hasta {day}/{month}/{year} JST',
        'fr': 'Vente jusqu\'à {day}/{month}/{year} JST',
        'ko': '{year}/{month}/{day} 까지 판매 JST',
        'zh': '促銷至 {year}/{month}/{day} JST',
        'zh-TW': '促销至 {year}/{month}/{day} JST',
      },
      '個人情報を変更希望の際は、チャットにてお問い合わせください': {
        'en': 'If you wish to change your personal information, please contact us via chat.',
        'it': 'Se desideri modificare i tuoi dati personali, contattaci tramite chat.',
        'de': 'Wenn Sie Ihre persönlichen Daten ändern möchten, kontaktieren Sie uns bitte per Chat.',
        'es': 'Si desea cambiar su información personal, contáctenos a través del chat.',
        'fr': 'Si vous souhaitez modifier vos informations personnelles, veuillez nous contacter par chat.',
        'ko': '개인 정보를 변경하고 싶을 때는 채팅으로 문의하십시오.',
        'zh': '如果您想更改您的個人訊息，請透過聊天與我們聯繫。',
        'zh-TW': '如果您想更改您的个人信息，请通过聊天联系我们。',
      },
      '詳細へ': {
        'en': 'Detail',
        'it': 'dettaglio',
        'de': 'Detail',
        'es': 'detalle',
        'fr': 'détail',
        'ko': '상세',
        'zh': '細節',
        'zh-TW': '细节',
      },
      '%d回限定': {
        'en': 'Limited to %d times',
        'it': 'Limitato a %d volte',
        'de': 'Beschränkt auf %d Mal',
        'es': 'Limitado a %d veces',
        'fr': 'Limité à %d fois',
        'ko': '%d회 한정',
        'zh': '限時 %d 次',
        'zh-TW': '限时 %d 次',
      },
      '株式会社ゼロプレイス': {
        'en': 'Xero Place Co., Ltd.',
        'it': 'Xero Place Co., Ltd.',
        'de': 'Xero Place Co., Ltd.',
        'es': 'Compañía Xero Place, Ltd.',
        'fr': 'Xero Place Co., Ltd.',
        'ko': '주식회사 제로 플레이스',
        'zh': '零點有限公司',
        'zh-TW': '零点有限公司',
      },
      'Xero Place Co., Ltd.': {
        'en': 'Xero Place Co., Ltd.',
        'it': 'Xero Place Co., Ltd.',
        'de': 'Xero Place Co., Ltd.',
        'es': 'Compañía Xero Place, Ltd.',
        'fr': 'Xero Place Co., Ltd.',
        'ko': 'Xero Place Co., Ltd.',
        'zh': 'Xero Place有限公司',
        'zh-TW': 'Xero Place有限公司',
      },
      '〒330-0854': {
        'en': '〒330-0854',
        'it': '〒330-0854',
        'de': '〒330-0854',
        'es': '〒330-0854',
        'fr': '〒330-0854',
        'ko': '〒330-0854',
        'zh': '〒330-0854',
        'zh-TW': '〒330-0854',
      },
      '埼玉県さいたま市大宮区桜木町1丁目195‑1': {
        'en': '1-195-1 Sakuragicho, Omiya Ward, Saitama City, Saitama Prefecture',
        'it': '1-195-1 Sakuragicho, Omiya Ward, Saitama City, Saitama Prefecture',
        'de': '1-195-1 Sakuragicho, Omiya-ku, Saitama-Stadt, Präfektur Saitama',
        'es': '1-195-1 Sakuragicho, Distrito de Omiya, Ciudad de Saitama, Prefectura de Saitama',
        'fr': '1-195-1 Sakuragicho, arrondissement d\'Omiya, ville de Saitama, préfecture de Saitama',
        'ko': '사이타마현 사이타마시 오미야구 사쿠라기초 1가 195-1',
        'zh': '埼玉縣埼玉市大宮區櫻木町1-195-1',
        'zh-TW': '埼玉县埼玉市大宫区樱木町1-195-1',
      },
      '大宮ソラミチKOZ4階': {
        'en': 'Omiya Soramichi KOZ 4th floor Xero Place Co., Ltd. Purchase Reception',
        'it': 'Omiya Soramichi KOZ 4° piano Xero Place Co., Ltd. Ricevimento acquisti',
        'de': 'Omiya Soramichi KOZ 4. Stock Xero Place Co., Ltd. Einkaufsannahme',
        'es': 'Recepción de compra de Omiya Soramichi KOZ, 4.º piso, Xero Place Co., Ltd.',
        'fr': 'Omiya Soramichi KOZ 4e étage Xero Place Co., Ltd. Réception des achats',
        'ko': '오미야 소라미치 KOS 4층 주식회사 제로 플레이스 매입 접수 담당 앞',
        'zh': '大宮空道 KOZ 4樓 Xero Place Co., Ltd. 採購接待處',
        'zh-TW': '大宫空道 KOZ 4楼 Zero Place Co., Ltd. 采购接待处',
      },
      '大宮ソラミチKOZ4階　株式会社ゼロプレイス　買取受付担当宛': {
        'en': 'TEL : +81 50-1724-5360',
        'it': 'TEL : +81 50-1724-5360',
        'de': 'TEL : +81 50-1724-5360',
        'es': 'TELÉFONO: +81 50-1724-5360',
        'fr': 'TÉL  : +81 50-1724-5360',
        'ko': 'TEL  : +81 50-1724-5360',
        'zh': '電話：+81 50-1724-5360',
        'zh-TW': '电话：+81 50-1724-5360',
      },
      'TEL：050-1724-5360': {
        'en': 'TEL : +81 50-1724-5360',
        'it': 'TEL : +81 50-1724-5360',
        'de': 'TEL : +81 50-1724-5360',
        'es': 'TELÉFONO: +81 50-1724-5360',
        'fr': 'TÉL  : +81 50-1724-5360',
        'ko': 'TEL  : +81 50-1724-5360',
        'zh': '電話：+81 50-1724-5360',
        'zh-TW': '电话：+81 50-1724-5360',
      },
      '{year}/{month}/{day} 以降の登録': {
        'en': 'Registration after {month}/{day}/{year}',
        'it': 'Registrazione dopo {day}/{month}/{year}',
        'de': 'Registrierung nach {day}/{month}/{year}',
        'es': 'Registro después de {day}/{month}/{year}',
        'fr': 'Inscription après {day}/{month}/{year}',
        'ko': '{year}/{month}/{day} 이후 등록',
        'zh': '{year}/{month}/{day}後註冊',
        'zh-TW': '{year}/{month}/{day}后注册',
      },
      '{year}/{month}/{day} 以前の登録': {
        'en': 'Registrations before {month}/{day}/{year}',
        'it': 'Registrazioni prima di {day}/{month}/{year}',
        'de': 'Anmeldungen vor {day}/{month}/{year}',
        'es': 'Inscripciones antes de {day}/{month}/{year}',
        'fr': 'Inscriptions avant {day}/{month}/{year}',
        'ko': '{year}/{month}/{day} 이전 등록',
        'zh': '{year}/{month}/{day}之前註冊',
        'zh-TW': '{year}/{month}/{day}之前注册',
      },
      '今月{amount}コイン以上決済された方限定': {
        'en': 'This month\'s {amount} spenders',
        'it': 'Chi ha speso {amount} di questo mese',
        'de': 'Die {amount}-Ausgaben dieses Monats',
        'es': 'Quienes gastaron {amount} este mes',
        'fr': 'Les {amount} dépenses de ce mois-ci',
        'ko': '이번 달 {amount}Coins 이상 결제된 분 한정',
        'zh': '僅限本月支付超過 {amount}Coins 的用戶',
        'zh-TW': '仅限本月已充值{amount}枚金币或以上的用户。',
      },
      '所持{amount}コイン以下の方限定': {
        'en': '{amount} Coins or less',
        'it': ' {amount} monete o meno',
        'de': '{amount} Münzen oder weniger',
        'es': ' {amount} monedas o menos',
        'fr': '{amount} pièces ou moins',
        'ko': '소지 {amount}Coins 이하의 분 한정',
        'zh': '僅限擁有 {amount} 金幣或更少的人',
        'zh-TW': '仅限拥有{amount}枚硬币或更少硬币的用户。',
      },
      '1日%d回限定': {
        'en': 'Limited to %d times per day',
        'it': 'Limitato a %d volte al giorno',
        'de': 'Beschränkt auf %d Mal pro Tag',
        'es': 'Limitado a %d veces al día.',
        'fr': 'Limité à %d fois par jour',
        'ko': '1일 %d회 한정',
        'zh': '每天限用 %d 次',
        'zh-TW': '每天限用 %d 次',
      },
      '言語': {
        'en': 'language',
        'it': 'lingua',
        'de': 'Sprache',
        'es': 'idioma',
        'fr': 'langue',
        'ko': '언어',
        'zh': '語言',
        'zh-TW': '语言',
      },
      '言語を選択してください': {
        'en': 'Please select a language.',
        'it': 'Seleziona una lingua.',
        'de': 'Bitte wählen Sie eine Sprache.',
        'es': 'Por favor, seleccione un idioma.',
        'fr': 'Veuillez sélectionner une langue.',
        'ko': '언어를 선택하세요',
        'zh': '請選擇一種語言。',
        'zh-TW': '请选择一种语言。',
      },
      '未選択一覧': {
        'en': 'Unselected list',
        'it': 'Elenco dei non selezionati',
        'de': 'Nicht ausgewählte Liste',
        'es': 'Lista no seleccionada',
        'fr': 'Liste non sélectionnée',
        'ko': '선택되지 않은 목록',
        'zh': '未選取列表',
        'zh-TW': '未选中列表',
      },
      '¥': {
        'en': '¥',
        'it': '¥',
        'de': '¥',
        'es': '¥',
        'fr': '¥',
        'ko': '¥',
        'zh': '¥',
        'zh-TW': '¥',
      },
      'システムエラーが発生しました。': {
        'en': 'A system error has occurred.',
        'it': 'Si è verificato un errore di sistema.',
        'de': 'Es ist ein Systemfehler aufgetreten.',
        'es': 'Se ha producido un error del sistema.',
        'fr': 'Une erreur système s\'est produite.',
        'ko': '시스템 오류가 발생했습니다.',
        'zh': '系統發生錯誤。',
        'zh-TW': '系统发生错误。',
      },
      '発送済み一覧': {
        'en': 'Shipped Items List',
        'it': 'Elenco degli articoli spediti',
        'de': 'Liste der versendeten Artikel',
        'es': 'Lista de artículos enviados',
        'fr': 'Liste des articles expédiés',
        'ko': '배송된 목록',
        'zh': '已出貨物品清單',
        'zh-TW': '已发货物品清单',
      },
      '選択する': {
        'en': 'Select',
        'it': 'Selezionare',
        'de': 'Wählen',
        'es': 'Seleccionar',
        'fr': 'Sélectionner',
        'ko': '선택하다',
        'zh': '選擇',
        'zh-TW': '选择',
      },
      '1タップで「発送依頼」': {
        'en': '"Request Shipping" with one tap',
        'it': '"Richiedi la spedizione" con un solo tocco',
        'de': '„Versand anfordern“ mit einem Fingertipp',
        'es': '"Solicitar envío" con un solo toque',
        'fr': '« Demander l\'expédition » en un seul clic',
        'ko': '1 탭으로 「발송 의뢰」',
        'zh': '一鍵“請求發貨”',
        'zh-TW': '一键“请求发货”',
      },
      '2タップで「X marketで販売」（近日公開）となります。': {
        'en': 'Two taps will take you to "Sell on X market" (coming soon).',
        'it': 'Con due tocchi potrai accedere alla sezione "Vendi sul mercato X" (disponibile a breve).',
        'de': 'Mit zwei Klicks gelangen Sie zu „Auf dem X-Markt verkaufen“ (demnächst verfügbar).',
        'es': 'Dos toques te llevarán a "Vender en el mercado X" (próximamente).',
        'fr': 'Deux clics vous mèneront à « Vendre sur le marché X » (bientôt disponible).',
        'ko': '2 탭으로 「X market에서 판매」(곧 공개)가 됩니다.',
        'zh': '輕點兩下即可進入「在 X 市場出售」（即將推出）。',
        'zh-TW': '轻点两下即可进入“在 X 市场出售”（即将推出）。',
      },
      '本商品の内容は全て非公開となります。': {
        'en': 'The contents of this gtcha are all secret.',
        'it': 'Il contenuto di questo gtcha è tutto segreto.',
        'de': 'Der Inhalt dieses gtcha ist streng geheim.',
        'es': 'Innehållet i denna gtcha är hemligt.',
        'fr': 'Le contenu de ce gtcha est entièrement secret.',
        'ko': '이 gtcha의 내용은 모두 비밀입니다.',
        'zh': '此 gtcha 的內容都是秘密。',
        'zh-TW': '此验证码的内容都是秘密。',
      },
      '視聴上限人数を超えました': {
        'en': 'The maximum number of viewers has been exceeded',
        'it': 'È stato superato il numero massimo di spettatori',
        'de': 'Die maximale Zuschauerzahl wurde überschritten',
        'es': 'Se ha superado el número máximo de espectadores.',
        'fr': 'Le nombre maximum de spectateurs a été dépassé',
        'ko': '시청 상한 인원을 초과했습니다.',
        'zh': '已超過最大觀看人數',
        'zh-TW': '已超过最大观看人数',
      },
      '詳細はこちら': {
        'en': 'Detail',
        'it': 'dettaglio',
        'de': 'Detail',
        'es': 'detalle',
        'fr': 'détail',
        'ko': '상세',
        'zh': '細節',
        'zh-TW': '细节',
      },
      '買取コイン': {
        'en': 'when you sold it to us',
        'it': 'quando ce lo hai venduto',
        'de': 'als Sie es an uns verkauft haben',
        'es': 'cuando nos lo vendiste',
        'fr': 'quand tu nous l\'as vendu',
        'ko': '우리에게 팔았을 때',
        'zh': '當你把它賣給我們時',
        'zh-TW': '当你把它卖给我们时',
      },
      'コインへ還元': {
        'en': 'To coin',
        'it': 'Coniare',
        'de': 'Prägen',
        'es': 'Att mynta',
        'fr': 'Inventer',
        'ko': '만들다',
        'zh': '創造詞語',
        'zh-TW': '创造',
      },
      '買取ボーナス': {
        'en': 'Bonus to sell to us',
        'it': 'Bonus da vendere a noi',
        'de': 'Bonus für den Verkauf an uns',
        'es': 'Bono por vendernos',
        'fr': 'Bonus à nous vendre',
        'ko': '우리에게 판매하는 보너스',
        'zh': '賣給我們的獎金',
        'zh-TW': '卖给我们的奖金',
      },
      'ログイン状態を保持する': {
        'en': 'Stay logged in',
        'it': 'Rimani connesso',
        'de': 'Bleiben Sie eingeloggt',
        'es': 'Manténgase conectado',
        'fr': 'Restez connecté',
        'ko': '로그인 상태 유지',
        'zh': '保持登入狀態',
        'zh-TW': '保持登录状态',
      },
      'パスワードをお忘れですか？': {
        'en': 'Forgot your password?',
        'it': 'Hai dimenticato la password?',
        'de': 'Passwort vergessen?',
        'es': '¿Olvidaste tu contraseña?',
        'fr': 'Vous avez oublié votre mot de passe ?',
        'ko': '비밀번호를 잊으셨습니까?',
        'zh': '忘記密碼了嗎？',
        'zh-TW': '忘记密码了吗？',
      },
      '姓': {
        'en': 'Last name',
        'it': 'Cognome',
        'de': 'Nachname',
        'es': 'Apellido',
        'fr': 'Nom de famille',
        'ko': '성',
        'zh': '姓',
        'zh-TW': '姓',
      },
      'ミドルネーム': {
        'en': 'middle name',
        'it': 'secondo nome',
        'de': 'zweiter Vorname',
        'es': 'segundo nombre',
        'fr': 'deuxième prénom',
        'ko': '중간 이름',
        'zh': '中間名字',
        'zh-TW': '中间名字',
      },
      '名': {
        'en': 'first name',
        'it': 'nome di battesimo',
        'de': 'Vorname',
        'es': 'nombre de pila',
        'fr': 'prénom',
        'ko': '첫 번째 이름',
        'zh': '名',
        'zh-TW': '名',
      },
      'パスワード確認': {
        'en': 'Confirm password',
        'it': 'Conferma password',
        'de': 'Passwort bestätigen',
        'es': 'Confirmar Contraseña',
        'fr': 'Confirmez le mot de passe',
        'ko': '비밀번호 확인',
        'zh': '確認密碼',
        'zh-TW': '确认密码',
      },
      '友達紹介コードを持っている': {
        'en': 'I have a friend referral code',
        'it': 'Ho un codice di invito amico',
        'de': 'Ich habe einen Freundesempfehlungscode.',
        'es': 'Tengo un código de referencia de un amigo.',
        'fr': 'J\'ai un code de parrainage d\'ami',
        'ko': '친구 소개 코드를 가지고',
        'zh': '我有一個朋友推薦碼',
        'zh-TW': '我有一个朋友推荐码',
      },
      '遊戯王': {
        'en': 'Yu-Gi-Oh!',
        'it': 'Yu-Gi-Oh!',
        'de': 'Yu-Gi-Oh!',
        'es': 'Yu-Gi-Oh!',
        'fr': 'Yu-Gi-Oh!',
        'ko': 'Yu-Gi-Oh!',
        'zh': 'Yu-Gi-Oh!',
        'zh-TW': 'Yu-Gi-Oh!',
      },
      'ヴァイスシュバルツ': {
        'en': 'Weiss Schwarz',
        'it': 'Weiss Schwarz',
        'de': 'Weiss Schwarz',
        'es': 'Weiss Schwarz',
        'fr': 'Weiss Schwarz',
        'ko': 'Weiss Schwarz',
        'zh': 'Weiss Schwarz',
        'zh-TW': 'Weiss Schwarz',
      },
      'ワンピース': {
        'en': 'One piece',
        'it': 'One piece',
        'de': 'One piece',
        'es': 'One piece',
        'fr': 'One piece',
        'ko': 'One piece',
        'zh': 'One piece',
        'zh-TW': 'One piece',
      },
      'ポケモン': {
        'en': 'Pokémon',
        'it': 'Pokémon',
        'de': 'Pokémon',
        'es': 'Pokémon',
        'fr': 'Pokémon',
        'ko': 'Pokémon',
        'zh': 'Pokémon',
        'zh-TW': 'Pokémon',
      },
      '※現金+査定額の1%分のコイン': {
        'en': '*Cash + 1% of the appraised value in coins',
        'it': '*Contanti + l\'1% del valore stimato in monete',
        'de': '*Bargeld + 1 % des Schätzwertes in Münzen',
        'es': '*Efectivo + 1% del valor tasado en monedas',
        'fr': '*Espèces + 1 % de la valeur estimée en pièces',
        'ko': '※현금+사정액의 1%분의 코인',
        'zh': '*現金 + 評估價值的 1%（以硬幣形式支付）',
        'zh-TW': '*现金 + 评估价值的 1%（以硬币形式支付）',
      },
      '※査定額の110%分のコイン': {
        'en': '*Coins equivalent to 110% of the appraised value',
        'it': '*Monete equivalenti al 110% del valore stimato',
        'de': '*Münzen im Wert von 110 % des Schätzwertes',
        'es': '*Monedas equivalentes al 110% del valor tasado',
        'fr': '*Pièces équivalentes à 110 % de la valeur estimée',
        'ko': '※사정액의 110%분의 코인',
        'zh': '*相當於評估價值110%的硬幣',
        'zh-TW': '*相当于评估价值110%的硬币',
      },
      'パスワード': {
        'en': 'password',
        'it': 'password',
        'de': 'Passwort',
        'es': 'contraseña',
        'fr': 'mot de passe',
        'ko': '비밀번호',
        'zh': '密碼',
        'zh-TW': '密码',
      },
      '現在のランクは「{rank}」です。': {
        'en': 'Current rank is "{rank}".',
        'it': 'Il rango attuale è "{rank}".',
        'de': 'Der aktuelle Rang ist „{rank}“.',
        'es': 'La clasificación actual es "{rank}".',
        'fr': 'Le classement actuel est "{rank}".',
        'ko': '현재 순위는 \'{rank}\'입니다.',
        'zh': '目前排名是“{rank}”。',
        'zh-TW': '当前排名是“{rank}”。',
      },
      'コインを使用しない場合、来月は「{rank}」ランクになります。': {
        'en': 'If you do not use Coin, you will be ranked as "White" next month.',
        'it': 'Se non usi le tue monete, sarai classificato "bianco" il mese prossimo.',
        'de': 'Wenn Sie Ihre Münzen nicht verwenden, werden Sie nächsten Monat als „weiß“ eingestuft.',
        'es': 'Si no usas tus monedas, serás clasificado como "blanco" el próximo mes.',
        'fr': 'Si vous n\'utilisez pas vos pièces, vous serez classé « blanc » le mois prochain.',
        'ko': '코인을 사용하지 않으면 다음 달은 "화이트"랭크가됩니다.',
        'zh': '如果你不使用你的硬幣，你將在下個月被評為「白」。',
        'zh-TW': '如果你不使用你的硬币，你将在下个月被评为“白”。',
      },
      '来月、「{rank}」からスタートするには {amount} コインが必要です。': {
        'en': 'You will need {amount} Coins to start at "{rank}" next month.',
        'it': 'Avrai bisogno di {importo} monete per iniziare da "{rank}" il mese prossimo.',
        'de': 'Sie benötigen {amount} Münzen, um nächsten Monat bei „{rank}“ zu beginnen.',
        'es': 'Necesitará {amount} monedas para comenzar en "{rank}" el próximo mes.',
        'fr': 'Vous aurez besoin de {amount} Coins pour commencer à "{rank}" le mois prochain.',
        'ko': '다음 달 "{rank}"에서 시작하려면 {amount} Coins가 필요합니다.',
        'zh': '您將需要 {amount} 金幣才能在下個月達到「{rank}」。',
        'zh-TW': '您将需要 {amount} 金币才能在下个月达到“{rank}”。',
      },
      'すでにランク維持を完了しています。': {
        'en': 'You have already completed rank maintenance.',
        'it': 'Hai già completato il mantenimento del grado.',
        'de': 'Sie haben die Rangerhaltung bereits abgeschlossen.',
        'es': 'Ya has completado el mantenimiento de rango.',
        'fr': 'Vous avez déjà terminé le maintien du rang.',
        'ko': '이미 순위 유지를 완료했습니다.',
        'zh': '您已經完成了等級維護。',
        'zh-TW': '您已经完成了等级维护。',
      },
      '未選択のお品物は24時間でコインへ自動変換されます': {
        'en': 'Unselected items will be automatically converted to coins within 24 hours.',
        'it': 'Gli oggetti non selezionati verranno automaticamente convertiti in monete entro 24 ore.',
        'de': 'Nicht ausgewählte Artikel werden innerhalb von 24 Stunden automatisch in Münzen umgewandelt.',
        'es': 'Los artículos no seleccionados se convertirán automáticamente en monedas dentro de las 24 horas.',
        'fr': 'Les éléments non sélectionnés seront automatiquement convertis en pièces dans les 24 heures.',
        'ko': '선택되지 않은 상품은 24시간 내에 동전으로 자동 변환됩니다.',
        'zh': '未選擇的物品將在24小時內自動轉換為金幣。',
        'zh-TW': '未选择的物品将在24小时内自动转换为金币。',
      },
      'ランク維持してよろしいですか': {
        'en': 'Is it alright to maintain my current rank?',
        'it': 'Posso mantenere il mio grado attuale?',
        'de': 'Ist es in Ordnung, meinen aktuellen Rang beizubehalten?',
        'es': '¿Puedo mantener mi rango actual?',
        'fr': 'Est-ce que je peux conserver mon grade actuel ?',
        'ko': '순위를 유지하시겠습니까?',
        'zh': '我可以維持目前的軍階嗎？',
        'zh-TW': '我可以维持目前的军衔吗？',
      },
      'ランク維持確認': {
        'en': 'Rank maintenance confirmation',
        'it': 'Conferma del mantenimento del grado',
        'de': 'Bestätigung der Rangbeibehaltung',
        'es': 'confirmación de mantenimiento de rango',
        'fr': 'confirmation de maintien de grade',
        'ko': '랭크 유지 확인',
        'zh': '等級維持確認',
        'zh-TW': '等级维持确认',
      },
      '支払う': {
        'en': 'pay',
        'it': 'paga',
        'de': 'zahlen',
        'es': 'pagar',
        'fr': 'payer',
        'ko': '지불하다',
        'zh': '支付',
        'zh-TW': '支付',
      },
      'ランク維持': {
        'en': 'Maintain rank',
        'it': 'Mantenere la posizione',
        'de': 'Rang beibehalten',
        'es': 'Mantener el rango',
        'fr': 'Maintenir son rang',
        'ko': '랭크 유지',
        'zh': '保持排名',
        'zh-TW': '保持排名',
      },
      'ランク維持が完了しました': {
        'en': 'Rank maintenance completed.',
        'it': 'Mantenimento del grado completato',
        'de': 'Rangpflege abgeschlossen',
        'es': 'Mantenimiento de rango completado',
        'fr': 'Maintien du classement terminé',
        'ko': '순위 유지가 완료되었습니다.',
        'zh': '等級維護完成',
        'zh-TW': '等级维护完成',
      },
      '{num}枚セット': {
        'en': '{num} pieces set',
        'it': '{num} pezzi impostati',
        'de': '{num} Teilesatz',
        'es': 'conjunto de {num} piezas',
        'fr': 'Ensemble de {num} pièces',
        'ko': '{num}매 세트',
        'zh': '{num} 件套裝',
        'zh-TW': '{num} 件套装',
      },
      '州': {
        'en': 'state',
        'it': 'stato',
        'de': 'Zustand',
        'es': 'estado',
        'fr': 'État',
        'ko': '주',
        'zh': '狀態',
        'zh-TW': '状态',
      },
      'この販売者のガチャ一覧': {
        'en': 'This seller\'s gacha list',
        'it': 'Lista gacha di questo venditore',
        'de': 'Gacha-Liste dieses Verkäufers',
        'es': 'Lista de gacha de este vendedor',
        'fr': 'Liste gacha de ce vendeur',
        'ko': '이 판매자의 뽑기 목록',
        'zh': '該賣家的扭蛋列表',
        'zh-TW': '该卖家的扭蛋列表',
      },
      'まだ販売されている商品がありません': {
        'en': 'There are no products currently available for sale.',
        'it': 'Al momento non ci sono prodotti disponibili per la vendita.',
        'de': 'Es sind derzeit keine Produkte zum Verkauf verfügbar.',
        'es': 'Actualmente no hay productos disponibles para la venta.',
        'fr': 'Aucun produit n\'est actuellement disponible à la vente.',
        'ko': '아직 판매되는 상품이 없습니다.',
        'zh': '目前沒有可供出售的產品。',
        'zh-TW': '目前没有可供出售的产品。',
      },
      '入力情報を確認': {
        'en': 'Confirm input information',
        'it': 'Conferma le informazioni inserite',
        'de': 'Eingabeinformationen bestätigen',
        'es': 'Confirme la información ingresada',
        'fr': 'Confirmer les informations saisies',
        'ko': '입력 정보 확인',
        'zh': '確認輸入訊息',
        'zh-TW': '确认输入信息',
      },
      '送信': {
        'en': 'send',
        'it': 'Inviare',
        'de': 'schicken',
        'es': 'enviar',
        'fr': 'envoyer',
        'ko': '전송',
        'zh': '傳送',
        'zh-TW': '发送',
      },
      '販売者一覧': {
        'en': 'List of sellers',
        'it': 'Elenco dei venditori',
        'de': 'Liste der Verkäufer',
        'es': 'Lista de vendedores',
        'fr': 'Liste des vendeurs',
        'ko': '판매자 목록',
        'zh': '賣家列表',
        'zh-TW': '卖家列表',
      },
      'ホビー系': {
        'en': 'Hobby-related',
        'it': 'Legato agli hobby',
        'de': 'Hobbybezogen',
        'es': 'Relacionado con pasatiempos',
        'fr': 'lié aux loisirs',
        'ko': '취미계',
        'zh': '與嗜好相關的',
        'zh-TW': '与爱好相关的',
      },
      'アイドル': {
        'en': 'idol',
        'it': 'idolo',
        'de': 'Idol',
        'es': 'ídolo',
        'fr': 'idole',
        'ko': '아이돌',
        'zh': '偶像',
        'zh-TW': '偶像',
      },
      'お酒': {
        'en': 'alcohol',
        'it': 'alcol',
        'de': 'Alkohol',
        'es': 'alcohol',
        'fr': 'alcool',
        'ko': '술',
        'zh': '酒精',
        'zh-TW': '酒精',
      },
      '電子機器': {
        'en': 'electronic equipment',
        'it': 'apparecchiature elettroniche',
        'de': 'elektronische Geräte',
        'es': 'equipos electrónicos',
        'fr': 'équipement électronique',
        'ko': '전자기기',
        'zh': '電子設備',
        'zh-TW': '电子设备',
      },
      '釣り': {
        'en': 'fishing',
        'it': 'pesca',
        'de': 'Angeln',
        'es': 'pesca',
        'fr': 'pêche',
        'ko': '낚시',
        'zh': '釣魚',
        'zh-TW': '钓鱼',
      },
      '宝石': {
        'en': 'jewelry ',
        'it': 'gioielli',
        'de': 'Schmuck',
        'es': 'joyas ',
        'fr': 'bijoux ',
        'ko': '보석',
        'zh': '珠寶',
        'zh-TW': '珠宝 ',
      },
      '食べ物': {
        'en': 'food',
        'it': 'cibo',
        'de': 'Essen',
        'es': 'alimento',
        'fr': 'nourriture',
        'ko': '음식',
        'zh': '食物',
        'zh-TW': '食物',
      },
      'ご当地': {
        'en': 'Local',
        'it': 'Locale',
        'de': 'Lokal',
        'es': 'Local',
        'fr': 'Locale',
        'ko': '현지',
        'zh': '當地的',
        'zh-TW': '当地的',
      },
      'アニメ': {
        'en': 'anime',
        'it': 'canzoni',
        'de': 'Anime',
        'es': 'anime',
        'fr': 'anime',
        'ko': '애니메이션',
        'zh': '日本卡通',
        'zh-TW': '日本动画片',
      },
      'スニーカー': {
        'en': 'sneakers',
        'it': 'scarpe da ginnastica',
        'de': 'Turnschuhe',
        'es': 'zapatillas',
        'fr': 'baskets',
        'ko': '운동화',
        'zh': '運動鞋',
        'zh-TW': '运动鞋',
      },
      'ブランド': {
        'en': 'brand',
        'it': 'marca',
        'de': 'Marke',
        'es': 'marca',
        'fr': 'marque',
        'ko': '브랜드',
        'zh': '品牌',
        'zh-TW': '品牌',
      },
      'パスワード入力': {
        'en': 'Enter password',
        'it': 'Inserisci la password',
        'de': 'Passwort eingeben',
        'es': 'Introduzca la contraseña',
        'fr': 'Saisissez le mot de passe',
        'ko': '비밀번호 입력',
        'zh': '輸入密碼',
        'zh-TW': '输入密码',
      },
      'パスワードは必須です。': {
        'en': 'A password is required.',
        'it': 'È necessaria una password.',
        'de': 'Ein Passwort ist erforderlich.',
        'es': 'Se requiere una contraseña.',
        'fr': 'Un mot de passe est requis.',
        'ko': '암호는 필수입니다.',
        'zh': '需要密碼。',
        'zh-TW': '需要密码。',
      },
      '商品が見つかりません。': {
        'en': 'The product could not be found.',
        'it': 'Prodotto non trovato.',
        'de': 'Das Produkt konnte nicht gefunden werden.',
        'es': 'No se pudo encontrar el producto.',
        'fr': 'Le produit est introuvable.',
        'ko': '상품을 찾을 수 없습니다.',
        'zh': '找不到該產品。',
        'zh-TW': '找不到该产品。',
      },
      'ログインが必要です。': {
        'en': 'Login is required.',
        'it': 'È necessario effettuare l\'accesso.',
        'de': 'Anmeldung erforderlich.',
        'es': 'Es necesario iniciar sesión.',
        'fr': 'Connexion requise.',
        'ko': '로그인이 필요합니다.',
        'zh': '需要登入。',
        'zh-TW': '需要登录。',
      },
      'パスワードが一致しません。': {
        'en': 'Passwords do not match.',
        'it': 'Le password non corrispondono.',
        'de': 'Die Passwörter stimmen nicht überein.',
        'es': 'Las contraseñas no coinciden.',
        'fr': 'Les mots de passe ne correspondent pas.',
        'ko': '비밀번호가 일치하지 않습니다.',
        'zh': '密碼不符。',
        'zh-TW': '密码不匹配。',
      },
      'パスワードログを保存しました。': {
        'en': 'The password log has been saved.',
        'it': 'Il registro delle password è stato salvato.',
        'de': 'Das Passwortprotokoll wurde gespeichert.',
        'es': 'El registro de contraseñas se ha guardado.',
        'fr': 'Le journal des mots de passe a été enregistré.',
        'ko': '비밀번호 로그를 저장했습니다.',
        'zh': '密碼日誌已儲存。',
        'zh-TW': '密码日志已保存。',
      },
      '株式会社A': {
        'en': 'Company A',
        'it': 'Azienda A',
        'de': 'Firma A',
        'es': 'Compañía A',
        'fr': 'Société A',
        'ko': '주식회사 A',
        'zh': 'A公司',
        'zh-TW': 'A公司',
      },
      'Xmarket出品リスト': {
        'en': 'My Xmarket Sales List',
        'it': 'La mia lista di vendite Xmarket',
        'de': 'Meine Xmarket-Verkaufsliste',
        'es': 'Min Xmarket Försäljningslista',
        'fr': 'Ma liste de ventes Xmarket',
        'ko': '내 Xmarket 판매 목록',
        'zh': '我的 Xmarket 銷售清單',
        'zh-TW': '我的Xmarket销售清单',
      },
      '販売する': {
        'en': 'To sell',
        'it': 'Vendere',
        'de': 'Verkaufen',
        'es': 'Sälja',
        'fr': 'Vendre',
        'ko': '판매하다',
        'zh': '出售',
        'zh-TW': '出售',
      },
      '販売価格を入力してください': {
        'en': 'Selling Price',
        'it': 'Prezzo di vendita',
        'de': 'Verkaufspreis',
        'es': 'Försäljningspris',
        'fr': 'Prix de vente',
        'ko': '판매 가격',
        'zh': '售價',
        'zh-TW': '售价',
      },
      'オークションとしてこの価格からマーケットに出品': {
        'en': 'This price will be used to put the item up for auction on the market.',
        'it': 'Questo prezzo verrà utilizzato per mettere l\'oggetto all\'asta sul mercato.',
        'de': 'Dieser Preis dient als Grundlage für die Versteigerung des Artikels auf dem Markt.',
        'es': 'Este precio se utilizará para subastar el artículo en el mercado.',
        'fr': 'Ce prix servira à mettre l\'article aux enchères sur le marché.',
        'ko': '경매로 이 가격에서 시장에 출품',
        'zh': '這個價格將用於將該物品放到市場上拍賣。',
        'zh-TW': '这个价格将用于将该物品放到市场上拍卖。',
      },
      '%d秒': {
        'en': '%d seconds',
        'it': '%d secondi',
        'de': '%d Sekunden',
        'es': '%d segundos',
        'fr': '%d secondes',
        'ko': '%d초',
        'zh': '%d 秒',
        'zh-TW': '%d 秒',
      },
      '%d分': {
        'en': '%d minutes',
        'it': '%d minuti',
        'de': '%d Minuten',
        'es': '%d minutos',
        'fr': '%d minutes',
        'ko': '%d분',
        'zh': '%d 分鐘',
        'zh-TW': '%d 分钟',
      },
      '%d時間': {
        'en': '%d hours',
        'it': '%d ore',
        'de': '%d Stunden',
        'es': '%d horas',
        'fr': '%d heures',
        'ko': '%d시간',
        'zh': '%d 小時',
        'zh-TW': '%d 小时',
      },
      '金額は{min}円以上になるように設定してください': {
        'en': 'Please set the amount to be at least {min} yen.',
        'it': 'Si prega di impostare l\'importo ad almeno {min} yen.',
        'de': 'Bitte geben Sie einen Betrag von mindestens {min} Yen an.',
        'es': 'Por favor, establezca la cantidad en al menos {min} yenes.',
        'fr': 'Veuillez fixer le montant à au moins {min} yens.',
        'ko': '금액은 {min}엔 이상이 되도록 설정하세요.',
        'zh': '請將金額設定為至少 {min} 日圓。',
        'zh-TW': '请将金额设置为至少 {min} 日元。',
      },
      '小計': {
        'en': 'subtotal',
        'it': 'subtotale',
        'de': 'Zwischensumme',
        'es': 'total parcial',
        'fr': 'total',
        'ko': '소계',
        'zh': '小計',
        'zh-TW': '小计',
      },
      '送料': {
        'en': 'postage',
        'it': 'affrancatura',
        'de': 'Porto',
        'es': 'franqueo',
        'fr': 'affranchissement',
        'ko': '우송료',
        'zh': '郵資',
        'zh-TW': '邮资',
      },
      '合計': {
        'en': 'total',
        'it': 'totale',
        'de': 'gesamt',
        'es': 'total',
        'fr': 'total',
        'ko': '합계',
        'zh': '全部的',
        'zh-TW': '全部的',
      },
      'カート': {
        'en': 'cart',
        'it': 'carrello',
        'de': 'Warenkorb',
        'es': 'carro',
        'fr': 'chariot',
        'ko': '장바구니',
        'zh': '大車',
        'zh-TW': '大车',
      },
      '数量': {
        'en': 'quantity',
        'it': 'quantità',
        'de': 'Menge',
        'es': 'cantidad',
        'fr': 'quantité',
        'ko': '수량',
        'zh': '數量',
        'zh-TW': '数量',
      },
      'カート商品が見つかりません': {
        'en': 'No items found in your cart.',
        'it': 'Nessun articolo trovato nel carrello.',
        'de': 'In Ihrem Warenkorb wurden keine Artikel gefunden.',
        'es': 'No se encontraron artículos en su carrito.',
        'fr': 'Aucun article trouvé dans votre panier.',
        'ko': '장바구니 상품을 찾을 수 없음',
        'zh': '您的購物車中沒有找到商品。',
        'zh-TW': '您的购物车中没有找到商品。',
      },
      '新たにカードを登録する': {
        'en': 'Register a new card',
        'it': 'Registra una nuova carta',
        'de': 'Neue Karte registrieren',
        'es': 'Registra una nueva tarjeta',
        'fr': 'Enregistrer une nouvelle carte',
        'ko': '새 카드 등록',
        'zh': '註冊新卡',
        'zh-TW': '注册新卡',
      },
      'カード情報の保存に失敗しました。(既に登録されているなど)': {
        'en': 'Failed to save card information. (e.g., already registered)',
        'it': 'Impossibile salvare i dati della carta. (ad esempio, carta già registrata)',
        'de': 'Die Karteninformationen konnten nicht gespeichert werden. (z. B. bereits registriert)',
        'es': 'No se pudo guardar la información de la tarjeta. (p. ej., ya está registrada)',
        'fr': 'Impossible d\'enregistrer les informations de la carte. (Par exemple, déjà enregistrée)',
        'ko': '카드 정보를 저장하지 못했습니다. (이미 등록된 등)',
        'zh': '保存卡片資訊失敗。 （例如，已註冊）',
        'zh-TW': '保存卡片信息失败。（例如，已注册）',
      },
      'カード情報の削除に失敗しました。': {
        'en': 'Card information deletion failed.',
        'it': 'L\'eliminazione delle informazioni della carta non è riuscita.',
        'de': 'Das Löschen der Karteninformationen ist fehlgeschlagen.',
        'es': 'No se pudo eliminar la información de la tarjeta.',
        'fr': 'La suppression des informations de la carte a échoué.',
        'ko': '카드 정보를 삭제하지 못했습니다.',
        'zh': '卡片資訊刪除失敗。',
        'zh-TW': '卡片信息删除失败。',
      },
      'このカード情報を保存する': {
        'en': 'Save this card information',
        'it': 'Salva le informazioni di questa carta',
        'de': 'Diese Karteninformationen speichern',
        'es': 'Guarda esta información de la tarjeta',
        'fr': 'Conservez les informations de cette carte',
        'ko': '이 카드 정보 저장',
        'zh': '儲存此卡片訊息',
        'zh-TW': '保存此卡片信息',
      },
      '出金申請': {
        'en': 'Withdrawal application',
        'it': 'Domanda di recesso',
        'de': 'Antrag auf Rücknahme',
        'es': 'Solicitud de desistimiento',
        'fr': 'Demande de retrait',
        'ko': '출금 신청',
        'zh': '提款申請',
        'zh-TW': '提款申请',
      },
      '出金可能額': {
        'en': 'Amount that can be withdrawn',
        'it': 'Importo prelevabile',
        'de': 'Abhebbarer Betrag',
        'es': 'Cantidad que se puede retirar',
        'fr': 'Montant pouvant être retiré',
        'ko': '출금 가능액',
        'zh': '可提取金額',
        'zh-TW': '可提取金额',
      },
      '振込金額': {
        'en': 'Transfer amount',
        'it': 'Importo del trasferimento',
        'de': 'Überweisungsbetrag',
        'es': 'Importe de la transferencia',
        'fr': 'Montant du transfert',
        'ko': '송금 금액',
        'zh': '轉帳金額',
        'zh-TW': '转账金额',
      },
      '振込方法': {
        'en': 'Bank transfer method',
        'it': 'Metodo di bonifico bancario',
        'de': 'Banküberweisungsmethode',
        'es': 'Método de transferencia bancaria',
        'fr': 'méthode de virement bancaire',
        'ko': '송금 방법',
        'zh': '銀行轉帳方式',
        'zh-TW': '银行转账方式',
      },
      '振込額3万円未満は350円の振込手数料がかかります。': {
        'en': 'The receiving fee will be deducted from the sending amount.',
        'it': 'Die Empfangsgebühr wird vom Sendebetrag abgezogen.',
        'de': 'La tarifa de recepción se deducirá del monto de envío.',
        'es': 'Les frais de réception seront déduits du montant de l\'envoi.',
        'fr': '수수료는 송금액보다 공제됩니다.',
        'ko': '接收費用將從發送金額中扣除。',
        'zh': '接收费用将从发送金额中扣除。',
        'zh-TW': '接收费用将从发送金额中扣除。',
      },
      '振込申請日の5営業日後に送金させていただきます。': {
        'en': 'We will transfer the funds five business days after the date of your transfer request.',
        'it': 'Il trasferimento dei fondi avverrà entro cinque giorni lavorativi dalla data della richiesta di bonifico.',
        'de': 'Wir werden die Gelder fünf Werktage nach Eingang Ihres Überweisungsauftrags überweisen.',
        'es': 'Realizaremos la transferencia de fondos cinco días hábiles después de la fecha de su solicitud de transferencia.',
        'fr': 'Nous effectuerons le virement dans les cinq jours ouvrables suivant la date de votre demande de virement.',
        'ko': '송금 신청일의 5 영업일 후에 송금하겠습니다.',
        'zh': '我們將在您提出轉帳請求後的五個工作天內轉帳。',
        'zh-TW': '我们将在您提出转账请求后的五个工作日内转账。',
      },
      '申請する': {
        'en': 'Apply',
        'it': 'Fare domanda a',
        'de': 'Anwenden',
        'es': 'Aplicar',
        'fr': 'Appliquer',
        'ko': '신청하다',
        'zh': '申請',
        'zh-TW': '申请',
      },
      '出金申請履歴': {
        'en': 'Withdrawal request history',
        'it': 'Cronologia delle richieste di prelievo',
        'de': 'Auszahlungsanfragehistorie',
        'es': 'Historial de solicitudes de retiro',
        'fr': 'Historique des demandes de retrait',
        'ko': '출금 신청 이력',
        'zh': '提款申請歷史記錄',
        'zh-TW': '提款申请历史记录',
      },
      '申請日': {
        'en': 'Date',
        'it': 'Data',
        'de': 'Datum',
        'es': 'Datum',
        'fr': 'Date',
        'ko': '날짜',
        'zh': '日期',
        'zh-TW': '日期',
      },
      '振込日': {
        'en': 'Transfer date',
        'it': 'Data di trasferimento',
        'de': 'Übertragungsdatum',
        'es': 'Fecha de transferencia',
        'fr': 'Date de transfert',
        'ko': '송금일',
        'zh': '轉會日期',
        'zh-TW': '转会日期',
      },
      '未振込': {
        'en': 'Unpaid',
        'it': 'Non pagato',
        'de': 'Unbezahlt',
        'es': 'No pagado',
        'fr': 'Non rémunéré',
        'ko': '미송금',
        'zh': '未付',
        'zh-TW': '未付',
      },
      '振込済': {
        'en': 'Payment made',
        'it': 'Pagamento effettuato',
        'de': 'Zahlung erfolgt',
        'es': 'Pago realizado',
        'fr': 'Paiement effectué',
        'ko': '송금',
        'zh': '已付款',
        'zh-TW': '已付款',
      },
      '口座番号': {
        'en': 'account number',
        'it': 'numero di conto',
        'de': 'Kontonummer',
        'es': 'número de cuenta',
        'fr': 'numéro de compte',
        'ko': '계좌 번호',
        'zh': '帳號',
        'zh-TW': '帐号',
      },
      '販売価格を決める': {
        'en': 'To sell',
        'it': 'Vendere',
        'de': 'Verkaufen',
        'es': 'Att sälja',
        'fr': 'Vendre',
        'ko': '판매하다',
        'zh': '出售',
        'zh-TW': '出售',
      },
      '未出品': {
        'en': 'Waiting for sale',
        'it': 'In attesa di vendita',
        'de': 'Warten auf den Verkauf',
        'es': 'Väntar på rea',
        'fr': 'En attente de vente',
        'ko': '세일 기다리는 중',
        'zh': '等待出售',
        'zh-TW': '等待出售',
      },
      '出品待ち/出品中': {
        'en': 'Now on sale',
        'it': 'Ora in vendita',
        'de': 'Jetzt im Angebot',
        'es': 'Nu till salu',
        'fr': 'En vente maintenant',
        'ko': '지금 판매 중',
        'zh': '現正特價',
        'zh-TW': '现正出售',
      },
      '完売': {
        'en': 'Sold out',
        'it': 'Esaurito',
        'de': 'Ausverkauft',
        'es': 'Agotado',
        'fr': 'épuisé',
        'ko': '매진',
        'zh': '售罄',
        'zh-TW': '售罄',
      },
      '全タイトル': {
        'en': 'All Titles',
        'it': 'Tutti i titoli',
        'de': 'Alle Titel',
        'es': 'Todos los títulos',
        'fr': 'Tous les titres',
        'ko': '모든 타이틀',
        'zh': '所有標題',
        'zh-TW': '所有标题',
      },
      '詳細検索': {
        'en': 'Advanced Search',
        'it': 'Ricerca avanzata',
        'de': 'Erweiterte Suche',
        'es': 'Búsqueda avanzada',
        'fr': 'Recherche avancée',
        'ko': '고급 검색',
        'zh': '進階搜尋',
        'zh-TW': '高级搜索',
      },
      '傷あり品を除く': {
        'en': 'Excluding items with damage.',
        'it': 'Sono esclusi gli articoli danneggiati.',
        'de': 'Ausgenommen sind beschädigte Gegenstände.',
        'es': 'Excluyendo artículos dañados.',
        'fr': 'À l\'exception des articles endommagés.',
        'ko': '긁힌 물건을 제외하다',
        'zh': '不包括有損壞的物品。',
        'zh-TW': '不包括有损坏的物品。',
      },
      '傷あり品のみ表示': {
        'en': 'Display only damaged items',
        'it': 'Nur beschädigte Artikel anzeigen',
        'de': 'Mostrar solo artículos dañados',
        'es': 'Afficher uniquement les articles endommagés',
        'fr': '데미지품만 표시',
        'ko': '僅顯示損壞的物品',
        'zh': '仅显示损坏的物品',
        'zh-TW': '仅显示损坏的物品',
      },
      '表示順': {
        'en': 'Display order',
        'it': 'Ordine di visualizzazione',
        'de': 'Anzeigereihenfolge',
        'es': 'Mostrar orden',
        'fr': 'Afficher l\'ordre',
        'ko': '표시 순서',
        'zh': '顯示順序',
        'zh-TW': '显示顺序',
      },
      'キーワード検索': {
        'en': 'Keyword search',
        'it': 'Ricerca per parole chiave',
        'de': 'Stichwortsuche',
        'es': 'Búsqueda por palabras clave',
        'fr': 'Recherche par mots clés',
        'ko': '키워드 검색',
        'zh': '關鍵字搜尋',
        'zh-TW': '关键词搜索',
      },
      '価格が高い順': {
        'en': 'Sort by price (highest first)',
        'it': 'Ordina per prezzo (dal più alto al più basso)',
        'de': 'Nach Preis sortieren (höchster Preis zuerst)',
        'es': 'Ordenar por precio (del más alto al más bajo)',
        'fr': 'Trier par prix (du plus élevé au plus bas)',
        'ko': '가격이 높은 순서',
        'zh': '依價格排序（價格最高排在最前面）',
        'zh-TW': '按价格排序（价格最高排在最前面）',
      },
      '価格が安い順': {
        'en': 'Sort by price (lowest first)',
        'it': 'Ordina per prezzo (dal più basso al più alto)',
        'de': 'Nach Preis sortieren (niedrigster Preis zuerst)',
        'es': 'Ordenar por precio (del más bajo al más alto)',
        'fr': 'Trier par prix (du plus bas au plus bas)',
        'ko': '가격이 싼 순서',
        'zh': '依價格排序（價格最低排在最前面）',
        'zh-TW': '按价格排序（价格最低排在最前面）',
      },
      'クリア': {
        'en': 'Clear',
        'it': 'Chiaro',
        'de': 'Klar',
        'es': 'Claro',
        'fr': 'Clair',
        'ko': '클리어',
        'zh': '清除',
        'zh-TW': '清除',
      },
      '検索': {
        'en': 'Search',
        'it': 'cerca',
        'de': 'suchen',
        'es': 'buscar',
        'fr': 'recherche',
        'ko': '검색',
        'zh': '搜尋',
        'zh-TW': '搜索',
      },
      '販売中のみ表示': {
        'en': 'Only items currently for sale will be displayed.',
        'it': 'Verranno visualizzati solo gli articoli attualmente in vendita.',
        'de': 'Es werden nur Artikel angezeigt, die aktuell zum Verkauf stehen.',
        'es': 'Solo se mostrarán los artículos que estén actualmente a la venta.',
        'fr': 'Seuls les articles actuellement en vente seront affichés.',
        'ko': '판매 중에만 표시',
        'zh': '僅顯示目前在售商品。',
        'zh-TW': '仅显示当前在售商品。',
      },
      'カートへ': {
        'en': 'Buy',
        'it': 'Compra',
        'de': 'Kaufen',
        'es': 'Köp',
        'fr': 'Acheter',
        'ko': '구매',
        'zh': '購買',
        'zh-TW': '购买',
      },
      '終了': {
        'en': 'end',
        'it': 'FINE',
        'de': 'Ende',
        'es': 'fin',
        'fr': 'fin',
        'ko': '종료',
        'zh': '結尾',
        'zh-TW': '结尾',
      },
      '現在': {
        'en': 'the current',
        'it': 'il corrente',
        'de': 'die jetzige',
        'es': 'la corriente',
        'fr': 'le courant',
        'ko': '현재',
        'zh': '目前',
        'zh-TW': '当前',
      },
      '銀行振込': {
        'en': 'Bank transfer',
        'it': 'Bonifico bancario',
        'de': 'Banküberweisung',
        'es': 'Transferencia bancaria',
        'fr': 'Virement bancaire',
        'ko': '은행 송금',
        'zh': '銀行轉帳',
        'zh-TW': '银行转账',
      },
      '申請中': {
        'en': 'Currently applying',
        'it': 'Attualmente in fase di candidatura',
        'de': 'Ich bewerbe mich derzeit.',
        'es': 'Actualmente estoy solicitando',
        'fr': 'Candidature en cours',
        'ko': '신청 중',
        'zh': '目前正在申請',
        'zh-TW': '目前正在申请',
      },
      '保存する': {
        'en': 'Save',
        'it': 'Salva',
        'de': 'Speichern',
        'es': 'Ahorrar',
        'fr': 'Sauvegarder',
        'ko': '저장하다',
        'zh': '節省',
        'zh-TW': '节省',
      },
      'スピード入金を利用する(翌営業日の送金)': {
        'en': 'Use the expedited deposit service (transfer on the next business day)',
        'it': 'Utilizza il servizio di deposito rapido (trasferimento entro il giorno lavorativo successivo).',
        'de': 'Nutzen Sie den Express-Einzahlungsservice (Überweisung am nächsten Werktag).',
        'es': 'Utilice el servicio de depósito exprés (transferencia al siguiente día hábil).',
        'fr': 'Utilisez le service de dépôt express (virement le jour ouvrable suivant).',
        'ko': '스피드 입금을 이용한다(다음 영업일의 송금)',
        'zh': '使用加急存款服務（下一個工作日到帳）',
        'zh-TW': '使用加急存款服务（下一个工作日到账）',
      },
      '振込先情報': {
        'en': 'Bank transfer information',
        'it': 'Informazioni sul bonifico bancario',
        'de': 'Informationen zur Banküberweisung',
        'es': 'Información sobre transferencias bancarias',
        'fr': 'Informations sur les virements bancaires',
        'ko': '송금처 정보',
        'zh': '銀行轉帳資訊',
        'zh-TW': '银行转账信息',
      },
      '削除': {
        'en': 'delete',
        'it': 'eliminare',
        'de': 'löschen',
        'es': 'borrar',
        'fr': 'supprimer',
        'ko': '삭제',
        'zh': '刪除',
        'zh-TW': '删除',
      },
      '申請振込金額': {
        'en': 'Requested Amount',
        'it': 'Importo Richiesto',
        'de': 'Angeforderter Betrag',
        'es': 'Begärd belopp',
        'fr': 'Montant demandé',
        'ko': '요청 금액',
        'zh': '申請金額',
        'zh-TW': '申请金额',
      },
      '申請確認': {
        'en': 'Application confirmation',
        'it': 'Conferma dell\'applicazione',
        'de': 'Antragsbestätigung',
        'es': 'Confirmación de la solicitud',
        'fr': 'Confirmation de la demande',
        'ko': '신청 확인',
        'zh': '申請確認',
        'zh-TW': '申请确认',
      },
      '振込手数料': {
        'en': 'Bank transfer fee',
        'it': 'commissione per bonifico bancario',
        'de': 'Banküberweisungsgebühr',
        'es': 'comisión por transferencia bancaria',
        'fr': 'Frais de virement bancaire',
        'ko': '송금 수수료',
        'zh': '銀行轉帳手續費',
        'zh-TW': '银行转账手续费',
      },
      'ホビー': {
        'en': 'Hobby',
        'it': 'Hobby',
        'de': 'Hobby',
        'es': 'Pasatiempo',
        'fr': 'Passe-temps',
        'ko': '취미',
        'zh': '嗜好',
        'zh-TW': '爱好',
      },
      '選択してください': {
        'en': 'please select',
        'it': 'seleziona',
        'de': 'Bitte auswählen',
        'es': 'Por favor, seleccione',
        'fr': 'Veuillez sélectionner',
        'ko': '선택해 주세요',
        'zh': '請選擇',
        'zh-TW': '请选择',
      },
      'Xmarketのご利用ありがとうございました': {
        'en': 'Thank you for using Xmarket.',
        'it': 'Grazie per aver utilizzato Xmarket.',
        'de': 'Vielen Dank, dass Sie Xmarket nutzen.',
        'es': 'Gracias por usar Xmarket.',
        'fr': 'Merci d\'avoir utilisé Xmarket.',
        'ko': 'Xmarket를 이용해 주셔서 감사합니다.',
        'zh': '感謝您使用Xmarket。',
        'zh-TW': '感谢您使用Xmarket。',
      },
      '購入完了': {
        'en': 'Purchase complete',
        'it': 'Acquisto completato',
        'de': 'Kauf abgeschlossen',
        'es': 'Compra completa',
        'fr': 'Achat complet',
        'ko': '구매 완료',
        'zh': '購買完成',
        'zh-TW': '购买完成',
      },
      '入金済み': {
        'en': 'Payment completed',
        'it': 'Pagamento completato',
        'de': 'Zahlung abgeschlossen',
        'es': 'Betalning slutförd',
        'fr': 'Paiement effectué',
        'ko': '결제 완료',
        'zh': '付款完成',
        'zh-TW': '付款完成',
      },
      'XMarket': {
        'en': 'XMarket',
        'it': 'XMarket',
        'de': 'XMarket',
        'es': 'Mercado X',
        'fr': 'XMarket',
        'ko': 'XMarket',
        'zh': 'XMarket',
        'zh-TW': 'XMarket',
      },
      '申請履歴はありません': {
        'en': 'No application history exists.',
        'it': 'Non esiste alcuna cronologia delle applicazioni.',
        'de': 'Es ist keine Bewerbungshistorie vorhanden.',
        'es': 'No existe historial de solicitudes.',
        'fr': 'Aucun historique de candidature n\'existe.',
        'ko': '신청 내역 없음',
        'zh': '沒有申請記錄。',
        'zh-TW': '没有申请记录。',
      },
      '未入金': {
        'en': 'Unpaid',
        'it': 'Non pagato',
        'de': 'Unbezahlt',
        'es': 'No pagado',
        'fr': 'Non rémunéré',
        'ko': '미입금',
        'zh': '未付',
        'zh-TW': '未付',
      },
      '{min}円以上の価格で出品できます。当該ガチャの販売終了後に出品されます。': {
        'en': 'Items can be sold at a price of {min} yen or more.',
        'it': 'Gli articoli possono essere venduti a un prezzo di {min} yen o più.',
        'de': 'Artikel können zu einem Preis von {min} Yen oder mehr verkauft werden.',
        'es': 'Varor kan säljas till ett pris av {min} yen eller mer.',
        'fr': 'Les articles peuvent être vendus à un prix de {min} yens ou plus.',
        'ko': '품목은 {min} 엔 이상으로 판매할 수 있습니다.',
        'zh': '商品可以以 {min} 日圓或以上的價格出售。',
        'zh-TW': '商品可以以 {min} 日元或以上的价格出售。',
      },
      'パラメータが不足しています': {
        'en': 'The parameter is missing.',
        'it': 'Il parametro è mancante.',
        'de': 'Der Parameter fehlt.',
        'es': 'Falta el parámetro.',
        'fr': 'Le paramètre est manquant.',
        'ko': '매개변수가 부족함',
        'zh': '缺少參數。',
        'zh-TW': '缺少参数。',
      },
      '出品対象外品': {
        'en': 'Cannot be sold to Xmarket',
        'it': 'Non può essere venduto a Xmarket',
        'de': 'Kann nicht an Xmarket verkauft werden.',
        'es': 'No se puede vender a Xmarket',
        'fr': 'Ne peut être vendu à Xmarket',
        'ko': 'Xmarket에 판매 불가',
        'zh': '不得出售給 Xmarket',
        'zh-TW': '不得出售给 Xmarket',
      },
      '購入手続きへ': {
        'en': 'To checkout',
        'it': 'Per il checkout',
        'de': 'Zur Kasse gehen',
        'es': 'To checkout',
        'fr': 'Passer à la caisse',
        'ko': '체크아웃하기',
        'zh': '結帳',
        'zh-TW': '结账',
      },
      '振込金額は351円以上で入力してください。': {
        'en': 'Please enter a transfer amount of 351 yen or more.',
        'it': 'Inserisci un importo di trasferimento pari o superiore a 351 yen.',
        'de': 'Bitte geben Sie einen Überweisungsbetrag von mindestens 351 Yen ein.',
        'es': 'Introduzca un importe de transferencia de 351 yenes o más.',
        'fr': 'Veuillez saisir un montant de transfert de 351 yens ou plus.',
        'ko': '송금 금액은 351엔 이상으로 입력해 주세요.',
        'zh': '請輸入351日圓或以上的轉帳金額。',
        'zh-TW': '请输入351日元或以上的转账金额。',
      },
      '振込金額は10,000円以上で入力してください。': {
        'en': 'Please enter a transfer amount of 10,000 yen or more.',
        'it': 'Inserisci un importo di trasferimento pari o superiore a 10.000 yen.',
        'de': 'Bitte geben Sie einen Überweisungsbetrag von mindestens 10.000 Yen ein.',
        'es': 'Introduzca un importe de transferencia de 10.000 yenes o más.',
        'fr': 'Veuillez saisir un montant de transfert de 10 000 yens ou plus.',
        'ko': '송금 금액은 10,000엔 이상으로 입력해 주세요.',
        'zh': '請輸入10000日圓或以上的轉帳金額。',
        'zh-TW': '请输入10000日元或以上的转账金额。',
      },
      '振込金額が出金可能額を超えています。': {
        'en': 'The transfer amount exceeds the available withdrawal limit.',
        'it': 'L\'importo del trasferimento supera il limite di prelievo disponibile.',
        'de': 'Der Überweisungsbetrag übersteigt das verfügbare Auszahlungslimit.',
        'es': 'El importe de la transferencia supera el límite de retirada disponible.',
        'fr': 'Le montant du transfert dépasse la limite de retrait disponible.',
        'ko': '송금 금액이 출금 가능 금액을 초과합니다.',
        'zh': '轉帳金額超過了可用提款限額。',
        'zh-TW': '转账金额超过了可用提款限额。',
      },
      '〒330-0854 埼玉県さいたま市大宮区桜木町1丁目195‑1 大宮ソラミチKOZ4階': {
        'en': '4th Floor, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, Saitama City, Saitama Prefecture 330-0854',
        'it': '4th Floor, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, Saitama City, Prefettura di Saitama 330-0854',
        'de': '4. Stock, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, Stadt Saitama, Präfektur Saitama 330-0854',
        'es': '4.° piso, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, ciudad de Saitama, prefectura de Saitama 330-0854',
        'fr': '4e étage, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, ville de Saitama, préfecture de Saitama 330-0854',
        'ko': '〒330-0854 사이타마현 사이타마시 오미야구 사쿠라기초 1가 195-1 오미야 소라미치 KOS4층',
        'zh': '郵編：330-0854 埼玉縣埼玉市大宮區櫻木町 1-195-1 大宮空道 KOZ 4 樓',
        'zh-TW': '邮编：330-0854 埼玉县埼玉市大宫区樱木町 1-195-1 大宫空道 KOZ 4 楼',
      },
      '発送先': {
        'en': 'Shipping address',
        'it': 'Indirizzo di spedizione',
        'de': 'Lieferadresse',
        'es': 'Dirección de envío',
        'fr': 'Adresse de livraison',
        'ko': '배송지',
        'zh': '收件地址',
        'zh-TW': '收件地址',
      },
      '査定額': {
        'en': 'Appraisal amount',
        'it': 'Importo della valutazione',
        'de': 'Schätzwert',
        'es': 'Importe de la tasación',
        'fr': 'Montant de l\'évaluation',
        'ko': '평가 금액',
        'zh': '評估金額',
        'zh-TW': '评估金额',
      },
      '受付番号': {
        'en': 'Registration number',
        'it': 'Numero di registrazione',
        'de': 'Registrierungsnummer',
        'es': 'Número de registro',
        'fr': 'Numéro d\'immatriculation',
        'ko': '접수 번호',
        'zh': '註冊號',
        'zh-TW': '注册号',
      },
      '査定枚数': {
        'en': 'Number of items to be appraised',
        'it': 'Numero di articoli da valutare',
        'de': 'Anzahl der zu bewertenden Gegenstände',
        'es': 'Número de artículos a tasar',
        'fr': 'Nombre d\'articles à évaluer',
        'ko': '평가 매수',
        'zh': '待評估物品數量',
        'zh-TW': '待评估物品数量',
      },
      '減額枚数': {
        'en': 'Number of reduced items',
        'it': 'Numero di articoli scontati',
        'de': 'Anzahl der reduzierten Artikel',
        'es': 'Número de artículos rebajados',
        'fr': 'Nombre d\'articles en promotion',
        'ko': '감액 매수',
        'zh': '減少的商品數量',
        'zh-TW': '减少的商品数量',
      },
      '返送枚数': {
        'en': 'Number of items to return',
        'it': 'Numero di articoli da restituire',
        'de': 'Anzahl der zurückzusendenden Artikel',
        'es': 'Número de artículos a devolver',
        'fr': 'Nombre d\'articles à retourner',
        'ko': '반송 매수',
        'zh': '退貨商品數量',
        'zh-TW': '退货商品数量',
      },
      '振込': {
        'en': 'transfer',
        'it': 'trasferire',
        'de': 'überweisen',
        'es': 'transferir',
        'fr': 'transfert',
        'ko': '송금',
        'zh': '轉移',
        'zh-TW': '转移',
      },
      '【特価品】': {
        'en': '[Damaged item]',
        'it': '[Oggetto danneggiato]',
        'de': '[Beschädigter Artikel]',
        'es': '[Artículo dañado]',
        'fr': '[Article endommagé]',
        'ko': '【상처 있어 품】',
        'zh': '[物品損壞]',
        'zh-TW': '[物品损坏]',
      },
      '【取り下げ】': {
        'en': '[Withdrawal]',
        'it': '[Ritiro]',
        'de': '[Rückzug]',
        'es': '[Retiro]',
        'fr': '[Retrait]',
        'ko': '【취하】',
        'zh': '【提款】',
        'zh-TW': '【提款】',
      },
      '買取申込(会員様限定)': {
        'en': 'Purchase application (for members only)',
        'it': 'Modulo di richiesta d\'acquisto (riservato ai soci)',
        'de': 'Kaufantrag (nur für Mitglieder)',
        'es': 'Solicitud de compra (solo para miembros)',
        'fr': 'Demande d\'achat (réservée aux membres)',
        'ko': '매입 신청 (회원님 한정)',
        'zh': '購買申請（僅限會員）',
        'zh-TW': '购买申请（仅限会员）',
      },
      '未出品の状態で24時間に販売価格を設定されていなければ、自動でコインへ還元されます。': {
        'en': 'If a selling price is not set within 24 hours, it will automatically be converted to coins.',
        'it': 'Se l\'articolo non è in elenco e non viene impostato un prezzo di vendita entro 24 ore, verrà automaticamente convertito in monete.',
        'de': 'Wenn der Artikel nicht gelistet ist und innerhalb von 24 Stunden kein Verkaufspreis festgelegt wird, wird er automatisch in Münzen umgewandelt.',
        'es': 'Si el artículo no está listado y no se establece ningún precio de venta dentro de las 24 horas, se convertirá automáticamente en monedas.',
        'fr': 'Si l\'article n\'est pas répertorié et qu\'aucun prix de vente n\'est fixé dans les 24 heures, il sera automatiquement converti en pièces.',
        'ko': '미출품 상태에서 24시간에 판매가격이 설정되어 있지 않으면 자동으로 코인으로 환원됩니다.',
        'zh': '如果該物品未上架且在 24 小時內未設定售價，則將自動轉換為金幣。',
        'zh-TW': '如果该物品未上架且在 24 小时内未设定售价，则将自动转换为金币。',
      },
      'マーケットへ出品して2週間経過して売れなかった場合は、自動でコインへ還元されます。': {
        'en': 'If an item is listed on the marketplace and does not sell within two weeks, the remaining amount will be automatically converted into coins.',
        'it': 'Se un oggetto viene messo in vendita sul marketplace e non viene venduto entro due settimane, l\'importo rimanente verrà automaticamente convertito in monete.',
        'de': 'Wird ein Artikel auf dem Marktplatz angeboten und verkauft er sich nicht innerhalb von zwei Wochen, wird der Restbetrag automatisch in Münzen umgewandelt.',
        'es': 'Si un artículo se publica en el mercado y no se vende en dos semanas, el importe restante se convertirá automáticamente en monedas.',
        'fr': 'Si un article est mis en vente sur la plateforme et ne se vend pas dans un délai de deux semaines, le montant restant sera automatiquement converti en pièces.',
        'ko': '마켓에 출품해 2주간 경과해 팔리지 않았던 경우는, 자동으로 코인에 환원됩니다.',
        'zh': '如果一件商品在市場上架兩週內沒有售出，剩餘金額將自動轉換為金幣。',
        'zh-TW': '如果一件商品在市场上架两周内没有售出，剩余金额将自动转换为金币。',
      },
      '出品開始後2週間以内なら、「コインへ還元」「発送依頼」を自由に変更できます。': {
        'en': 'Within two weeks of listing your item, you can freely change between "Convert to Coins" and "Request Shipping."',
        'it': 'Entro due settimane dalla pubblicazione dell\'articolo, puoi liberamente passare dall\'opzione "Converti in monete" all\'opzione "Richiedi spedizione".',
        'de': 'Innerhalb von zwei Wochen nach dem Einstellen Ihres Artikels können Sie jederzeit zwischen „In Münzen umwandeln“ und „Versand anfordern“ wechseln.',
        'es': 'En un plazo de dos semanas desde la publicación del artículo, puede cambiar libremente entre "Convertir a monedas" y "Solicitar envío".',
        'fr': 'Dans les deux semaines suivant la mise en vente de votre article, vous pouvez librement choisir entre « Convertir en pièces » et « Demander l\'expédition ».',
        'ko': '출품 개시 후 2주일 이내라면, 「코인에 환원」 「발송 의뢰」를 자유롭게 변경할 수 있습니다.',
        'zh': '在商品上架後的兩週內，您可以隨時在「兌換成硬幣」和「請求運送」之間進行更改。',
        'zh-TW': '在商品上架后的两周内，您可以随时在“兑换成硬币”和“请求运送”之间进行更改。',
      },
      '販売手数料として10%を頂戴いたします。': {
        'en': 'A 10% sales commission and PayPal transfer fees will apply.',
        'it': 'Si applicheranno una commissione di vendita del 10% e le spese di trasferimento PayPal.',
        'de': 'Eine Verkaufsprovision von 10 % und PayPal-Überweisungsgebühren fallen an.',
        'es': 'En provision på 10 % och PayPal-överföringsavgifter tillkommer.',
        'fr': 'Une commission de vente de 10 % et des frais de transfert PayPal s\'appliqueront.',
        'ko': '10% 판매 수수료와 PayPal 송금 수수료가 적용됩니다.',
        'zh': '將收取10%的銷售佣金和PayPal轉帳費用。',
        'zh-TW': '销售佣金为10%，并适用PayPal转账费用。',
      },
      '売上金についてはこちらをご確認ください。': {
        'en': 'Please check here for details on sales proceeds.',
        'it': 'Per i dettagli relativi al ricavato delle vendite, consultare questa pagina.',
        'de': 'Bitte prüfen Sie hier die Einzelheiten zum Verkaufserlös.',
        'es': 'Consulte aquí para obtener detalles sobre los ingresos de las ventas.',
        'fr': 'Veuillez consulter cette page pour plus de détails sur le produit des ventes.',
        'ko': '매출금에 대해서는 이쪽을 확인해 주세요.',
        'zh': '請點擊此處查看銷售收益詳情。',
        'zh-TW': '请点击此处查看销售收益详情。',
      },
      '2タップで「X marketで販売」となります。': {
        'en': 'Two taps will put it on "X market for sale".',
        'it': 'Due tocchi lo metteranno in vendita sul mercato X.',
        'de': 'Mit zwei Klicks wird es auf dem „Markt X zum Verkauf angeboten“.',
        'es': 'Dos toques lo pondrán en "Mercado X en venta".',
        'fr': 'Deux clics suffisent pour le mettre en vente sur le marché X.',
        'ko': '2 탭으로 「X market에서 판매」가 됩니다.',
        'zh': '輕點兩下即可將其放到「X市場出售」。',
        'zh-TW': '轻点两下即可将其放到“X市场出售”。',
      },
      'コインに還元する': {
        'en': 'To coins',
        'it': 'Alle monete',
        'de': 'Zu Münzen',
        'es': 'Till mynt',
        'fr': 'Aux pièces',
        'ko': '동전으로',
        'zh': '至硬幣',
        'zh-TW': '硬币',
      },
      '発送する': {
        'en': 'To ship',
        'it': 'Per spedire',
        'de': 'Zum Versenden',
        'es': 'Para enviar',
        'fr': 'Pour expédier',
        'ko': '발송하다',
        'zh': '出貨',
        'zh-TW': '发货',
      },
      'このカードをコインに還元しますか？': {
        'en': 'Do you want to convert this card into coins?',
        'it': 'Desideri convertire questa carta in monete?',
        'de': 'Möchtest du diese Karte in Münzen umtauschen?',
        'es': '¿Deseas convertir esta tarjeta en monedas?',
        'fr': 'Souhaitez-vous convertir cette carte en pièces ?',
        'ko': '이 카드를 동전으로 환원하시겠습니까?',
        'zh': '您想把這張卡兌換成金幣嗎？',
        'zh-TW': '您想把这张卡兑换成金币吗？',
      },
      '(※実行後の変更はできません)': {
        'en': '(※Changes cannot be made after execution)',
        'it': '(※Non è possibile apportare modifiche dopo l\'esecuzione)',
        'de': '(※Nach der Ausführung können keine Änderungen mehr vorgenommen werden)',
        'es': '(※No se pueden realizar cambios después de la ejecución)',
        'fr': '(※Aucune modification ne peut être apportée après l\'exécution)',
        'ko': '(※실행 후의 변경은 할 수 없습니다)',
        'zh': '（※執行後無法更改）',
        'zh-TW': '（※执行后无法更改）',
      },
      'このカードを発送しますか？': {
        'en': 'Should I ship this card?',
        'it': 'Devo spedire questa cartolina?',
        'de': 'Soll ich diese Karte verschicken?',
        'es': '¿Debo enviar esta tarjeta?',
        'fr': 'Dois-je expédier cette carte ?',
        'ko': '이 카드를 발송하시겠습니까?',
        'zh': '我該寄出這張卡片嗎？',
        'zh-TW': '我应该寄出这张卡片吗？',
      },
      '当該ガチャの販売終了後に自動で出品されます': {
        'en': 'This item will be automatically listed for sale after the sale of the gacha ends.',
        'it': 'Questo oggetto verrà automaticamente messo in vendita al termine della vendita del gacha.',
        'de': 'Dieser Artikel wird nach Ende des Gacha-Verkaufs automatisch zum Verkauf angeboten.',
        'es': 'Este artículo se pondrá a la venta automáticamente una vez finalizada la venta del gacha.',
        'fr': 'Cet article sera automatiquement mis en vente une fois la vente du gacha terminée.',
        'ko': '해당 뽑기의 판매 종료 후 자동으로 출품됩니다',
        'zh': '扭蛋活動結束後，該物品將自動上架出售。',
        'zh-TW': '扭蛋活动结束后，该物品将自动上架出售。',
      },
      'マーケット購入': {
        'en': 'Market purchase',
        'it': 'Acquisto sul mercato',
        'de': 'Marktkauf',
        'es': 'Compra en el mercado',
        'fr': 'Achat au marché',
        'ko': '마켓 구매',
        'zh': '市場購買',
        'zh-TW': '市场购买',
      },
      'フィギュア': {
        'en': 'Figure',
        'it': 'Figura',
        'de': 'Figur',
        'es': 'Cifra',
        'fr': 'Chiffre',
        'ko': '피규어',
        'zh': '數位',
        'zh-TW': '数字',
      },
      '{min}円以上の価格で出品できます': {
        'en': 'You can sell it for more than {min} yen',
        'it': 'Sie können es für mehr als {min} Yen verkaufen',
        'de': 'Puedes venderlo por más de {min} yenes',
        'es': 'Vous pouvez le vendre pour plus de {min} yens',
        'fr': '{min}엔 이상의 가격으로 판매 가능',
        'ko': '您可以以高於{min}日圓的價格出售它',
        'zh': '您可以以高于{min}日元的价格出售它',
        'zh-TW': '您可以以高于{min}日元的价格出售它',
      },
      'カートに追加しました': {
        'en': 'Added to cart',
        'it': 'Aggiunto al carrello',
        'de': 'Dem Warenkorb hinzugefügt',
        'es': 'Añadido al carrito',
        'fr': 'Ajouté au panier',
        'ko': '장바구니에 추가됨',
        'zh': '加入購物車',
        'zh-TW': '加入购物车',
      },
      'マーケット購入品': {
        'en': 'Market purchases',
        'it': 'Acquisti al mercato',
        'de': 'Marktkäufe',
        'es': 'Compras en el mercado',
        'fr': 'Achats sur le marché',
        'ko': '마켓 구매품',
        'zh': '市場購買',
        'zh-TW': '市场购买',
      },
      '該当するカード履歴が見つかりません': {
        'en': 'No matching card history was found.',
        'it': 'Non è stata trovata alcuna corrispondenza nella cronologia della carta.',
        'de': 'Es wurde keine passende Kartenhistorie gefunden.',
        'es': 'No se encontró ningún historial de tarjeta coincidente.',
        'fr': 'Aucun historique de carte correspondant n\'a été trouvé.',
        'ko': '해당 카드 기록을 찾을 수 없습니다.',
        'zh': '未找到符合的信用卡歷史記錄。',
        'zh-TW': '未找到匹配的信用卡历史记录。',
      },
      'このカードの所有者ではありません': {
        'en': 'I am not the owner of this card.',
        'it': 'Non sono il proprietario di questa carta.',
        'de': 'Ich bin nicht der Besitzer dieser Karte.',
        'es': 'No soy el propietario de esta tarjeta.',
        'fr': 'Je ne suis pas le propriétaire de cette carte.',
        'ko': '이 카드의 소유자가 아닙니다.',
        'zh': '我不是這張卡的持有者。',
        'zh-TW': '我不是这张卡的持有者。',
      },
      'このカードは既に取引が完了しています': {
        'en': 'This card has already been traded.',
        'it': 'Questa carta è già stata scambiata.',
        'de': 'Diese Karte wurde bereits getauscht.',
        'es': 'Esta carta ya ha sido intercambiada.',
        'fr': 'Cette carte a déjà été échangée.',
        'ko': '이 카드는 이미 거래가 완료되었습니다.',
        'zh': '這張卡已經交易過了。',
        'zh-TW': '这张卡已经交易过了。',
      },
      '出品できないカードです': {
        'en': 'This card cannot be listed for sale.',
        'it': 'Questa carta non può essere messa in vendita.',
        'de': 'Diese Karte darf nicht zum Verkauf angeboten werden.',
        'es': 'Esta tarjeta no puede ponerse a la venta.',
        'fr': 'Cette carte ne peut être mise en vente.',
        'ko': '전시 할 수없는 카드입니다.',
        'zh': '此卡不能上架出售。',
        'zh-TW': '此卡不能上架出售。',
      },
      '既に出品されています': {
        'en': 'Already listed',
        'it': 'È già stato messo in vendita.',
        'de': 'Es steht bereits zum Verkauf.',
        'es': 'Ya está puesto a la venta.',
        'fr': 'Il a déjà été mis en vente.',
        'ko': '이미 전시되었습니다.',
        'zh': '它已經掛牌出售了。',
        'zh-TW': '它已经挂牌出售了。',
      },
      '既にカートに追加されています': {
        'en': 'It has already been added to your cart.',
        'it': 'È già stato aggiunto al carrello.',
        'de': 'Es wurde bereits Ihrem Warenkorb hinzugefügt.',
        'es': 'Ya se ha añadido a tu carrito.',
        'fr': 'Il a déjà été ajouté à votre panier.',
        'ko': '이미 장바구니에 추가되었습니다.',
        'zh': '它已加入您的購物車。',
        'zh-TW': '它已加入您的购物车。',
      },
      '自分の出品はカートに追加できません': {
        'en': 'I cannot add my own listings to my cart.',
        'it': 'Non riesco ad aggiungere i miei articoli al carrello.',
        'de': 'Ich kann meine eigenen Artikel nicht in meinen Warenkorb legen.',
        'es': 'No puedo añadir mis propios artículos al carrito.',
        'fr': 'Je ne peux pas ajouter mes propres annonces à mon panier.',
        'ko': '자신의 전시는 장바구니에 추가할 수 없습니다.',
        'zh': '我無法將自己的商品加入購物車。',
        'zh-TW': '我无法将自己的商品添加到购物车。',
      },
      '出品が見つかりません': {
        'en': 'No listings found.',
        'it': 'Nessun risultato trovato.',
        'de': 'Keine Einträge gefunden.',
        'es': 'No se encontraron resultados.',
        'fr': 'Aucun résultat trouvé.',
        'ko': '출품을 찾을 수 없음',
        'zh': '未找到任何房源。',
        'zh-TW': '未找到任何房源。',
      },
      'システムエラーが発生しました': {
        'en': 'A system error occurred.',
        'it': 'Si è verificato un errore di sistema.',
        'de': 'Es ist ein Systemfehler aufgetreten.',
        'es': 'Se ha producido un error del sistema.',
        'fr': 'Une erreur système s\'est produite.',
        'ko': '시스템 오류가 발생했습니다.',
        'zh': '系統發生錯誤。',
        'zh-TW': '系统发生错误。',
      },
      '既に購入済みです': {
        'en': 'I have already purchased it.',
        'it': 'L\'ho già acquistato.',
        'de': 'Ich habe es bereits gekauft.',
        'es': 'Ya lo he comprado.',
        'fr': 'Je l\'ai déjà acheté.',
        'ko': '이미 구입했습니다.',
        'zh': '我已經買好了。',
        'zh-TW': '我已经买好了。',
      },
      '既に他の人に購入されました': {
        'en': 'It has already been purchased by someone else.',
        'it': 'È già stato acquistato da qualcun altro.',
        'de': 'Es wurde bereits von jemand anderem gekauft.',
        'es': 'Ya lo ha comprado otra persona.',
        'fr': 'Il a déjà été acheté par quelqu\'un d\'autre.',
        'ko': '이미 다른 사람들에게 구입했습니다.',
        'zh': '它已經被別人買走了。',
        'zh-TW': '它已经被别人买走了。',
      },
      '自分の出品は購入できません': {
        'en': 'You cannot purchase my own listings.',
        'it': 'Non è possibile acquistare i miei articoli in vendita.',
        'de': 'Meine eigenen Angebote können Sie nicht kaufen.',
        'es': 'No puedes comprar mis propios anuncios.',
        'fr': 'Vous ne pouvez pas acheter mes propres annonces.',
        'ko': '자신의 출품은 구입할 수 없습니다.',
        'zh': '你不能購買我自己發布的商品。',
        'zh-TW': '你不能购买我自己发布的商品。',
      },
      'オークション商品は個別に購入してください': {
        'en': 'Please purchase auction items individually.',
        'it': 'Si prega di acquistare gli articoli all\'asta singolarmente.',
        'de': 'Bitte kaufen Sie die Auktionsartikel einzeln.',
        'es': 'Por favor, compre los artículos de la subasta individualmente.',
        'fr': 'Veuillez acheter les articles mis aux enchères individuellement.',
        'ko': '경매 상품은 개별적으로 구입해 주세요',
        'zh': '請單獨購買拍賣品。',
        'zh-TW': '请单独购买拍卖品。',
      },
      '商品価格が変更されました': {
        'en': 'Product price has been changed.',
        'it': 'Il prezzo del prodotto è stato modificato.',
        'de': 'Der Produktpreis wurde geändert.',
        'es': 'El precio del producto ha cambiado.',
        'fr': 'Le prix du produit a été modifié.',
        'ko': '상품 가격이 변경되었습니다.',
        'zh': '產品價格已更改。',
        'zh-TW': '产品价格已更改。',
      },
      '商品が見つかりません': {
        'en': 'Product not found.',
        'it': 'Prodotto non trovato.',
        'de': 'Produkt nicht gefunden.',
        'es': 'Producto no encontrado.',
        'fr': 'Produit introuvable.',
        'ko': '상품을 찾을 수 없음',
        'zh': '未找到產品。',
        'zh-TW': '未找到产品。',
      },
      'サポートされていない決済方法です': {
        'en': 'This payment method is not supported.',
        'it': 'Questo metodo di pagamento non è supportato.',
        'de': 'Diese Zahlungsmethode wird nicht unterstützt.',
        'es': 'Este método de pago no es compatible.',
        'fr': 'Ce mode de paiement n\'est pas pris en charge.',
        'ko': '지원되지 않는 결제 방법입니다.',
        'zh': '此付款方式不受支援。',
        'zh-TW': '此付款方式不受支持。',
      },
      '決済処理でエラーが発生しました': {
        'en': 'An error occurred during payment processing.',
        'it': 'Si è verificato un errore durante l\'elaborazione del pagamento.',
        'de': 'Bei der Zahlungsabwicklung ist ein Fehler aufgetreten.',
        'es': 'Se produjo un error durante el procesamiento del pago.',
        'fr': 'Une erreur s\'est produite lors du traitement du paiement.',
        'ko': '결제 처리 중 오류가 발생했습니다.',
        'zh': '支付處理過程中發生錯誤。',
        'zh-TW': '支付处理过程中发生错误。',
      },
      '購入完了処理に失敗しました': {
        'en': 'Purchase completion failed.',
        'it': 'Acquisto non completato.',
        'de': 'Kaufabwicklung fehlgeschlagen.',
        'es': 'La compra no se completó correctamente.',
        'fr': 'L\'achat a échoué.',
        'ko': '구매 완료 처리에 실패했습니다.',
        'zh': '購買交易失敗。',
        'zh-TW': '购买交易失败。',
      },
      '一部の商品が購入できませんでした': {
        'en': 'Some items could not be purchased.',
        'it': 'Alcuni articoli non potevano essere acquistati.',
        'de': 'Einige Artikel konnten nicht gekauft werden.',
        'es': 'Algunos artículos no pudieron comprarse.',
        'fr': 'Certains articles n\'ont pas pu être achetés.',
        'ko': '일부 상품을 구입할 수 없습니다.',
        'zh': '部分商品無法購買。',
        'zh-TW': '部分商品无法购买。',
      },
      'カートに商品がありません': {
        'en': 'There are no items in your cart.',
        'it': 'Non ci sono articoli nel carrello.',
        'de': 'Ihr Warenkorb ist leer.',
        'es': 'No hay artículos en tu carrito.',
        'fr': 'Votre panier est vide.',
        'ko': '장바구니에 상품이 없습니다.',
        'zh': '您的購物車中沒有商品。',
        'zh-TW': '您的购物车中没有商品。',
      },
      '購入情報が見つかりません': {
        'en': 'Purchase information not found.',
        'it': 'Informazioni sull\'acquisto non trovate.',
        'de': 'Kaufinformationen nicht gefunden.',
        'es': 'No se encontró información de compra.',
        'fr': 'Informations d\'achat introuvables.',
        'ko': '구매 정보를 찾을 수 없음',
        'zh': '未找到購買資訊。',
        'zh-TW': '未找到购买信息。',
      },
      '購入が完了しました': {
        'en': 'Purchase complete.',
        'it': 'Acquisto completato.',
        'de': 'Kauf abgeschlossen.',
        'es': 'Compra completada.',
        'fr': 'Achat terminé.',
        'ko': '구매가 완료되었습니다.',
        'zh': '購買完成。',
        'zh-TW': '购买完成。',
      },
      '購入処理でエラーが発生しました': {
        'en': 'An error occurred during the purchase process.',
        'it': 'Si è verificato un errore durante il processo di acquisto.',
        'de': 'Während des Kaufvorgangs ist ein Fehler aufgetreten.',
        'es': 'Se produjo un error durante el proceso de compra.',
        'fr': 'Une erreur s\'est produite lors du processus d\'achat.',
        'ko': '구매 처리 중 오류가 발생했습니다.',
        'zh': '購買過程中出現錯誤。',
        'zh-TW': '购买过程中出现错误。',
      },
      '入金情報が見つかりません': {
        'en': 'Payment information not found.',
        'it': 'Informazioni di pagamento non trovate.',
        'de': 'Zahlungsinformationen nicht gefunden.',
        'es': 'Información de pago no encontrada.',
        'fr': 'Informations de paiement introuvables.',
        'ko': '입금 정보를 찾을 수 없음',
        'zh': '未找到支付資訊。',
        'zh-TW': '未找到支付信息。',
      },
      '振込金額は手数料を差し引いた金額が1円以上になるように指定してください': {
        'en': 'Please specify a transfer amount such that the amount after deducting the transfer fee is 1 yen or more.',
        'it': 'Si prega di specificare un importo per il trasferimento tale che, al netto delle commissioni, l\'importo totale sia pari o superiore a 1 yen.',
        'de': 'Bitte geben Sie einen Überweisungsbetrag an, sodass der Betrag nach Abzug der Überweisungsgebühr mindestens 1 Yen beträgt.',
        'es': 'Por favor, especifique un importe de transferencia tal que, tras deducir la comisión, el importe resultante sea de 1 yen o más.',
        'fr': 'Veuillez indiquer un montant de transfert tel que le montant après déduction des frais de transfert soit de 1 yen ou plus.',
        'ko': '송금 금액은 수수료를 뺀 금액이 1 엔 이상이되도록 지정하십시오',
        'zh': '請指定轉帳金額，使扣除手續費後的金額為1日圓或以上。',
        'zh-TW': '请指定转账金额，使扣除手续费后的金额为1日元或以上。',
      },
      '不正な振込タイプです': {
        'en': 'This is an invalid transfer type.',
        'it': 'Questo è un tipo di trasferimento non valido.',
        'de': 'Dies ist ein ungültiger Übertragungstyp.',
        'es': 'Este es un tipo de transferencia no válido.',
        'fr': 'Il s\'agit d\'un type de transfert invalide.',
        'ko': '부정한 송금 타입입니다',
        'zh': '這是無效的轉帳類型。',
        'zh-TW': '这是无效的转账类型。',
      },
      '出金可能額を超えています': {
        'en': 'You have exceeded your withdrawal limit.',
        'it': 'Hai superato il limite di prelievo.',
        'de': 'Sie haben Ihr Auszahlungslimit überschritten.',
        'es': 'Has superado tu límite de retiro.',
        'fr': 'Vous avez dépassé votre limite de retrait.',
        'ko': '출금 가능 금액을 초과했습니다.',
        'zh': '您已超出提款限額。',
        'zh-TW': '您已超出提款限额。',
      },
      '銀行口座情報が不足しています': {
        'en': 'Bank account information is missing.',
        'it': 'Mancano le informazioni sul conto bancario.',
        'de': 'Die Bankkontoinformationen fehlen.',
        'es': 'Falta la información de la cuenta bancaria.',
        'fr': 'Les informations relatives au compte bancaire sont manquantes.',
        'ko': '은행 계좌 정보가 부족합니다.',
        'zh': '銀行帳戶資料缺失。',
        'zh-TW': '银行账户信息缺失。',
      },
      'PayPalメールアドレスが不足しています': {
        'en': 'We are missing PayPal email addresses.',
        'it': 'Ci mancano gli indirizzi email di PayPal.',
        'de': 'Uns fehlen PayPal-E-Mail-Adressen.',
        'es': 'Nos faltan direcciones de correo electrónico de PayPal.',
        'fr': 'Il nous manque des adresses e-mail PayPal.',
        'ko': 'PayPal 이메일 주소가 부족합니다.',
        'zh': '我們缺少PayPal郵箱地址。',
        'zh-TW': '我们缺少PayPal邮箱地址。',
      },
      '不正な入金情報の種別です': {
        'en': 'This is the type of fraudulent deposit information.',
        'it': 'Questo è il tipo di informazione fraudolenta relativa al deposito.',
        'de': 'Dies sind betrügerische Einzahlungsinformationen.',
        'es': 'Este es el tipo de información de depósito fraudulenta.',
        'fr': 'Voici le type d\'informations frauduleuses concernant les dépôts.',
        'ko': '무단 입금 정보의 종류입니다.',
        'zh': '這是典型的詐欺性存款資訊。',
        'zh-TW': '这是典型的欺诈性存款信息。',
      },
      'マーケットIDまたはユーザー履歴カードIDが必要です': {
        'en': 'A Market ID or User History Card ID is required.',
        'it': 'È richiesto un ID di mercato o un ID della scheda cronologia utente.',
        'de': 'Eine Markt-ID oder eine Benutzerhistorien-Karten-ID ist erforderlich.',
        'es': 'Se requiere un ID de mercado o un ID de tarjeta de historial de usuario.',
        'fr': 'Un identifiant de marché ou un identifiant de carte d\'historique utilisateur est requis.',
        'ko': '마켓 ID 또는 사용자 기록 카드 ID 필요',
        'zh': '需要提供市場 ID 或用戶歷史卡 ID。',
        'zh-TW': '需要提供市场 ID 或用户历史卡 ID。',
      },
      '該当するマーケット出品が見つかりません': {
        'en': 'No matching market listings were found.',
        'it': 'Non sono stati trovati annunci di mercato corrispondenti.',
        'de': 'Es wurden keine passenden Markteinträge gefunden.',
        'es': 'No se encontraron resultados de mercado coincidentes.',
        'fr': 'Aucune annonce correspondante n\'a été trouvée.',
        'ko': '해당 시장 출품을 찾을 수 없습니다.',
        'zh': '未找到符合的市場清單。',
        'zh-TW': '未找到匹配的市场列表。',
      },
      'ログインが必要です': {
        'en': 'Login is required.',
        'it': 'È necessario effettuare l\'accesso.',
        'de': 'Anmeldung erforderlich.',
        'es': 'Es necesario iniciar sesión.',
        'fr': 'Connexion requise.',
        'ko': '로그인 필요',
        'zh': '需要登入。',
        'zh-TW': '需要登录。',
      },
      'PayPalの手数料に準ずる': {
        'en': 'In accordance with PayPal terms',
        'it': 'Le commissioni sono soggette ai termini e alle condizioni di PayPal.',
        'de': 'Es fallen Gebühren gemäß den PayPal-Bedingungen an.',
        'es': 'Las comisiones están sujetas a los términos y condiciones de PayPal.',
        'fr': 'Les frais sont soumis aux conditions générales de PayPal.',
        'ko': 'PayPal 수수료에 부합',
        'zh': '費用須遵守PayPal的條款。',
        'zh-TW': '费用须遵守PayPal的条款。',
      },
      'PayPalの手数料が差し引かれた後の金額': {
        'en': 'Amount after PayPal fees have been deducted',
        'it': 'L\'importo al netto delle commissioni di PayPal.',
        'de': 'Der Betrag nach Abzug der PayPal-Gebühren.',
        'es': 'El importe después de deducir las comisiones de PayPal.',
        'fr': 'Le montant après déduction des frais PayPal.',
        'ko': 'PayPal 수수료가 공제된 후 금액',
        'zh': '扣除PayPal手續費後的金額。',
        'zh-TW': '扣除PayPal手续费后的金额。',
      },
      'PayPalメールアドレス': {
        'en': 'PayPal email address',
        'it': 'indirizzo email di PayPal',
        'de': 'PayPal-E-Mail-Adresse',
        'es': 'Dirección de correo electrónico de PayPal',
        'fr': 'Adresse e-mail PayPal',
        'ko': 'PayPal 이메일 주소',
        'zh': 'PayPal 電子郵件地址',
        'zh-TW': 'PayPal 电子邮件地址',
      },
      'このカードを削除しますか？': {
        'en': 'Do you want to remove this card?',
        'it': 'Vuoi rimuovere questa scheda?',
        'de': 'Möchten Sie diese Karte entfernen?',
        'es': '¿Desea eliminar esta tarjeta?',
        'fr': 'Voulez-vous retirer cette carte ?',
        'ko': '이 카드를 삭제하시겠습니까?',
        'zh': '您要移除這張卡嗎？',
        'zh-TW': '您要移除这张卡吗？',
      },
      '販売手数料として10%を頂戴いたします': {
        'en': 'We will charge a 10% sales commission.',
        'it': 'Applicheremo una commissione di vendita del 10%.',
        'de': 'Wir berechnen eine Verkaufsprovision von 10%.',
        'es': 'Cobraremos una comisión de venta del 10%.',
        'fr': 'Nous prélèverons une commission de 10 % sur les ventes.',
        'ko': '판매 수수료로서 10%를 받습니다',
        'zh': '我們將收取10%的銷售佣金。',
        'zh-TW': '我们将收取10%的销售佣金。',
      },
      '未発送': {
        'en': 'Not yet shipped',
        'it': 'Non ancora spedito',
        'de': 'Noch nicht versendet',
        'es': 'Aún no se ha enviado',
        'fr': 'Pas encore expédié',
        'ko': '미발송',
        'zh': '尚未出貨',
        'zh-TW': '尚未发货',
      },
      '出品額': {
        'en': 'Sales amount',
        'it': 'Importo delle vendite',
        'de': 'Verkaufsbetrag',
        'es': 'Försäljningsbelopp',
        'fr': 'Montant des ventes',
        'ko': '매출액',
        'zh': '銷售額',
        'zh-TW': '销售额',
      },
      '入金額': {
        'en': 'Received amount',
        'it': 'Importo ricevuto',
        'de': 'Erhaltener Betrag',
        'es': 'Mottagen summa',
        'fr': 'Montant reçu',
        'ko': '수령 금액',
        'zh': '收到金額',
        'zh-TW': '收到金额',
      },
      'ポイント購入履歴': {
        'en': 'Points Purchase History',
        'it': 'Cronologia degli acquisti di punti',
        'de': 'Punktekaufhistorie',
        'es': 'Historial de compra de puntos',
        'fr': 'Historique d\'achat de points',
        'ko': '포인트 구매 내역',
        'zh': '積分購買歷史記錄',
        'zh-TW': '积分购买历史记录',
      },
      '所持{amount}ポイント以下の方限定': {
        'en': 'Limited to those with {amount} points or less',
        'it': 'Riservato a coloro che hanno {amount} punti o meno',
        'de': 'Beschränkt auf Teilnehmer mit {amount} Punkten oder weniger',
        'es': 'Limitado a aquellos con {cantidad} puntos o menos',
        'fr': 'Réservé aux personnes ayant {amount} points ou moins',
        'ko': '소지 {amount}포인트 이하의 분 한정',
        'zh': '僅限積分低於 {amount} 分的用戶',
        'zh-TW': '仅限积分低于 {amount} 分的用户',
      },
      '今月{amount}ポイント以上決済された方限定': {
        'en': 'Limited to customers who have spent more than {amount} points this month.',
        'it': 'Offerta valida solo per i clienti che hanno speso più di {amount} punti questo mese.',
        'de': 'Beschränkt auf Kunden, die in diesem Monat mehr als {amount} Punkte eingelöst haben.',
        'es': 'Limitado a clientes que hayan gastado más de {cantidad} puntos este mes.',
        'fr': 'Offre limitée aux clients ayant dépensé plus de {amount} points ce mois-ci.',
        'ko': '이번 달 {amount}포인트 이상 결제된 분 한정',
        'zh': '僅限本月消費超過{amount}積分的顧客。',
        'zh-TW': '仅限本月消费超过{amount}积分的顾客。',
      },
      '所持ポイント': {
        'en': 'Points',
        'it': 'Punti',
        'de': 'Punkte',
        'es': 'Agujas',
        'fr': 'Points',
        'ko': '소지 포인트',
        'zh': '積分',
        'zh-TW': '积分',
      },
      'ポイントを使用しない場合、来月は「{rank}」ランクになります。': {
        'en': 'If you do not use your points, your rank will be "{rank}" next month.',
        'it': 'Se non utilizzi i tuoi punti, il tuo rango sarà "{rank}" il mese prossimo.',
        'de': 'Wenn Sie Ihre Punkte nicht einlösen, wird Ihr Rang im nächsten Monat "{rank}" lauten.',
        'es': 'Si no utilizas tus puntos, tu rango será "{rank}" el próximo mes.',
        'fr': 'Si vous n\'utilisez pas vos points, votre rang sera « {rank} » le mois prochain.',
        'ko': '포인트를 사용하지 않으면 다음 달은 \'{rank}\' 순위가 됩니다.',
        'zh': '如果您不使用積分，下個月您的排名將為「{rank}」。',
        'zh-TW': '如果您不使用积分，下个月您的排名将为“{rank}”。',
      },
      '来月、「{rank}」からスタートするには {amount} ポイントが必要です。': {
        'en': 'To start at "{rank}" next month, you will need {amount} points.',
        'it': 'Per iniziare al rango "{rank}" il mese prossimo, avrai bisogno di {amount} punti.',
        'de': 'Um nächsten Monat auf Rang "{rank}" zu starten, benötigen Sie {amount} Punkte.',
        'es': 'Para comenzar en "{rank}" el próximo mes, necesitarás {amount} puntos.',
        'fr': 'Pour commencer au "{rank}" le mois prochain, vous aurez besoin de {amount} points.',
        'ko': '다음 달 "{rank}"에서 시작하려면 {amount} 포인트가 필요합니다.',
        'zh': '下個月要達到「{rank}」級別，您需要{amount}點數。',
        'zh-TW': '下个月要达到“{rank}”级别，您需要{amount}点数。',
      },
      'ポイントが不足しています': {
        'en': 'You do not have enough points.',
        'it': 'Non hai abbastanza punti.',
        'de': 'Du hast nicht genügend Punkte.',
        'es': 'No tienes suficientes puntos.',
        'fr': 'Vous n\'avez pas assez de points.',
        'ko': '포인트가 부족함',
        'zh': '您的積分不足。',
        'zh-TW': '您的积分不足。',
      },
      'ポイントのみ': {
        'en': 'Points only',
        'it': 'Solo punti',
        'de': 'Nur Punkte',
        'es': 'Solo puntos',
        'fr': 'Points seulement',
        'ko': '포인트만',
        'zh': '僅積分',
        'zh-TW': '仅积分',
      },
      'あなたも友達も 500ポイントがもらえる': {
        'en': 'You and your friend will both receive 500 points.',
        'it': 'Tu e il tuo amico riceverete entrambi 500 punti.',
        'de': 'Du und dein Freund erhaltet beide 500 Punkte.',
        'es': 'Tú y tu amigo recibiréis 500 puntos cada uno.',
        'fr': 'Vous et votre ami recevrez chacun 500 points.',
        'ko': '당신도 친구도 500포인트를 받을 수 있다',
        'zh': '你和你的朋友都將獲得500點。',
        'zh-TW': '你和你的朋友都将获得500积分。',
      },
      'ポイントの購入': {
        'en': 'Purchase of points',
        'it': 'Acquisto di punti',
        'de': 'Kauf von Punkten',
        'es': 'Compra de puntos',
        'fr': 'Achat de points',
        'ko': '포인트 구매',
        'zh': '購買積分',
        'zh-TW': '购买积分',
      },
      'ポイントへの還元数': {
        'en': 'Number of points redeemed',
        'it': 'Numero di punti riscattati',
        'de': 'Anzahl der eingelösten Punkte',
        'es': 'Número de puntos canjeados',
        'fr': 'Nombre de points échangés',
        'ko': '포인트로의 환원수',
        'zh': '已兌換積分數量',
        'zh-TW': '已兑换积分数量',
      },
      'ポイントへの合計還元数': {
        'en': 'Total number of points redeemed',
        'it': 'Numero totale di punti riscattati',
        'de': 'Gesamtzahl der eingelösten Punkte',
        'es': 'Número total de puntos canjeados',
        'fr': 'Nombre total de points échangés',
        'ko': '포인트에 대한 총 환원 수',
        'zh': '已兌換積分總數',
        'zh-TW': '已兑换积分总数',
      },
      'ポイント数': {
        'en': 'Points',
        'it': 'Punti',
        'de': 'Punkte',
        'es': 'Agujas',
        'fr': 'Points',
        'ko': '포인트 수',
        'zh': '積分',
        'zh-TW': '积分',
      },
      '引換履歴&ポイント履歴': {
        'en': 'Redemption History & Points History',
        'it': 'Cronologia dei riscatti e cronologia dei punti',
        'de': 'Einlösungshistorie & Punktehistorie',
        'es': 'Historial de canje e historial de puntos',
        'fr': 'Historique des échanges et historique des points',
        'ko': '교환 이력 & 포인트 이력',
        'zh': '兌換歷史與積分歷史',
        'zh-TW': '兑换历史和积分历史',
      },
      '引換・付与ポイント': {
        'en': 'Redemption/Points Awarded',
        'it': 'Riscatto/Punti assegnati',
        'de': 'Einlösung/Punktevergabe',
        'es': 'Canje/Puntos otorgados',
        'fr': 'Échange/Points attribués',
        'ko': '교환·부여 포인트',
        'zh': '兌換/獎勵積分',
        'zh-TW': '兑换/奖励积分',
      },
      '引換履歴&ポイント履歴がありません。': {
        'en': 'There is no redemption history or points history.',
        'it': 'Non è disponibile alcuna cronologia di riscatti o di punti.',
        'de': 'Es gibt keine Einlösungshistorie oder Punktehistorie.',
        'es': 'No hay historial de canje ni historial de puntos.',
        'fr': 'Il n\'y a pas d\'historique des échanges ni d\'historique des points.',
        'ko': '교환 이력 & 포인트 이력이 없습니다.',
        'zh': '沒有兌換記錄或積分記錄。',
        'zh-TW': '没有兑换记录或积分记录。',
      },
      'ポイント購入完了': {
        'en': 'Points purchase complete.',
        'it': 'Acquisto punti completato.',
        'de': 'Punktekauf abgeschlossen.',
        'es': 'Compra de puntos completada.',
        'fr': 'Achat de points terminé.',
        'ko': '포인트 구매 완료',
        'zh': '積分購買完成。',
        'zh-TW': '积分购买完成。',
      },
      'ポイントのご購入ありがとうございました。': {
        'en': 'Thank you for purchasing points.',
        'it': 'Grazie per aver acquistato punti.',
        'de': 'Vielen Dank für den Kauf von Punkten.',
        'es': 'Gracias por comprar puntos.',
        'fr': 'Merci d\'avoir acheté des points.',
        'ko': '포인트를 구입해 주셔서 감사합니다.',
        'zh': '感謝您購買積分。',
        'zh-TW': '感谢您购买积分。',
      },
      'ポイント購入': {
        'en': 'Purchase points',
        'it': 'Punti di acquisto',
        'de': 'Kaufstellen',
        'es': 'Puntos de compra',
        'fr': 'Points d\'achat',
        'ko': '포인트 구매',
        'zh': '購買點數',
        'zh-TW': '购买点数',
      },
      '購入ポイント': {
        'en': 'Purchase points',
        'it': 'Punti di acquisto',
        'de': 'Kaufstellen',
        'es': 'Puntos de compra',
        'fr': 'Points d\'achat',
        'ko': '구매 포인트',
        'zh': '購買點數',
        'zh-TW': '购买点数',
      },
      'ポイントを': {
        'en': 'Points',
        'it': 'Punti',
        'de': 'Punkte',
        'es': 'Agujas',
        'fr': 'Points',
        'ko': '포인트를',
        'zh': '積分',
        'zh-TW': '积分',
      },
      '未選択のお品物は24時間でポイントへ自動変換されます': {
        'en': 'Unselected items will be automatically converted to points within 24 hours.',
        'it': 'Gli articoli non selezionati verranno convertiti automaticamente in punti entro 24 ore.',
        'de': 'Nicht ausgewählte Artikel werden innerhalb von 24 Stunden automatisch in Punkte umgewandelt.',
        'es': 'Los artículos no seleccionados se convertirán automáticamente en puntos en un plazo de 24 horas.',
        'fr': 'Les articles non sélectionnés seront automatiquement convertis en points sous 24 heures.',
        'ko': '선택되지 않은 제품은 24시간 내에 포인트로 자동 변환됩니다.',
        'zh': '未選擇的商品將在24小時內自動轉換為積分。',
        'zh-TW': '未选择的商品将在24小时内自动转换为积分。',
      },
      '発送は還元ポイントの合計が1000P以上からとなります。': {
        'en': 'Shipping will only be available for orders with a total of 1000 points or more.',
        'it': 'La spedizione sarà disponibile solo per ordini con un totale di 1000 punti o più.',
        'de': 'Der Versand ist nur für Bestellungen mit einem Gesamtwert von 1000 Punkten oder mehr möglich.',
        'es': 'El envío solo estará disponible para pedidos con un total de 1000 puntos o más.',
        'fr': 'La livraison ne sera disponible que pour les commandes d\'un montant total de 1000 points ou plus.',
        'ko': '발송은 환원 포인트의 합계가 1000 P이상이 됩니다.',
        'zh': '只有累計積分達到1000點或以上的訂單才能享有包郵服務。',
        'zh-TW': '只有累计积分达到1000积分或以上的订单才能享受包邮服务。',
      },
      '還元ポイント（発送待ち商品）の合計が1000P未満の場合は、1000Pを超えてからの発送となります。': {
        'en': 'If the total points earned (for items awaiting shipment) are less than 1000 points, shipment will only be made after the total points exceed 1000 points.',
        'it': 'Se il totale dei punti accumulati (per gli articoli in attesa di spedizione) è inferiore a 1000 punti, la spedizione avverrà solo dopo che il totale dei punti avrà superato i 1000 punti.',
        'de': 'Wenn die Gesamtpunktzahl (für Artikel, die noch auf den Versand warten) unter 1000 Punkten liegt, erfolgt der Versand erst, wenn die Gesamtpunktzahl 1000 Punkte übersteigt.',
        'es': 'Si el total de puntos obtenidos (por los artículos pendientes de envío) es inferior a 1000 puntos, el envío solo se realizará una vez que el total de puntos supere los 1000 puntos.',
        'fr': 'Si le total des points accumulés (pour les articles en attente d\'expédition) est inférieur à 1000 points, l\'expédition ne sera effectuée qu\'une fois le total des points supérieur à 1000 points.',
        'ko': '환원 포인트(발송 대기 상품)의 합계가 1000 P미만의 경우는, 1000 P를 넘고 나서의 발송이 됩니다.',
        'zh': '如果（待出貨商品的）總積分少於 1000 分，則只有在總積分超過 1000 分後才會出貨。',
        'zh-TW': '如果（待发货商品的）总积分少于 1000 分，则只有在总积分超过 1000 分后才会发货。',
      },
      '株式会社はっち': {
        'en': 'Hatch Co., Ltd.',
        'it': 'Hatch Co., Ltd.',
        'de': 'Hatch Co., Ltd.',
        'es': 'Compañía Hatch, Ltd.',
        'fr': 'Hatch Co., Ltd.',
        'ko': '주식회사 하치',
        'zh': '哈奇有限公司',
        'zh-TW': '哈奇有限公司',
      },
      '大阪府大阪市平野区長吉出戸七丁目3-39': {
        'en': '3-39, Nagayoshideto 7-chome, Hirano-ku, Osaka City, Osaka Prefecture',
        'it': '3-39, Nagayoshideto 7-chome, Hirano-ku, Città di Osaka, Prefettura di Osaka',
        'de': '3-39, Nagayoshideto 7-chome, Hirano-ku, Stadt Osaka, Präfektur Osaka',
        'es': '3-39, Nagayoshideto 7-chome, Hirano-ku, ciudad de Osaka, prefectura de Osaka',
        'fr': '3-39, Nagayoshideto 7-chome, Hirano-ku, ville d\'Osaka, préfecture d\'Osaka',
        'ko': '오사카부 오사카시 히라노구 나가요시 데이치 나나초메 3-39',
        'zh': '大阪府大阪市平野區長吉出戶7丁目3-39',
        'zh-TW': '大阪府大阪市平野区长吉出户7丁目3-39',
      },
      '〒547-0011': {
        'en': '547-0011',
        'it': '547-0011',
        'de': '547-0011',
        'es': '547-0011',
        'fr': '547-0011',
        'ko': '〒547-0011',
        'zh': '547-0011',
        'zh-TW': '547-0011',
      },
      'TEL：06-6643-9996': {
        'en': 'TEL: 06-6643-9996',
        'it': 'TEL: 06-6643-9996',
        'de': 'TEL: 06-6643-9996',
        'es': 'TEL: 06-6643-9996',
        'fr': 'TÉL. : 06-6643-9996',
        'ko': 'TEL:06-6643-9996',
        'zh': '電話：06-6643-9996',
        'zh-TW': '电话：06-6643-9996',
      },
      'ドラゴンボール': {
        'en': 'Dragon Ball',
        'it': 'Dragon Ball',
        'de': 'Dragon Ball',
        'es': 'Dragon Ball',
        'fr': 'Dragon Ball',
        'ko': '드래곤볼',
        'zh': '七龍珠',
        'zh-TW': '龙珠',
      },
      'デュエルマスターズ': {
        'en': 'Duel Masters',
        'it': 'Maestri del Duello',
        'de': 'Duellmeister',
        'es': 'Maestros del Duelo',
        'fr': 'Maîtres du duel',
        'ko': '듀얼 마스터스',
        'zh': '決鬥大師',
        'zh-TW': '决斗大师',
      },
      'アーセナルベース': {
        'en': 'Arsenal base',
        'it': 'Base dell\'Arsenale',
        'de': 'Arsenalbasis',
        'es': 'Base del Arsenal',
        'fr': 'Base d\'Arsenal',
        'ko': '아스날 베이스',
        'zh': '阿森納基地',
        'zh-TW': '阿森纳基地',
      },
      'ホロライブ': {
        'en': 'Hololive',
        'it': 'Hololive',
        'de': 'Hololive',
        'es': 'Hololive',
        'fr': 'Hololive',
        'ko': '홀로 라이브',
        'zh': 'Hololive',
        'zh-TW': 'Hololive',
      },
      '八塚 健': {
        'en': 'Ken Yatsuzuka',
        'it': 'Ken Yatsuzuka',
        'de': 'Ken Yatsuzuka',
        'es': 'Ken Yatsuzuka',
        'fr': 'Ken Yatsuzuka',
        'ko': '하치즈카 켄',
        'zh': '八塚健',
        'zh-TW': '八冢健',
      },
      'デジタルコンテンツ': {
        'en': 'Digital content',
        'it': 'Contenuti digitali',
        'de': 'Digitale Inhalte',
        'es': 'Contenido digital',
        'fr': 'contenu numérique',
        'ko': '디지털 콘텐츠',
        'zh': '數位內容',
        'zh-TW': '数字内容',
      },
      '{remaining}コイン購入が必要': {
        'en': '{remaining}Coins purchase required',
        'it': '{remaining}È richiesto l\'acquisto di monete',
        'de': '{remaining}Münzenkauf erforderlich',
        'es': '{remaining}Se requiere compra de monedas',
        'fr': '{remaining}Achat de pièces requis',
        'ko': '{remaining} 동전 구매 필요',
        'zh': '需要購買{remaining}枚硬幣',
        'zh-TW': '需要购买{remaining}个硬币',
      },
      '購入可能': {
        'en': 'Available for purchase',
        'it': 'Disponibile per l\'acquisto',
        'de': 'Zum Kauf erhältlich',
        'es': 'Disponible para la compra',
        'fr': 'Disponible à l\'achat',
        'ko': '구매 가능',
        'zh': '可供購買',
        'zh-TW': '可供购买',
      },
      'ダイヤバンク': {
        'en': 'Diamond Bank',
        'it': 'Banca dei Diamanti',
        'de': 'Diamantenbank',
        'es': 'Banco de Diamantes',
        'fr': 'Banque de diamants',
        'ko': '다이아 뱅크',
        'zh': '鑽石銀行',
        'zh-TW': '钻石银行',
      },
      '紹介ボーナス': {
        'en': 'Referral Bonus',
        'it': 'Bonus di segnalazione',
        'de': 'Empfehlungsbonus',
        'es': 'Bonificación por recomendación',
        'fr': 'Bonus de parrainage',
        'ko': '소개 보너스',
        'zh': '推薦獎金',
        'zh-TW': '推荐奖金',
      },
      '紹介ボーナスコイン': {
        'en': 'Referral bonus coins',
        'it': 'Monete bonus per la segnalazione',
        'de': 'Empfehlungsbonusmünzen',
        'es': 'monedas de bonificación por referidos',
        'fr': 'Pièces bonus de parrainage',
        'ko': '소개 보너스 동전',
        'zh': '推薦獎勵金幣',
        'zh-TW': '推荐奖励金币',
      },
      '支払方法': {
        'en': 'payment method',
        'it': 'metodo di pagamento',
        'de': 'Zahlungsmethode',
        'es': 'método de pago',
        'fr': 'mode de paiement',
        'ko': '지불 방법',
        'zh': '付款方式',
        'zh-TW': '付款方式',
      },
      '支払方法変更': {
        'en': 'Change payment method',
        'it': 'Modifica il metodo di pagamento',
        'de': 'Zahlungsmethode ändern',
        'es': 'Cambiar método de pago',
        'fr': 'Changer le mode de paiement',
        'ko': '지불 방법 변경',
        'zh': '更改付款方式',
        'zh-TW': '更改付款方式',
      },
      '{min}円以上の価格で出品できます。': {
        'en': 'It can be sold at a price of {min} yen or more.',
        'it': 'Può essere venduto a un prezzo di {min} yen o più.',
        'de': 'Es kann zu einem Preis von {min} Yen oder mehr verkauft werden.',
        'es': 'Det kan säljas för ett pris av {min} yen eller mer.',
        'fr': 'Il peut être vendu à un prix de {min} yens ou plus.',
        'ko': '{min} 엔 이상에 판매할 수 있습니다.',
        'zh': 'Può essere venduto a un prezzo di {min} 日元 o più。',
        'zh-TW': 'Può essere venduto a un prezzo di {min} 日元 o più。',
      },
      '販売価格を更新する': {
        'en': 'Update the selling price',
        'it': 'Aggiorna il prezzo di vendita',
        'de': 'Aktualisieren Sie den Verkaufspreis',
        'es': 'Actualizar el precio de venta',
        'fr': 'Mettre à jour le prix de vente',
        'ko': '판매 가격 업데이트',
        'zh': '更新售價',
        'zh-TW': '更新售价',
      },
      '価格を変更する': {
        'en': 'Change price',
        'it': 'Modifica il prezzo',
        'de': 'Preis ändern',
        'es': 'Cambiar precio',
        'fr': 'Changer le prix',
        'ko': '가격 변경',
        'zh': '更改價格',
        'zh-TW': '更改价格',
      },
      'PSAのみ表示': {
        'en': 'Show PSA only',
        'it': 'Mostra solo l\'annuncio di pubblica utilità',
        'de': 'Nur PSA anzeigen',
        'es': 'Mostrar solo el anuncio de servicio público',
        'fr': 'Afficher uniquement le message d\'intérêt public',
        'ko': 'PSA만 표시',
        'zh': '僅顯示PSA',
        'zh-TW': '仅显示PSA',
      },
      'PSAを非表示': {
        'en': 'Hide PSA',
        'it': 'Nascondi l\'annuncio di pubblica utilità',
        'de': 'PSA ausblenden',
        'es': 'Ocultar anuncio de servicio público',
        'fr': 'Masquer le PSA',
        'ko': 'PSA 숨기기',
        'zh': '隱藏公共服務公告',
        'zh-TW': '隐藏公共服务公告',
      },
      'ボーナス': {
        'en': 'bonus',
        'it': 'bonus',
        'de': 'Bonus',
        'es': 'prima',
        'fr': 'prime',
        'ko': '보너스',
        'zh': '獎金',
        'zh-TW': '奖金',
      },
      '埼玉県さいたま市大宮区桜木町1丁目195‑1 大宮ソラミチKOZ4階': {
        'en': '4th Floor, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, Saitama City, Saitama Prefecture',
        'it': '4° piano, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, città di Saitama, prefettura di Saitama',
        'de': '4. Stock, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, Stadt Saitama, Präfektur Saitama',
        'es': '4.º piso, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, ciudad de Saitama, prefectura de Saitama',
        'fr': '4e étage, Omiya Soramichi KOZ, 1-195-1 Sakuragi-cho, Omiya-ku, ville de Saitama, préfecture de Saitama',
        'ko': '사이타마현 사이타마시 오미야구 사쿠라기초 1가 195-1 오미야 소라미치 KOS 4층',
        'zh': '埼玉縣埼玉市大宮區櫻木町1-195-1 大宮空道KOZ 4樓',
        'zh-TW': '埼玉县埼玉市大宫区樱木町1-195-1 大宫空道KOZ 4楼',
      },
      '弊社へ査定依頼品の発送(発払い)': {
        'en': 'Send the items you wish to have appraised to our company (prepaid shipping)',
        'it': 'Invia gli oggetti che desideri far valutare alla nostra azienda (spedizione prepagata).',
        'de': 'Senden Sie die Gegenstände, die Sie schätzen lassen möchten, an unser Unternehmen (Versandkosten im Voraus bezahlt).',
        'es': 'Envíe los artículos que desea que tasemos a nuestra empresa (envío prepagado).',
        'fr': 'Envoyez à notre société les articles que vous souhaitez faire évaluer (frais de port prépayés).',
        'ko': '폐사에 사정 의뢰품의 발송(발불)',
        'zh': '請將您需要估價的物品寄送至我公司（運費預付）。',
        'zh-TW': '请将您需要估价的物品寄送至我公司（运费预付）。',
      },
      ' & 買取申込フォームの送信': {
        'en': '& Submit the purchase request form',
        'it': 'Invia il modulo di richiesta d\'acquisto',
        'de': '& Reichen Sie das Kaufanforderungsformular ein',
        'es': '& Envíe el formulario de solicitud de compra',
        'fr': '& Soumettez le formulaire de demande d\'achat',
        'ko': ' & 구매 신청 양식 제출',
        'zh': '提交採購申請表',
        'zh-TW': '提交采购申请表',
      },
      'メールにて査定結果の送信': {
        'en': 'Sending the appraisal results via email',
        'it': 'Invio dei risultati della valutazione via e-mail',
        'de': 'Die Bewertungsergebnisse werden per E-Mail versendet.',
        'es': 'Envío de los resultados de la tasación por correo electrónico',
        'fr': 'Envoi des résultats de l\'évaluation par courriel',
        'ko': '이메일로 평가 결과 보내기',
        'zh': '透過電子郵件發送評估結果',
        'zh-TW': '通过电子邮件发送评估结果',
      },
      '(到着後2営業日以内)': {
        'en': '(Within 2 business days of arrival)',
        'it': '(Entro 2 giorni lavorativi dall\'arrivo)',
        'de': '(Innerhalb von 2 Werktagen nach Ankunft)',
        'es': '(Dentro de los 2 días hábiles posteriores a la llegada)',
        'fr': '(Dans les 2 jours ouvrables suivant l\'arrivée)',
        'ko': '(도착 후 2 영업일 이내)',
        'zh': '（到貨後 2 個工作天內）',
        'zh-TW': '（到货后 2 个工作日内）',
      },
      'お振込': {
        'en': 'Bank transfer',
        'it': 'Bonifico bancario',
        'de': 'Banküberweisung',
        'es': 'Transferencia bancaria',
        'fr': 'Virement bancaire',
        'ko': '송금',
        'zh': '銀行轉帳',
        'zh-TW': '银行转账',
      },
      '(査定結果へのご同意後2営業日以内)': {
        'en': '(Within 2 business days after you agree to the assessment results)',
        'it': '(Entro 2 giorni lavorativi dall\'accettazione dei risultati della valutazione)',
        'de': '(Innerhalb von 2 Werktagen nach Ihrer Zustimmung zu den Bewertungsergebnissen)',
        'es': '(Dentro de los 2 días hábiles posteriores a su aceptación de los resultados de la evaluación)',
        'fr': '(Dans les 2 jours ouvrables suivant votre acceptation des résultats de l\'évaluation)',
        'ko': '(사정 결과에 동의 후 2 영업일 이내)',
        'zh': '（在您同意評估結果後的 2 個工作天內）',
        'zh-TW': '（在您同意评估结果后的 2 个工作日内）',
      },
      '査定額の受け取り方法': {
        'en': 'How to receive the appraisal amount',
        'it': 'Come ricevere l\'importo della valutazione',
        'de': 'Wie Sie den Schätzwert erhalten',
        'es': 'Cómo recibir el importe de la tasación',
        'fr': 'Comment recevoir le montant de l\'évaluation',
        'ko': '평가 금액을 받는 방법',
        'zh': '如何收到評估金額',
        'zh-TW': '如何收到评估金额',
      },
      '内訳': {
        'en': 'breakdown',
        'it': 'guasto',
        'de': 'abbauen',
        'es': 'descomponer',
        'fr': 'panne',
        'ko': '고장',
        'zh': '分解',
        'zh-TW': '分解',
      },
      '現金+ボーナスコイン1%': {
        'en': 'Cash + 1% Bonus Coins',
        'it': 'Contanti + 1% di monete bonus',
        'de': 'Bargeld + 1% Bonusmünzen',
        'es': 'Efectivo + 1% de monedas de bonificación',
        'fr': 'Argent comptant + 1 % de pièces bonus',
        'ko': '현금 + 보너스 동전 1%',
        'zh': '現金 + 1% 獎勵金幣',
        'zh-TW': '现金 + 1% 奖励金币',
      },
      'マイナンバーカードの場合は表面のみ': {
        'en': 'In the case of My Number Card, only the front side is shown.',
        'it': 'Nel caso di My Number Card, viene mostrato solo il lato anteriore.',
        'de': 'Im Falle der My Number Card wird nur die Vorderseite gezeigt.',
        'es': 'En el caso de My Number Card, solo se muestra el anverso.',
        'fr': 'Dans le cas de la carte My Number Card, seule la face avant est visible.',
        'ko': '마이 넘버 카드의 경우는 표면만',
        'zh': '我的號碼卡只顯示正面。',
        'zh-TW': '我的号码卡只显示正面。',
      },
      '表面': {
        'en': 'surface',
        'it': 'superficie',
        'de': 'Oberfläche',
        'es': 'superficie',
        'fr': 'surface',
        'ko': '표면',
        'zh': '表面',
        'zh-TW': '表面',
      },
      '裏面': {
        'en': 'Back side',
        'it': 'Lato posteriore',
        'de': 'Rückseite',
        'es': 'Parte trasera',
        'fr': 'verso',
        'ko': '뒷면',
        'zh': '背面',
        'zh-TW': '背面',
      },
      ' 申し込みへ ': {
        'en': 'Apply now',
        'it': 'Candidati ora',
        'de': 'Jetzt bewerben',
        'es': 'Solicita ahora',
        'fr': 'Postulez maintenant',
        'ko': ' 신청에',
        'zh': '立即申請',
        'zh-TW': '立即申请',
      },
      'VTuber': {
        'en': 'VTuber',
        'it': 'VTuber',
        'de': 'VTuber',
        'es': 'VTuber',
        'fr': 'VTuber',
        'ko': 'VTuber',
        'zh': '虛擬主播',
        'zh-TW': '虚拟主播',
      },
      '俳優': {
        'en': 'actor',
        'it': 'attore',
        'de': 'Schauspieler',
        'es': 'actor',
        'fr': 'acteur',
        'ko': '배우',
        'zh': '演員',
        'zh-TW': '演员',
      },
      'グッズ': {
        'en': 'merchandise',
        'it': 'merce',
        'de': 'Waren',
        'es': 'mercancías',
        'fr': 'marchandises',
        'ko': '상품',
        'zh': '商品',
        'zh-TW': '商品',
      },
      'スポーツ': {
        'en': 'Sports',
        'it': 'Sport',
        'de': 'Sport',
        'es': 'Deportes',
        'fr': 'Sportif',
        'ko': '스포츠',
        'zh': '運動的',
        'zh-TW': '运动的',
      },
      '1タップで「ダウンロード」': {
        'en': 'Download with one tap',
        'it': 'Scarica con un solo tocco',
        'de': 'Mit einem Fingertipp herunterladen',
        'es': 'Descarga con un solo toque',
        'fr': 'Télécharger en un clic',
        'ko': '1 탭으로 "다운로드"',
        'zh': '一鍵下載',
        'zh-TW': '一键下载',
      },
      'ダウンロード': {
        'en': 'download',
        'it': 'scaricamento',
        'de': 'herunterladen',
        'es': 'descargar',
        'fr': 'télécharger',
        'ko': '다운로드',
        'zh': '下載',
        'zh-TW': '下载',
      },
      'ダウンロードのみ': {
        'en': 'Download only',
        'it': 'Solo download',
        'de': 'Nur herunterladen',
        'es': 'Solo descarga',
        'fr': 'Téléchargement uniquement',
        'ko': '다운로드만',
        'zh': '僅下載',
        'zh-TW': '仅下载',
      },
      'ダウンロード済み': {
        'en': 'Downloaded',
        'it': 'Scaricato',
        'de': 'Heruntergeladen',
        'es': 'Descargado',
        'fr': 'Téléchargé',
        'ko': '다운로드됨',
        'zh': '下載',
        'zh-TW': '下载',
      },
      'ダウンロード済み一覧': {
        'en': 'Downloaded items list',
        'it': 'Elenco degli elementi scaricati',
        'de': 'Liste der heruntergeladenen Elemente',
        'es': 'Lista de elementos descargados',
        'fr': 'Liste des éléments téléchargés',
        'ko': '다운로드된 목록',
        'zh': '下載項目列表',
        'zh-TW': '下载项目列表',
      },
      '表示': {
        'en': 'display',
        'it': 'display',
        'de': 'Anzeige',
        'es': 'mostrar',
        'fr': 'afficher',
        'ko': '표시',
        'zh': '展示',
        'zh-TW': '展示',
      },
      '景品を確認する': {
        'en': 'Check your prize',
        'it': 'Controlla il tuo premio',
        'de': 'Überprüfen Sie Ihren Gewinn',
        'es': 'Comprueba tu premio',
        'fr': 'Vérifiez votre prix',
        'ko': '경품 확인',
        'zh': '查看您的獎品',
        'zh-TW': '查看您的奖品',
      },
      '販売商品': {
        'en': 'Products for sale',
        'it': 'Prodotti in vendita',
        'de': 'Produkte zum Verkauf',
        'es': 'Productos en venta',
        'fr': 'Produits à vendre',
        'ko': '판매 상품',
        'zh': '待售產品',
        'zh-TW': '待售产品',
      },
      'あとで決める': {
        'en': 'I\'ll decide later',
        'it': 'Deciderò più tardi',
        'de': 'Ich entscheide später.',
        'es': 'Lo decidiré más tarde.',
        'fr': 'Je déciderai plus tard.',
        'ko': '나중에 결정',
        'zh': '我稍後再決定。',
        'zh-TW': '我稍后再决定。',
      },
      'ウルトラマン': {
        'en': 'Ultraman',
        'it': 'Ultraman',
        'de': 'Ultraman',
        'es': 'Ultraman',
        'fr': 'Ultraman',
        'ko': '울트라맨',
        'zh': '奧特曼',
        'zh-TW': '奥特曼',
      },
      'SMS認証完了後、マイページに表示される「紹介コード」をご友人に会員登録時に入力してもらってください。\nそのご友人が「SMS認証」と「コイン購入」で、あなたとご友人の双方にコインが入ります。\n※双方が貰えるコイン数はこちらからご確認ください。': {
        'en': 'After SMS authentication is completed, please have your friend enter the "referral code" displayed on your My Page during their membership registration. \nWhen that friend completes "SMS authentication" and "coin purchase," both you and your friend will receive coins. \n*Please check here for the number of coins both parties can receive.',
        'it': 'Dopo aver completato l\'autenticazione SMS, chiedi al tuo amico di inserire il "codice di riferimento" visualizzato sulla tua pagina personale durante la registrazione al loro abbonamento. Quando quell\'amico completa l\'"autenticazione SMS" e l\'"acquisto di monete", sia tu che il tuo amico riceverete monete. *Controlla qui per il numero di monete che entrambe le parti possono ricevere.',
        'de': 'Nachdem die SMS-Authentifizierung abgeschlossen ist, lassen Sie bitte Ihren Freund den "Empfehlungscode" eingeben, der auf Ihrer Mein-Seite während seiner Mitgliedsregistrierung angezeigt wird. Wenn dieser Freund die "SMS-Authentifizierung" und den "Münzkauf" abschließt, erhalten sowohl Sie als auch Ihr Freund Münzen. *Bitte überprüfen Sie hier die Anzahl der Münzen, die beide Parteien erhalten können.',
        'es': 'Después de completar la autenticación por SMS, por favor pide a tu amigo que ingrese el "código de referencia" que se muestra en tu Mi Página durante su registro de membresía. Cuando ese amigo complete la "autenticación por SMS" y la "compra de monedas", tanto tú como tu amigo recibirán monedas. *Por favor, consulta aquí para conocer el número de monedas que ambas partes pueden recibir.',
        'fr': 'Après avoir terminé l\'authentification par SMS, veuillez demander à votre ami d\'entrer le "code de parrainage" affiché sur votre page personnelle lors de son inscription. Lorsque cet ami termine l\'"authentification par SMS" et l\'"achat de pièces", vous et votre ami recevrez des pièces. *Veuillez vérifier ici le nombre de pièces que les deux parties peuvent recevoir.',
        'ko': 'SMS 인증이 완료되면, 친구가 회원 가입 시 귀하의 마이 페이지에 표시된 "추천 코드"를 입력하도록 하세요. 그 친구가 "SMS 인증"과 "코인 구매"를 완료하면, 귀하와 친구 모두 코인을 받게 됩니다. *양측이 받을 수 있는 코인의 수는 여기를 확인하세요.',
        'zh': '完成 SMS 驗證後，請讓您的朋友在註冊會員時輸入顯示在您的我的頁面上的「推薦碼」。當該朋友完成「SMS 驗證」和「購買硬幣」後，您和您的朋友都將獲得硬幣。*請在此處查看雙方可以獲得的硬幣數量。',
        'zh-TW': '在完成短信验证后，请让您的朋友在注册会员时输入显示在您的我的页面上的“推荐码”。当该朋友完成“短信验证”和“购买硬币”后，您和您的朋友都将获得硬币。*请在此处查看双方可以获得的硬币数量。',
      },
      'シルバー会員以上の方はマイページの専用ボタンでコインを消費することにより、1つ下のランクから翌月はスタートすることが可能です。\n※ブロンズランクは3ヶ月間ブロンズが維持されます。\n詳細はこちらからご確認ください。': {
        'en': 'Silver members and above can start from one rank lower the following month by consuming coins with the dedicated button on My Page. \n*Bronze rank is maintained for three months. Please check the details here.',
        'it': 'I membri Silver e superiori possono iniziare da un grado inferiore il mese successivo consumando monete con il pulsante dedicato nella Mia Pagina. *Il grado Bronze è mantenuto per tre mesi. Si prega di controllare i dettagli qui.',
        'de': 'Silbermitglieder und höher können im folgenden Monat eine Stufe niedriger beginnen, indem sie Münzen mit der speziellen Schaltfläche auf Meine Seite verwenden. *Bronze-Rang wird für drei Monate beibehalten. Bitte überprüfen Sie die Details hier.',
        'es': 'Los miembros de plata y superiores pueden comenzar desde un rango inferior el mes siguiente consumiendo monedas con el botón dedicado en Mi Página. *El rango de bronce se mantiene durante tres meses. Por favor, consulte los detalles aquí.',
        'fr': 'Les membres Silver et supérieurs peuvent commencer à partir d\'un rang inférieur le mois suivant en consommant des pièces avec le bouton dédié sur Ma Page. *Le rang Bronze est maintenu pendant trois mois. Veuillez vérifier les détails ici.',
        'ko': '실버 회원 이상은 마이 페이지의 전용 버튼을 사용하여 코인을 소모함으로써 다음 달에 한 단계 낮은 등급에서 시작할 수 있습니다. *브론즈 등급은 3개월 동안 유지됩니다. 자세한 내용은 여기를 확인하세요.',
        'zh': '銀級會員及以上可以在我的頁面上使用專用按鈕消耗硬幣，從下一個月開始從低一級的排名開始。 *銅級排名維持三個月。請在此查看詳細信息。',
        'zh-TW': '银级会员及以上可以在我的页面上使用专用按钮消耗金币，从下个月开始从低一级别开始。*铜级别保持三个月。请在此处查看详细信息。',
      },
      'ご検討ありがとうございます。まずはこちらよりお問合せをお願いいたします。': {
        'en': 'Thank you for your consideration. Please contact us from here first.',
        'it': 'Grazie per la vostra considerazione. Vi preghiamo di contattarci prima da qui.',
        'de': 'Vielen Dank für Ihre Berücksichtigung. Bitte kontaktieren Sie uns zuerst hier.',
        'es': 'Gracias por su consideración. Por favor, contáctenos desde aquí primero.',
        'fr': 'Merci pour votre considération. Veuillez nous contacter d\'ici d\'abord.',
        'ko': '감사합니다. 먼저 여기에서 저희에게 연락해 주세요.',
        'zh': '感謝您的考慮。請先從這裡聯繫我們。',
        'zh-TW': '感谢您的考虑。请先从这里联系我们。',
      },
      '原則2営業日以内にお返事いたします。': {
        'en': 'We will reply within 2 business days in principle.',
        'it': 'Risponderemo entro 2 giorni lavorativi in linea di principio.',
        'de': 'Wir werden grundsätzlich innerhalb von 2 Werktagen antworten.',
        'es': 'Responderemos en un plazo de 2 días hábiles en principio.',
        'fr': 'Nous répondrons en principe dans un délai de 2 jours ouvrables.',
        'ko': '원칙적으로 영업일 기준 2일 이내에 회신하겠습니다.',
        'zh': '原則上，我們會在2個工作天內回覆。',
        'zh-TW': '我们原则上将在2个工作日内回复。',
      },
      '動画を離脱することなく、最後までご視聴ください。\nそれでも反映されない場合は恐れ入りますがお問い合わせくださいませ。': {
        'en': 'Please watch the video until the end without leaving. If it still doesn\'t reflect, we apologize, but please contact us.',
        'it': 'Si prega di guardare il video fino alla fine senza uscire. Se ancora non si riflette, ci scusiamo, ma vi preghiamo di contattarci.',
        'de': 'Bitte sehen Sie sich das Video bis zum Ende an, ohne es zu verlassen. Wenn es immer noch nicht angezeigt wird, entschuldigen wir uns, aber bitte kontaktieren Sie uns.',
        'es': 'Por favor, mira el video hasta el final sin salir. Si aún no se refleja, nos disculpamos, pero por favor contáctanos.',
        'fr': 'Veuillez regarder la vidéo jusqu\'à la fin sans quitter. Si cela ne se reflète toujours pas, nous nous excusons, mais veuillez nous contacter.',
        'ko': '끝까지 나가지 않고 영상을 시청해 주세요. 그래도 반영되지 않으면 죄송하지만, 저희에게 연락해 주세요.',
        'zh': '請觀看影片直到結束而不離開。如果仍然沒有反映，我們很抱歉，但請聯繫我們。',
        'zh-TW': '请观看视频直到结束，不要离开。如果仍然没有反映，我们很抱歉，但请联系我们。',
      },
      '発送は、毎月5日・10日・15日・20日・25日・月末におこなわせていただきます。': {
        'en': 'Shipments are generally made around the 10th, 20th, and 30th of each month.\n*The monthly shipping schedule will be posted on the website each month.\n*Shipments may be delayed at our discretion if the number of items to ship is low. If you have any concerns, please feel free to contact us.',
        'it': 'Le spedizioni vengono generalmente effettuate intorno al 10, 20 e 30 di ogni mese. *Il programma di spedizione mensile sarà pubblicato sul sito web ogni mese. *Le spedizioni possono essere ritardate a nostra discrezione se il numero di articoli da spedire è basso. Se hai qualche preoccupazione, non esitare a contattarci.',
        'de': 'Sendungen erfolgen in der Regel um den 10., 20. und 30. eines jeden Monats. *Der monatliche Versandplan wird jeden Monat auf der Website veröffentlicht. *Sendungen können nach unserem Ermessen verzögert werden, wenn die Anzahl der zu versendenden Artikel gering ist. Wenn Sie Bedenken haben, können Sie uns gerne kontaktieren.',
        'es': 'Los envíos generalmente se realizan alrededor del 10, 20 y 30 de cada mes. *El calendario de envíos mensuales se publicará en el sitio web cada mes. *Los envíos pueden retrasarse a nuestra discreción si la cantidad de artículos a enviar es baja. Si tiene alguna inquietud, no dude en contactarnos.',
        'fr': 'Les expéditions sont généralement effectuées autour du 10, 20 et 30 de chaque mois. *Le calendrier d\'expédition mensuel sera affiché sur le site web chaque mois. *Les expéditions peuvent être retardées à notre discrétion si le nombre d\'articles à expédier est faible. Si vous avez des préoccupations, n\'hésitez pas à nous contacter.',
        'ko': '배송은 일반적으로 매월 10일, 20일, 30일에 이루어집니다. *매월 배송 일정은 웹사이트에 게시됩니다. *배송할 품목 수가 적을 경우 당사의 재량에 따라 배송이 지연될 수 있습니다. 궁금한 점이 있으면 언제든지 문의해 주세요.',
        'zh': '出貨通常在每月的10日、20日和30日左右進行。 *每月的出貨時間表將在網站上公佈。 *如果出貨數量較少，我們可能會酌情延遲出貨。如有任何疑慮，請隨時與我們聯繫。',
        'zh-TW': '货物通常在每月的10号、20号和30号发出。*每月的发货时间表将发布在网站上。*如果发货数量较少，我们可能会酌情延迟发货。如有任何疑虑，请随时联系我们。',
      },
      '配送過程で傷が付かないよう丁寧に梱包することを心掛けます。\nもし、ご希望やご要望等がございましたらご遠慮なく本サイトのチャットよりお申し付けくださいませ。': {
        'en': 'We take care to pack items carefully to prevent damage during shipping.\nIf you have any requests or preferences, please feel free to let us know via the chat on this site or WhatsApp.',
        'it': 'Ci prendiamo cura di imballare gli articoli con attenzione per prevenire danni durante la spedizione. Se hai richieste o preferenze, non esitare a farcelo sapere tramite la chat su questo sito o WhatsApp.',
        'de': 'Wir achten darauf, die Artikel sorgfältig zu verpacken, um Schäden während des Versands zu vermeiden. Wenn Sie Wünsche oder Vorlieben haben, lassen Sie es uns bitte über den Chat auf dieser Seite oder WhatsApp wissen.',
        'es': 'Nos encargamos de embalar los artículos cuidadosamente para evitar daños durante el envío. Si tiene alguna solicitud o preferencia, no dude en hacérnoslo saber a través del chat en este sitio o por WhatsApp.',
        'fr': 'Nous prenons soin d\'emballer les articles avec précaution pour éviter les dommages pendant le transport. Si vous avez des demandes ou des préférences, n\'hésitez pas à nous le faire savoir via le chat sur ce site ou WhatsApp.',
        'ko': '저희는 배송 중 손상을 방지하기 위해 물품을 신중하게 포장합니다. 요청 사항이나 선호 사항이 있으시면 이 사이트의 채팅이나 WhatsApp을 통해 언제든지 알려주십시오.',
        'zh': '我們會小心包裝物品以防止在運送過程中受損。如果您有任何要求或偏好，請隨時通過此網站的聊天或 WhatsApp 告訴我們。',
        'zh-TW': '我们会小心包装物品，以防止在运输过程中损坏。如果您有任何要求或偏好，请随时通过本网站的聊天或WhatsApp告知我们。',
      },
      'ヤマト運輸にて発送いたします。': {
        'en': 'We will ship via the post office, FedEx, or other carriers designated by our company.',
        'it': 'Spediremo tramite l\'ufficio postale, FedEx o altri corrieri designati dalla nostra azienda.',
        'de': 'Wir versenden über die Post, FedEx oder andere von unserem Unternehmen benannte Spediteure.',
        'es': 'Enviaremos a través de la oficina de correos, FedEx u otros transportistas designados por nuestra empresa.',
        'fr': 'Nous expédierons via la poste, FedEx ou d\'autres transporteurs désignés par notre entreprise.',
        'ko': '우리는 우체국, FedEx 또는 당사에서 지정한 다른 운송업체를 통해 배송할 것입니다.',
        'zh': '我們將通過郵局、FedEx或我們公司指定的其他運輸公司發貨。',
        'zh-TW': '我们将通过邮局、联邦快递或我公司指定的其他承运商发货。',
      },
      '送料は弊社が全額負担で元払いで発送いたします。': {
        'en': 'We will pay all shipping costs and ship the item prepaid. However, customs duties will be borne by the customer.',
        'it': 'Coprireremo tutti i costi di spedizione e spediremo l\'articolo in porto franco. Tuttavia, i dazi doganali saranno a carico del cliente.',
        'de': 'Wir übernehmen alle Versandkosten und versenden den Artikel frachtfrei. Allerdings werden die Zollgebühren vom Kunden getragen.',
        'es': 'Nosotros pagaremos todos los costos de envío y enviaremos el artículo prepagado. Sin embargo, los derechos de aduana serán asumidos por el cliente.',
        'fr': 'Nous paierons tous les frais d\'expédition et expédierons l\'article en port payé. Cependant, les droits de douane seront à la charge du client.',
        'ko': '모든 배송비를 지불하고 선불로 배송하겠습니다. 그러나 관세는 고객이 부담합니다.',
        'zh': '我們將支付所有運費並預付運送物品。然而，關稅將由客戶承擔。',
        'zh-TW': '我们将支付所有运费并预付运费。然而，关税将由客户承担。',
      },
      'こちらよりご確認をお願いいたします。': {
        'en': 'Please check here.',
        'it': 'Si prega di controllare qui.',
        'de': 'Bitte hier überprüfen.',
        'es': 'Por favor, verifica aquí.',
        'fr': 'Veuillez vérifier ici.',
        'ko': '여기를 확인해 주세요.',
        'zh': '請在這裡查看。',
        'zh-TW': '请在这里查看。',
      },
      '発送通知日と実際の発送日は配送業務の関係上異なってしまうことがございます。\nそのため、毎月5日・10日・15日・20日・25日・月末の夕方以降にご確認をお願いいたします。': {
        'en': 'Due to shipping operations, the date of the shipping notification and the actual shipping date may differ.\nTherefore, the tracking number may appear on the next business day after the shipping notification. We kindly ask for your understanding in advance.',
        'it': 'A causa delle operazioni di spedizione, la data della notifica di spedizione e la data effettiva di spedizione possono differire. Pertanto, il numero di tracciamento potrebbe apparire il giorno lavorativo successivo alla notifica di spedizione. Vi chiediamo gentilmente di comprendere in anticipo.',
        'de': 'Aufgrund von Versandvorgängen können das Datum der Versandbenachrichtigung und das tatsächliche Versanddatum abweichen. Daher kann die Sendungsnummer am nächsten Werktag nach der Versandbenachrichtigung erscheinen. Wir bitten im Voraus um Ihr Verständnis.',
        'es': 'Debido a las operaciones de envío, la fecha de la notificación de envío y la fecha real de envío pueden diferir. Por lo tanto, el número de seguimiento puede aparecer el siguiente día hábil después de la notificación de envío. Le pedimos amablemente su comprensión de antemano.',
        'fr': 'En raison des opérations d\'expédition, la date de la notification d\'expédition et la date réelle d\'expédition peuvent différer. Par conséquent, le numéro de suivi peut apparaître le jour ouvrable suivant la notification d\'expédition. Nous vous demandons votre compréhension à l\'avance.',
        'ko': '배송 작업으로 인해 배송 알림 날짜와 실제 배송 날짜가 다를 수 있습니다. 따라서 배송 알림 후 다음 영업일에 추적 번호가 나타날 수 있습니다. 미리 양해 부탁드립니다.',
        'zh': '由於運輸操作，出貨通知日期和實際出貨日期可能會有所不同。因此，追蹤號碼可能會在出貨通知後的下一個工作日出現。敬請提前諒解。',
        'zh-TW': '由于运输操作，发货通知日期和实际发货日期可能会有所不同。因此，跟踪号码可能会在发货通知后的下一个工作日出现。我们提前感谢您的理解。',
      },
      'こちらからお問い合わせください。弊社側で変更いたします。': {
        'en': 'Please contact us via WhatsApp or the website chat.\nWhatsApp is here.',
        'it': 'Si prega di contattarci tramite WhatsApp o la chat del sito web. WhatsApp è qui.',
        'de': 'Bitte kontaktieren Sie uns über WhatsApp oder den Website-Chat. WhatsApp ist hier.',
        'es': 'Por favor, contáctenos a través de WhatsApp o el chat del sitio web. WhatsApp está aquí.',
        'fr': 'Veuillez nous contacter via WhatsApp ou le chat du site web. WhatsApp est ici.',
        'ko': 'WhatsApp 또는 웹사이트 채팅을 통해 저희에게 연락해 주세요. WhatsApp은 여기에 있습니다.',
        'zh': '請透過 WhatsApp 或網站聊天聯繫我們。WhatsApp 在這裡。',
        'zh-TW': '请通过 WhatsApp 或网站聊天与我们联系。WhatsApp 在这里。',
      },
      '一律「中古品(二次流通品)・傷あり品」というご認識でお願いいたします。\nご留意事項等はこちらよりご確認をお願いいたします。': {
        'en': 'Please understand that all items are "used (second-hand) and may have scratches."\n\nPlease check here for important notes and other information.',
        'it': 'Si prega di capire che tutti gli articoli sono di seconda mano (circolazione secondaria) e danneggiati. Si prega di controllare qui per i punti importanti da notare.',
        'de': 'Bitte beachten Sie, dass alle Artikel gebraucht (sekundäre Zirkulation) und beschädigt sind. Bitte überprüfen Sie hier wichtige Punkte, die zu beachten sind.',
        'es': 'Por favor, comprenda que todos los artículos son de segunda mano (circulación secundaria) y están dañados. Por favor, consulte aquí los puntos importantes a tener en cuenta.',
        'fr': 'Veuillez comprendre que tous les articles sont d\'occasion (circulation secondaire) et endommagés. Veuillez vérifier ici les points importants à noter.',
        'ko': '모든 물품은 중고(2차 유통)이며 손상된 것임을 이해해 주시기 바랍니다. 중요한 사항은 여기를 확인해 주세요.',
        'zh': '請理解所有物品都是二手的（次級流通）且有損壞。請在此查看重要注意事項。',
        'zh-TW': '请理解，所有物品都是二手的（再次流通）并且有损坏。请在此查看需要注意的重要事项。',
      },
      '弊社で保管しているデータと確認させていただきます。\n恐れ入りますが、こちらよりお問い合わせくださいませ。': {
        'en': 'We will verify the data stored in our company.\nWe apologize for the inconvenience, but please contact us via the chat on this site or WhatsApp.\nWhatsApp is here',
        'it': 'Verificheremo i dati memorizzati nella nostra azienda. Ci scusiamo per l\'inconveniente, ma contattaci tramite la chat su questo sito o WhatsApp. WhatsApp è qui.',
        'de': 'Wir werden die in unserem Unternehmen gespeicherten Daten überprüfen. Wir entschuldigen uns für die Unannehmlichkeiten, aber bitte kontaktieren Sie uns über den Chat auf dieser Seite oder WhatsApp. WhatsApp ist hier.',
        'es': 'Verificaremos los datos almacenados en nuestra empresa. Pedimos disculpas por las molestias, pero por favor contáctenos a través del chat en este sitio o por WhatsApp. WhatsApp está aquí.',
        'fr': 'Nous vérifierons les données stockées dans notre entreprise. Nous nous excusons pour le désagrément, mais veuillez nous contacter via le chat sur ce site ou WhatsApp. WhatsApp est ici.',
        'ko': '저장된 데이터를 확인하겠습니다. 불편을 드려 죄송합니다만, 이 사이트의 채팅이나 WhatsApp을 통해 저희에게 연락해 주세요. WhatsApp은 여기에 있습니다.',
        'zh': '我們將驗證存儲在我們公司中的數據。很抱歉造成不便，但請通過此網站上的聊天或 WhatsApp 聯繫我們。WhatsApp 在這裡。',
        'zh-TW': '我们将验证存储在我们公司中的数据。我们对给您带来的不便表示歉意，但请通过本网站的聊天或WhatsApp与我们联系。WhatsApp在这里。',
      },
      '出品は、ブロンズ会員以上の方のみとなります。\nまた、当該ガチャの1回あたりの販売コイン数を上回る還元コイン数以上のお品物しか出品できません。': {
        'en': 'Only Bronze members and above are eligible to list items for sale.\n\nFurthermore, you can only list items whose value exceeds the number of coins earned per single draw of the gacha.',
        'it': 'Solo i membri Bronze e superiori possono elencare articoli. Inoltre, puoi elencare articoli solo con un numero di monete premio che supera il numero di monete vendute per ogni estrazione del gacha in questione.',
        'de': 'Nur Bronze-Mitglieder und höher können Artikel auflisten. Außerdem können Sie nur Artikel mit einer Anzahl von Belohnungsmünzen auflisten, die die Anzahl der pro Zug des betreffenden Gacha verkauften Münzen übersteigt.',
        'es': 'Solo los miembros de Bronce y superiores pueden listar artículos. Además, solo puedes listar artículos con un número de monedas de recompensa que exceda el número de monedas vendidas por tirada del gacha en cuestión.',
        'fr': 'Seuls les membres Bronze et supérieurs peuvent répertorier des articles. De plus, vous ne pouvez répertorier des articles qu\'avec un nombre de pièces de récompense supérieur au nombre de pièces vendues par tirage du gacha en question.',
        'ko': '브론즈 회원 이상만 항목을 나열할 수 있습니다. 또한, 해당 가챠의 한 번 뽑기에 판매된 코인 수를 초과하는 보상 코인 수를 가진 항목만 나열할 수 있습니다.',
        'zh': '只有銅級會員及以上等級的會員可以列出物品。此外，您只能列出獎勵硬幣數量超過該扭蛋每次抽取所售硬幣數量的物品。',
        'zh-TW': '只有青铜会员及以上级别的会员可以列出物品。此外，您只能列出奖励币数量超过所涉及扭蛋每次抽取所售币数量的物品。',
      },
      'ログイン画面よりパスワード再発行をクリックして、仮パスワードでログインしてください。\nその後、マイページよりパスワードをご変更ください。': {
        'en': 'Please click "Reset Password" on the login screen and log in with the temporary password.\n\nAfterward, please change your password from your My Page.',
        'it': 'Fare clic su "Riemetti password" nella schermata di accesso e accedi con la tua password temporanea. Quindi, cambia la tua password dalla Mia Pagina.',
        'de': 'Bitte klicken Sie auf "Passwort neu ausstellen" auf dem Anmeldebildschirm und melden Sie sich mit Ihrem temporären Passwort an. Dann ändern Sie bitte Ihr Passwort auf Meine Seite.',
        'es': 'Por favor, haz clic en "Reemitir contraseña" en la pantalla de inicio de sesión e inicia sesión con tu contraseña temporal. Luego, por favor cambia tu contraseña desde Mi Página.',
        'fr': 'Veuillez cliquer sur "Réémettre le mot de passe" sur l\'écran de connexion et vous connecter avec votre mot de passe temporaire. Ensuite, veuillez changer votre mot de passe depuis Ma Page.',
        'ko': '로그인 화면에서 "비밀번호 재발급"을 클릭하고 임시 비밀번호로 로그인하세요. 그런 다음, 마이 페이지에서 비밀번호를 변경해 주세요.',
        'zh': '請在登入畫面上點擊「重新發行密碼」，並使用您的臨時密碼登入。然後，請在我的頁面中更改您的密碼。',
        'zh-TW': '请在登录界面点击“重新发放密码”，并使用您的临时密码登录。然后，请在我的页面更改您的密码。',
      },
      '恐れ入りますが、こちらよりその旨のご連絡をお願いいたします。': {
        'en': 'We apologize for the inconvenience, but please contact us via this site\'s chat or WhatsApp to inform us of this matter.\nWhatsApp is here',
        'it': 'Ci scusiamo per l\'inconveniente, ma ti preghiamo di contattarci tramite la chat di questo sito o WhatsApp per informarci di questa questione. WhatsApp è qui.',
        'de': 'Wir entschuldigen uns für die Unannehmlichkeiten, aber bitte kontaktieren Sie uns über den Chat dieser Seite oder WhatsApp, um uns über diese Angelegenheit zu informieren. WhatsApp ist hier.',
        'es': 'Lamentamos las molestias, pero por favor contáctenos a través del chat de este sitio o WhatsApp para informarnos sobre este asunto. WhatsApp está aquí.',
        'fr': 'Nous nous excusons pour le désagrément, mais veuillez nous contacter via le chat de ce site ou WhatsApp pour nous informer de ce problème. WhatsApp est ici.',
        'ko': '불편을 드려 죄송합니다만, 이 사이트의 채팅이나 WhatsApp을 통해 이 문제를 알려주시기 바랍니다. WhatsApp은 여기에 있습니다.',
        'zh': '我們對此不便深感抱歉，但請通過此網站的聊天或 WhatsApp 聯繫我們以告知此事。WhatsApp 在這裡。',
        'zh-TW': '对于给您带来的不便，我们深表歉意，但请通过本网站的聊天或WhatsApp与我们联系以告知我们此事。WhatsApp在这里。',
      },
      '複数アカウントの所持は禁止しております。\n発覚した際は、告知なくアカウント制限の対象となりますので、ご留意くださいませ。': {
        'en': 'The possession of multiple accounts is prohibited. If discovered, the account will be subject to restrictions without notice, so please be aware.',
        'it': 'Il possesso di più account è vietato. Se scoperto, l\'account sarà soggetto a restrizioni senza preavviso, quindi si prega di esserne consapevoli.',
        'de': 'Der Besitz mehrerer Konten ist verboten. Wenn dies entdeckt wird, unterliegt das Konto ohne Vorankündigung Einschränkungen, also bitte beachten.',
        'es': 'La posesión de múltiples cuentas está prohibida. Si se descubre, la cuenta estará sujeta a restricciones sin previo aviso, así que por favor tenga en cuenta.',
        'fr': 'La possession de plusieurs comptes est interdite. Si elle est découverte, le compte sera soumis à des restrictions sans préavis, alors veuillez en être conscient.',
        'ko': '다중 계정 소유는 금지되어 있습니다. 발견될 경우, 계정은 통보 없이 제한될 수 있으니 유의하시기 바랍니다.',
        'zh': '禁止擁有多個帳戶。如果被發現，帳戶將在不通知的情況下受到限制，請注意。',
        'zh-TW': '禁止拥有多个账户。如果被发现，账户将受到限制，恕不另行通知，请注意。',
      },
      '可能です。\n※1台で複数アカウントの利用はアカウント制限の対象にもなり得ますためお控えくださいませ。': {
        'en': 'It is possible. *Please refrain from using multiple accounts on one device as it may be subject to account restrictions.',
        'it': 'È possibile. *Si prega di astenersi dall\'utilizzare più account su un dispositivo poiché potrebbe essere soggetto a restrizioni dell\'account.',
        'de': 'Es ist möglich. *Bitte verzichten Sie darauf, mehrere Konten auf einem Gerät zu verwenden, da dies zu Kontobeschränkungen führen kann.',
        'es': 'Es posible. *Por favor, abstente de usar múltiples cuentas en un solo dispositivo, ya que puede estar sujeto a restricciones de cuenta.',
        'fr': 'C\'est possible. *Veuillez vous abstenir d\'utiliser plusieurs comptes sur un seul appareil, car cela pourrait entraîner des restrictions de compte.',
        'ko': '가능합니다. *하나의 기기에서 여러 계정을 사용하는 것을 자제해 주세요. 계정 제한이 있을 수 있습니다.',
        'zh': '這是可能的。*請避免在一個設備上使用多個帳戶，因為這可能會受到帳戶限制。',
        'zh-TW': '有可能。*请避免在一台设备上使用多个账户，因为这可能会导致账户限制。',
      },
      '弊社に到着後、原則2営業日には査定結果をお送りいたします。': {
        'en': 'We will send you the appraisal results in principle within two business days after arrival at our company.',
        'it': 'Ti invieremo i risultati della valutazione in linea di principio entro due giorni lavorativi dall\'arrivo presso la nostra azienda.',
        'de': 'Wir werden Ihnen die Bewertungsergebnisse grundsätzlich innerhalb von zwei Werktagen nach Eingang in unserem Unternehmen zusenden.',
        'es': 'Le enviaremos los resultados de la tasación en principio dentro de dos días hábiles después de la llegada a nuestra empresa.',
        'fr': 'Nous vous enverrons les résultats de l\'évaluation en principe dans les deux jours ouvrables suivant l\'arrivée dans notre entreprise.',
        'ko': '원칙적으로 당사 도착 후 영업일 기준 이틀 이내에 평가 결과를 보내드리겠습니다.',
        'zh': '我們將在收到後的兩個工作日內原則上發送給您評估結果。',
        'zh-TW': '我们将在到达我公司后原则上在两个工作日内将评估结果发送给您。',
      },
      '査定結果へご同意から2営業日以内にお振込いたします。': {
        'en': 'We will transfer the money within two business days after agreeing to the assessment results.',
        'it': 'Trasferiremo il denaro entro due giorni lavorativi dopo aver accettato i risultati della valutazione.',
        'de': 'Wir werden das Geld innerhalb von zwei Werktagen nach Zustimmung zu den Bewertungsergebnissen überweisen.',
        'es': 'Transferiremos el dinero dentro de dos días hábiles después de aceptar los resultados de la evaluación.',
        'fr': 'Nous transférerons l\'argent dans les deux jours ouvrables suivant l\'accord sur les résultats de l\'évaluation.',
        'ko': '평가 결과에 동의한 후 영업일 기준 이틀 내에 돈을 이체하겠습니다.',
        'zh': '我們會在同意評估結果後的兩個工作日內轉帳。',
        'zh-TW': '我们将在同意评估结果后的两个工作日内转账。',
      },
      '可能です。1枚からでもご返送を承ります。\n着払いにてご返送をさせていただきます。': {
        'en': 'It is possible. We accept returns even for one item. We will arrange the return shipping at our expense.',
        'it': 'È possibile. Accettiamo resi anche per un solo articolo. Organizzeremo la spedizione di ritorno a nostre spese.',
        'de': 'Es ist möglich. Wir akzeptieren Rücksendungen auch für einen Artikel. Wir organisieren den Rückversand auf unsere Kosten.',
        'es': 'Es posible. Aceptamos devoluciones incluso por un solo artículo. Organizaremos el envío de devolución a nuestro cargo.',
        'fr': 'C\'est possible. Nous acceptons les retours même pour un seul article. Nous organiserons le retour à nos frais.',
        'ko': '가능합니다. 저희는 한 개의 상품이라도 반품을 받습니다. 반품 배송은 저희가 비용을 부담하여 처리하겠습니다.',
        'zh': '這是可能的。我們即使是一件商品也接受退貨。我們將安排退貨運費，費用由我們承擔。',
        'zh-TW': '有可能。即使是一件商品，我们也接受退货。我们将安排退货运输，费用由我们承担。',
      },
      '買取表に記載のカードのみとなります。\n予めご容赦くださいませ。': {
        'en': 'Only the cards listed on the purchase form are applicable. Please understand in advance.',
        'it': 'Solo le carte elencate nel modulo d\'acquisto sono applicabili. Si prega di comprendere in anticipo.',
        'de': 'Nur die auf dem Kaufformular aufgeführten Karten sind anwendbar. Bitte haben Sie im Voraus Verständnis.',
        'es': 'Solo las tarjetas enumeradas en el formulario de compra son aplicables. Por favor, comprenda de antemano.',
        'fr': 'Seules les cartes répertoriées sur le formulaire d\'achat sont applicables. Veuillez comprendre à l\'avance.',
        'ko': '구매 양식에 기재된 카드만 적용됩니다. 미리 양해 부탁드립니다.',
        'zh': '僅限購買表格上列出的卡片適用。請事先了解。',
        'zh-TW': '只有购买表格上列出的卡片适用。请事先理解。',
      },
      'はい。取得日より6ヶ月となります。': {
        'en': 'Yes. It will be six months from the date of acquisition.',
        'it': 'Sì. Saranno sei mesi dalla data di acquisizione.',
        'de': 'Ja. Es werden sechs Monate ab dem Erwerbsdatum sein.',
        'es': 'Sí. Serán seis meses a partir de la fecha de adquisición.',
        'fr': 'Oui. Ce sera six mois à partir de la date d\'acquisition.',
        'ko': '네. 인수일로부터 6개월이 될 것입니다.',
        'zh': '是的。這將從收購日期起算六個月。',
        'zh-TW': '是的。从收购日期起将是六个月。',
      },
      '現金への換金はできません。': {
        'en': 'Cash redemption is not possible.',
        'it': 'Il riscatto in contanti non è possibile.',
        'de': 'Eine Barauszahlung ist nicht möglich.',
        'es': 'No es posible el canje en efectivo.',
        'fr': 'Le remboursement en espèces n\'est pas possible.',
        'ko': '현금으로 상환할 수 없습니다.',
        'zh': '無法兌換現金。',
        'zh-TW': '无法兑现。',
      },
      '「商品名」の方が優先されます。ご心配をおかけしてしまい、大変申し訳ございません。': {
        'en': 'The "product name" will take precedence. We apologize for causing you concern.',
        'it': 'Il "nome del prodotto" avrà la precedenza. Ci scusiamo per avervi causato preoccupazione.',
        'de': 'Der "Produktname" hat Vorrang. Wir entschuldigen uns für die entstandenen Unannehmlichkeiten.',
        'es': 'El "nombre del producto" tendrá prioridad. Lamentamos haberle causado preocupación.',
        'fr': 'Le "nom du produit" aura la priorité. Nous nous excusons de vous avoir causé des inquiétudes.',
        'ko': '"제품명"이 우선합니다. 걱정을 끼쳐드려 죄송합니다.',
        'zh': '「產品名稱」將優先處理。我們對於造成您的困擾深感抱歉。',
        'zh-TW': '“产品名称”将优先。我们为给您带来的担忧表示歉意。',
      },
      '一度ご決定いただいたものは変更いたしかねます。予めご容赦くださいませ。': {
        'en': 'Once a decision has been made, it cannot be changed. Please understand in advance.',
        'it': 'Una volta presa una decisione, non può essere cambiata. Si prega di comprendere in anticipo.',
        'de': 'Sobald eine Entscheidung getroffen wurde, kann sie nicht mehr geändert werden. Bitte haben Sie im Voraus Verständnis.',
        'es': 'Una vez que se ha tomado una decisión, no se puede cambiar. Por favor, comprenda de antemano.',
        'fr': 'Une fois qu\'une décision a été prise, elle ne peut pas être changée. Veuillez comprendre à l\'avance.',
        'ko': '일단 결정이 내려지면 변경할 수 없습니다. 미리 양해 부탁드립니다.',
        'zh': '一旦做出決定，就無法更改。請事先理解。',
        'zh-TW': '一旦做出决定，就不能更改。请提前理解。',
      },
      '返金は原則不可となります。': {
        'en': 'Refunds are generally not possible.',
        'it': 'I rimborsi generalmente non sono possibili.',
        'de': 'Rückerstattungen sind in der Regel nicht möglich.',
        'es': 'Los reembolsos generalmente no son posibles.',
        'fr': 'Les remboursements ne sont généralement pas possibles.',
        'ko': '환불은 일반적으로 불가능합니다.',
        'zh': '一般來說，退款是不可能的。',
        'zh-TW': '通常无法退款。',
      },
      'ガチャで当たった景品を出品できたり、欲しいカードを購入できます。\n詳細はこちらをクリックしてください。': {
        'en': 'You can list the prizes you won in the gacha or purchase the cards you want. Please click here for details.',
        'it': 'Puoi elencare i premi che hai vinto nel gacha o acquistare le carte che desideri. Clicca qui per i dettagli.',
        'de': 'Sie können die Preise, die Sie im Gacha gewonnen haben, auflisten oder die Karten kaufen, die Sie möchten. Bitte klicken Sie hier für Details.',
        'es': 'Du kan lista de priser du vann i gacha eller köpa de kort du vill ha. Klicka här för detaljer.',
        'fr': 'Vous pouvez répertorier les prix que vous avez gagnés dans le gacha ou acheter les cartes que vous souhaitez. Veuillez cliquer ici pour plus de détails.',
        'ko': '당신이 가챠에서 획득한 상품을 나열하거나 원하는 카드를 구매할 수 있습니다. 자세한 내용은 여기를 클릭하세요.',
        'zh': '您可以列出您在扭蛋中贏得的獎品或購買您想要的卡片。詳情請點擊此處。',
        'zh-TW': '您可以列出您在扭蛋中赢得的奖品或购买您想要的卡片。详情请点击此处。',
      },
      '日本のさまざまな法人さまの商品をガチャで購入することができるページです。': {
        'en': 'This is a page where you can purchase products from various Japanese corporations through a gacha system.',
        'it': 'Questa è una pagina dove puoi acquistare prodotti da varie aziende giapponesi attraverso un sistema gacha.',
        'de': 'Dies ist eine Seite, auf der Sie Produkte von verschiedenen japanischen Unternehmen über ein Gacha-System kaufen können.',
        'es': 'Detta är en sida där du kan köpa produkter från olika japanska företag genom ett gacha-system.',
        'fr': 'C\'est une page où vous pouvez acheter des produits de diverses entreprises japonaises via un système de gacha.',
        'ko': '이 페이지에서는 가챠 시스템을 통해 다양한 일본 기업의 제품을 구매할 수 있습니다.',
        'zh': '這是一個可以通過扭蛋系統購買各種日本公司產品的頁面。',
        'zh-TW': '这是一个可以通过扭蛋系统从各种日本公司购买产品的页面。',
      },
      'サイトについて': {
        'en': 'About the site',
        'it': 'Informazioni sul sito',
        'de': 'Über die Seite',
        'es': 'Om webbplatsen',
        'fr': 'À propos du site',
        'ko': '사이트 정보',
        'zh': '關於本站',
        'zh-TW': '关于本站',
      },
      '発送について': {
        'en': 'About shipping',
        'it': 'Informazioni sulla spedizione',
        'de': 'Zum Versand',
        'es': 'Om frakt',
        'fr': 'À propos de l\'expédition',
        'ko': '배송에 대하여',
        'zh': '關於運送',
        'zh-TW': '关于运输',
      },
      '商品について': {
        'en': 'About the product',
        'it': 'Informazioni sul prodotto',
        'de': 'Über das Produkt',
        'es': 'Om produkten',
        'fr': 'À propos du produit',
        'ko': '제품 정보',
        'zh': '關於產品',
        'zh-TW': '关于产品',
      },
      'shopについて': {
        'en': 'About the shop',
        'it': 'Informazioni sul negozio',
        'de': 'Über den Laden',
        'es': 'Om butiken',
        'fr': 'À propos de la boutique',
        'ko': '상점 소개',
        'zh': '關於商店',
        'zh-TW': '关于商店',
      },
      'X marketについて': {
        'en': 'About X market',
        'it': 'Informazioni sul mercato X',
        'de': 'Über den X-Markt',
        'es': 'Om X-marknaden',
        'fr': 'À propos du marché X',
        'ko': 'X 시장에 대하여',
        'zh': '關於X市場',
        'zh-TW': '关于X市场',
      },
      'アカウントについて': {
        'en': 'About the account',
        'it': 'Informazioni sull\'account',
        'de': 'Über das Konto',
        'es': 'Om kontot',
        'fr': 'À propos du compte',
        'ko': '계정 정보',
        'zh': '關於帳戶',
        'zh-TW': '关于账户',
      },
      '郵送買取について': {
        'en': 'About sell to us',
        'it': 'Informazioni sulla vendita a noi',
        'de': 'Über den Verkauf an uns',
        'es': 'Om att sälja till oss',
        'fr': 'À propos de la vente à nous',
        'ko': '판매에 대하여',
        'zh': '關於賣給我們',
        'zh-TW': '关于卖给我们',
      },
      'コインについて': {
        'en': 'About the coin',
        'it': 'Informazioni sulla moneta',
        'de': 'Über die Münze',
        'es': 'Om myntet',
        'fr': 'À propos de la pièce',
        'ko': '동전에 대하여',
        'zh': '關於這枚硬幣',
        'zh-TW': '关于这枚硬币',
      },
      'キャンセル・返品・返金について': {
        'en': 'Regarding cancellation, returns, and refunds',
        'it': 'Per quanto riguarda la cancellazione, i resi e i rimborsi',
        'de': 'Bezüglich Stornierung, Rücksendungen und Rückerstattungen',
        'es': 'Angående avbokning, returer och återbetalningar',
        'fr': 'Concernant l\'annulation, les retours et les remboursements',
        'ko': '취소, 반품 및 환불에 관하여',
        'zh': '關於取消、退貨和退款',
        'zh-TW': '关于取消、退货和退款',
      },
      '友達を紹介してコインを貰いたいけど、どうすればいいですか？': {
        'en': 'I want to introduce a friend and get coins, but what should I do?',
        'it': 'Voglio presentare un amico e ottenere monete, ma cosa dovrei fare?',
        'de': 'Ich möchte einen Freund vorstellen und Münzen bekommen, aber was soll ich tun?',
        'es': 'Jag vill presentera en vän och få mynt, men vad ska jag göra?',
        'fr': 'Je veux présenter un ami et obtenir des pièces, mais que dois-je faire ?',
        'ko': '친구를 소개하고 코인을 받고 싶은데, 어떻게 해야 하나요?',
        'zh': '我想介紹一位朋友並獲得硬幣，但我應該怎麼做？',
        'zh-TW': '我想介绍一个朋友并获得硬币，但我该怎么办？',
      },
      '会員ランクを翌月も維持することはできますか？': {
        'en': 'Can I maintain my membership rank for the following month?',
        'it': 'Posso mantenere il mio livello di appartenenza per il mese successivo?',
        'de': 'Kann ich meinen Mitgliedsrang für den folgenden Monat beibehalten?',
        'es': 'Kan jag behålla min medlemskapsnivå för nästa månad?',
        'fr': 'Puis-je maintenir mon rang d\'adhésion pour le mois suivant ?',
        'ko': '다음 달에도 내 회원 등급을 유지할 수 있나요?',
        'zh': '我可以在下個月維持我的會員等級嗎？',
        'zh-TW': '我可以在下个月保持我的会员等级吗？',
      },
      '私の会社の商材もガチャで販売できますか？': {
        'en': 'Can my company\'s products also be sold in the shop\'s gacha?',
        'it': 'I prodotti della mia azienda possono essere venduti anche nel gacha del negozio?',
        'de': 'Können die Produkte meines Unternehmens auch im Gacha des Ladens verkauft werden?',
        'es': 'Kan mitt företags produkter också säljas i butikens gacha?',
        'fr': 'Les produits de mon entreprise peuvent-ils également être vendus dans le gacha du magasin ?',
        'ko': '우리 회사의 제품도 가게의 가챠에서 판매될 수 있나요?',
        'zh': '我的公司的產品也可以在商店的扭蛋機中出售嗎？',
        'zh-TW': '我的公司的产品也可以在商店的扭蛋机中出售吗？',
      },
      '問い合わせへの返信はどのくらいの時間で返ってきますか？': {
        'en': 'How long does it take to get a reply to an inquiry?',
        'it': 'Quanto tempo ci vuole per ricevere una risposta a una richiesta?',
        'de': 'Wie lange dauert es, eine Antwort auf eine Anfrage zu erhalten?',
        'es': 'Hur lång tid tar det att få svar på en förfrågan?',
        'fr': 'Combien de temps faut-il pour obtenir une réponse à une demande ?',
        'ko': '문의에 대한 답변을 받는 데 얼마나 걸리나요?',
        'zh': '查詢需要多長時間才能得到回覆？',
        'zh-TW': '询问需要多长时间才能得到回复？',
      },
      '動画を見たのにコインが貰えなかった。なぜでしょうか？': {
        'en': 'I watched the video but didn\'t receive the coin. Why is that?',
        'it': 'Ho guardato il video ma non ho ricevuto la moneta. Perché?',
        'de': 'Ich habe das Video angesehen, aber die Münze nicht erhalten. Warum ist das so?',
        'es': 'Jag tittade på videon men fick inte myntet. Varför är det så?',
        'fr': 'J\'ai regardé la vidéo mais je n\'ai pas reçu la pièce. Pourquoi cela?',
        'ko': '동영상을 봤지만 동전을 받지 못했습니다. 왜 그런가요?',
        'zh': '我看了影片但沒有收到硬幣。這是為什麼？',
        'zh-TW': '我看了视频但没有收到硬币。这是为什么？',
      },
      '発送はいつですか？': {
        'en': 'When is the shipment?',
        'it': 'Quando è la spedizione?',
        'de': 'Wann ist die Lieferung?',
        'es': 'När är leveransen?',
        'fr': 'Quand est l\'expédition ?',
        'ko': '배송은 언제입니까?',
        'zh': '貨物何時運送？',
        'zh-TW': '发货时间是什么时候？',
      },
      '梱包は丁寧ですか？': {
        'en': 'Is the packaging careful?',
        'it': 'L\'imballaggio è accurato?',
        'de': 'Ist die Verpackung sorgfältig?',
        'es': 'Är förpackningen noggrann?',
        'fr': 'L\'emballage est-il soigné ?',
        'ko': '포장이 신중한가요?',
        'zh': '包裝是否仔細？',
        'zh-TW': '包装是否仔细？',
      },
      '配送業者はどこですか？': {
        'en': 'Where is the delivery company?',
        'it': 'Dov\'è la compagnia di consegna?',
        'de': 'Wo ist das Lieferunternehmen?',
        'es': 'Var är leveransföretaget?',
        'fr': 'Où est l\'entreprise de livraison ?',
        'ko': '배달 회사는 어디에 있나요?',
        'zh': '送貨公司在哪裡？',
        'zh-TW': '送货公司在哪里？',
      },
      '送料はかかりますか？': {
        'en': 'Is there a shipping fee?',
        'it': 'C\'è una tassa di spedizione?',
        'de': 'Gibt es eine Versandgebühr?',
        'es': 'Är det en fraktavgift?',
        'fr': 'Y a-t-il des frais de livraison ?',
        'ko': '배송비가 있나요?',
        'zh': '有運費嗎？',
        'zh-TW': '有运费吗？',
      },
      '追跡番号はどこでわかりますか？': {
        'en': 'Where can I find the tracking number?',
        'it': 'Dove posso trovare il numero di tracciamento?',
        'de': 'Wo finde ich die Sendungsnummer?',
        'es': 'Var kan jag hitta spårningsnumret?',
        'fr': 'Où puis-je trouver le numéro de suivi ?',
        'ko': '추적 번호를 어디에서 찾을 수 있나요?',
        'zh': '我在哪裡可以找到追蹤號碼？',
        'zh-TW': '我在哪里可以找到追踪号码？',
      },
      '発送通知からどのくらいで追跡番号がインターネットで確認できますか？': {
        'en': 'How long after the shipping notification can the tracking number be checked online?',
        'it': 'Quanto tempo dopo la notifica di spedizione si può controllare il numero di tracciamento online?',
        'de': 'Wie lange nach der Versandbenachrichtigung kann die Sendungsnummer online überprüft werden?',
        'es': 'Hur lång tid efter leveransmeddelandet kan spårningsnumret kontrolleras online?',
        'fr': 'Combien de temps après la notification d\'expédition le numéro de suivi peut-il être vérifié en ligne ?',
        'ko': '배송 알림 후 얼마나 지나야 추적 번호를 온라인에서 확인할 수 있나요?',
        'zh': '在收到運送通知後多久可以在線上查詢追蹤號碼？',
        'zh-TW': '发货通知后多久可以在线查询追踪号码？',
      },
      '住所変更はどこからできますか？': {
        'en': 'Where can I change my address?',
        'it': 'Dove posso cambiare il mio indirizzo?',
        'de': 'Wo kann ich meine Adresse ändern?',
        'es': 'Var kan jag ändra min adress?',
        'fr': 'Où puis-je changer mon adresse ?',
        'ko': '주소를 어디에서 변경할 수 있나요?',
        'zh': '我可以在哪裡更改我的地址？',
        'zh-TW': '我可以在哪里更改我的地址？',
      },
      'X marketで買った商品は何日くらいで届きますか？': {
        'en': 'How many days does it take for the products bought at X market to arrive?',
        'it': 'Quanti giorni ci vogliono per l\'arrivo dei prodotti acquistati al mercato X?',
        'de': 'Wie viele Tage dauert es, bis die im X-Markt gekauften Produkte ankommen?',
        'es': 'Hur många dagar tar det för produkterna köpta på X-marknaden att komma fram?',
        'fr': 'Combien de jours faut-il pour que les produits achetés au marché X arrivent ?',
        'ko': 'X 시장에서 구매한 제품이 도착하는 데 며칠이 걸리나요?',
        'zh': '從X市場購買的產品需要多少天才能到達？',
        'zh-TW': '从X市场购买的产品需要多少天才能到达？',
      },
      'カードの状態は綺麗ですか？': {
        'en': 'Is the condition of the card good?',
        'it': 'La condizione della carta è buona?',
        'de': 'Ist der Zustand der Karte gut?',
        'es': 'Är kortets skick bra?',
        'fr': 'L\'état de la carte est-il bon ?',
        'ko': '카드 상태가 좋은가요?',
        'zh': '卡的狀況好嗎？',
        'zh-TW': '卡的状况好吗？',
      },
      '違う商品が届いた。どうすればいいですか？': {
        'en': 'A different product arrived. What should I do?',
        'it': 'È arrivato un prodotto diverso. Cosa dovrei fare?',
        'de': 'Ein anderes Produkt ist angekommen. Was soll ich tun?',
        'es': 'En annan produkt kom. Vad ska jag göra?',
        'fr': 'Un produit différent est arrivé. Que dois-je faire ?',
        'ko': '다른 제품이 도착했습니다. 어떻게 해야 하나요?',
        'zh': '收到不同的產品。我該怎麼辦？',
        'zh-TW': '收到不同的产品。我该怎么办？',
      },
      '私たちの会社の商品を販売して欲しい。どうしたらいいですか？': {
        'en': 'I want our products to be sold as gacha on this site. What should I do?',
        'it': 'Voglio che i nostri prodotti siano venduti come gacha su questo sito. Cosa dovrei fare?',
        'de': 'Ich möchte, dass unsere Produkte als Gacha auf dieser Seite verkauft werden. Was soll ich tun?',
        'es': 'Jag vill att våra produkter ska säljas som gacha på den här sidan. Vad ska jag göra?',
        'fr': 'Je veux que nos produits soient vendus en gacha sur ce site. Que dois-je faire ?',
        'ko': '우리 제품을 이 사이트에서 가챠로 판매하고 싶습니다. 어떻게 해야 하나요?',
        'zh': '我希望我們的產品能在這個網站上以扭蛋形式銷售。我該怎麼做？',
        'zh-TW': '我希望我们的产品能在这个网站上以扭蛋的形式出售。我该怎么办？',
      },
      'X marketに出品できないのはなぜですか？': {
        'en': 'Why can\'t I list it on X market?',
        'it': 'Perché non posso elencarlo sul mercato X?',
        'de': 'Warum kann ich es nicht auf dem X-Markt auflisten?',
        'es': 'Varför kan jag inte lista det på X-marknaden?',
        'fr': 'Pourquoi ne puis-je pas le répertorier sur le marché X ?',
        'ko': '왜 X 시장에 그것을 나열할 수 없나요?',
        'zh': '為什麼我不能在 X 市場上列出它？',
        'zh-TW': '为什么我不能在X市场上列出它？',
      },
      'パスワードを忘れた。どうすればいいですか？': {
        'en': 'I forgot my password. What should I do?',
        'it': 'Ho dimenticato la mia password. Cosa dovrei fare?',
        'de': 'Ich habe mein Passwort vergessen. Was soll ich tun?',
        'es': 'Jag glömde mitt lösenord. Vad ska jag göra?',
        'fr': 'J\'ai oublié mon mot de passe. Que dois-je faire ?',
        'ko': '비밀번호를 잊어버렸습니다. 어떻게 해야 하나요?',
        'zh': '我忘記了我的密碼。我該怎麼辦？',
        'zh-TW': '我忘记了我的密码。我该怎么办？',
      },
      '退会したい場合はどうすればいいですか？': {
        'en': 'What should I do if I want to withdraw?',
        'it': 'Cosa dovrei fare se voglio ritirarmi?',
        'de': 'Was soll ich tun, wenn ich mich zurückziehen möchte?',
        'es': 'Vad ska jag göra om jag vill dra mig tillbaka?',
        'fr': 'Que dois-je faire si je veux me retirer ?',
        'ko': '어떻게 출금할 수 있나요?',
        'zh': '如果我想提款該怎麼辦？',
        'zh-TW': '如果我想退出，我该怎么办？',
      },
      '1人で複数のアカウントを所有することは可能ですか？': {
        'en': 'Is it possible to own multiple accounts by oneself?',
        'it': 'È possibile possedere più account da soli?',
        'de': 'Ist es möglich, mehrere Konten selbst zu besitzen?',
        'es': 'Är det möjligt att äga flera konton själv?',
        'fr': 'Est-il possible de posséder plusieurs comptes soi-même ?',
        'ko': '한 사람이 여러 계정을 소유할 수 있나요?',
        'zh': '是否可以自己擁有多個帳戶？',
        'zh-TW': '一个人可以拥有多个账户吗？',
      },
      '1アカウントを複数台の端末を利用することは可能ですか？': {
        'en': 'Is it possible to use one account on multiple devices?',
        'it': 'È possibile utilizzare un account su più dispositivi?',
        'de': 'Ist es möglich, ein Konto auf mehreren Geräten zu verwenden?',
        'es': 'Är det möjligt att använda ett konto på flera enheter?',
        'fr': 'Est-il possible d\'utiliser un compte sur plusieurs appareils ?',
        'ko': '하나의 계정을 여러 기기에서 사용할 수 있나요?',
        'zh': '是否可以在多個設備上使用一個帳戶？',
        'zh-TW': '是否可以在多个设备上使用一个账户？',
      },
      '何日くらいで査定結果がでますか？': {
        'en': 'How many days will it take to get the appraisal results?',
        'it': 'Quanti giorni ci vorranno per ottenere i risultati della valutazione?',
        'de': 'Wie viele Tage wird es dauern, bis die Bewertungsergebnisse vorliegen?',
        'es': 'Hur många dagar tar det att få utvärderingsresultaten?',
        'fr': 'Combien de jours faudra-t-il pour obtenir les résultats de l\'évaluation ?',
        'ko': '평가 결과를 받는 데 며칠이 걸릴까요?',
        'zh': '評估結果需要多少天才能獲得？',
        'zh-TW': '评估结果需要多少天才能出来？',
      },
      'いつ入金されますか？': {
        'en': 'When will the payment be made?',
        'it': 'Quando verrà effettuato il pagamento?',
        'de': 'Wann wird die Zahlung erfolgen?',
        'es': 'När kommer betalningen att göras?',
        'fr': 'Quand le paiement sera-t-il effectué ?',
        'ko': '결제는 언제 이루어지나요?',
        'zh': '付款何時會完成？',
        'zh-TW': '付款什么时候进行？',
      },
      '返却は可能ですか？': {
        'en': 'Is a return possible?',
        'it': 'È possibile un ritorno?',
        'de': 'Ist eine Rückgabe möglich?',
        'es': 'Är en retur möjlig?',
        'fr': 'Un retour est-il possible ?',
        'ko': '반품이 가능한가요?',
        'zh': '是否可以退貨？',
        'zh-TW': '是否可以返回？',
      },
      '買取表に載っていないカードの買取は可能ですか？': {
        'en': 'Is it possible to buy cards that are not listed on the purchase list?',
        'it': 'È possibile acquistare carte che non sono elencate nella lista degli acquisti?',
        'de': 'Ist es möglich, Karten zu kaufen, die nicht auf der Einkaufsliste stehen?',
        'es': 'Är det möjligt att köpa kort som inte finns med på inköpslistan?',
        'fr': 'Est-il possible d\'acheter des cartes qui ne sont pas répertoriées sur la liste d\'achat ?',
        'ko': '구매 목록에 없는 카드를 구매할 수 있나요?',
        'zh': '是否可以購買不在購買清單上的卡片？',
        'zh-TW': '是否可以购买未列在购买清单上的卡片？',
      },
      '有効期限はありますか？': {
        'en': 'Is there an expiration date?',
        'it': 'C\'è una data di scadenza?',
        'de': 'Gibt es ein Ablaufdatum?',
        'es': 'Finns det ett utgångsdatum?',
        'fr': 'Y a-t-il une date d\'expiration ?',
        'ko': '유효 기간이 있나요?',
        'zh': '有有效期限嗎？',
        'zh-TW': '有有效期吗？',
      },
      '換金できますか？': {
        'en': 'Can it be exchanged for cash?',
        'it': 'Può essere scambiato per contanti?',
        'de': 'Kann es gegen Bargeld eingetauscht werden?',
        'es': 'Kan det bytas mot kontanter?',
        'fr': 'Peut-il être échangé contre de l\'argent ?',
        'ko': '현금으로 교환할 수 있나요?',
        'zh': '可以兌換成現金嗎？',
        'zh-TW': '可以兑换成现金吗？',
      },
      'カードの画像と商品名が違うカードが当たった。どっちが正しいですか？': {
        'en': 'I received a card where the image and product name are different. Which one is correct?',
        'it': 'Ho ricevuto una carta in cui l\'immagine e il nome del prodotto sono diversi. Quale è corretto?',
        'de': 'Ich habe eine Karte erhalten, bei der Bild und Produktname unterschiedlich sind. Welches ist korrekt?',
        'es': 'Jag fick ett kort där bilden och produktnamnet är olika. Vilken är korrekt?',
        'fr': 'J\'ai reçu une carte où l\'image et le nom du produit sont différents. Lequel est correct ?',
        'ko': '이미지와 제품 이름이 다른 카드를 받았습니다. 어느 것이 맞나요?',
        'zh': '我收到一張卡片，上面的圖片和產品名稱不同。哪一個是正確的？',
        'zh-TW': '我收到了一张卡片，其中的图像和产品名称不同。哪个是正确的？',
      },
      '発送を希望している商品を誤ってコインに還元してしまった。変更できますか？': {
        'en': 'I accidentally converted the product I wanted to ship into coins. Can I change it?',
        'it': 'Ho accidentalmente convertito il prodotto che volevo spedire in monete. Posso cambiarlo?',
        'de': 'Ich habe versehentlich das Produkt, das ich versenden wollte, in Münzen umgewandelt. Kann ich es ändern?',
        'es': 'Jag råkade omvandla produkten jag ville skicka till mynt. Kan jag ändra det?',
        'fr': 'J\'ai accidentellement converti le produit que je voulais expédier en pièces. Puis-je le changer ?',
        'ko': '제가 배송하려던 제품을 실수로 동전으로 변환했습니다. 변경할 수 있나요?',
        'zh': '我不小心把我想運送的產品轉換成硬幣了。我可以更改嗎？',
        'zh-TW': '我不小心把我想运送的产品转换成了硬币。我可以更改吗？',
      },
      '返金は可能でしょうか？': {
        'en': 'Is a refund possible?',
        'it': 'È possibile un rimborso?',
        'de': 'Ist eine Rückerstattung möglich?',
        'es': 'Är en återbetalning möjlig?',
        'fr': 'Un remboursement est-il possible ?',
        'ko': '환불이 가능한가요?',
        'zh': '可以退款嗎？',
        'zh-TW': '可以退款吗？',
      },
      'Xmarketとはなんですか？': {
        'en': 'What is Xmarket?',
        'it': 'Cos\'è Xmarket?',
        'de': 'Was ist Xmarket?',
        'es': 'Qué es Xmarket?',
        'fr': 'Qu\'est-ce que Xmarket ?',
        'ko': 'Xmarket이란 무엇인가요?',
        'zh': '何謂Xmarket？',
        'zh-TW': '什么是Xmarket？',
      },
      'shopとはなんですか？': {
        'en': 'What is a shop?',
        'it': 'Che cos\'è un negozio?',
        'de': 'Was ist ein Geschäft?',
        'es': 'Qué es una tienda?',
        'fr': 'Qu\'est-ce qu\'un shop ?',
        'ko': 'shop이란 무엇입니까?',
        'zh': 'shop是什麼？',
        'zh-TW': '什么是shop？',
      },
    },
  }),
  computed: {
    ...mapGetters({
      currentLanguage: 'user/currentLanguage',
    }),
  },
  methods: {
    t(code) {
      if (this.currentLanguage === 'jp') {
        return code;
      }
      if (this.i18n_message[code]) {
        if (this.i18n_message[code][this.currentLanguage]) {
          return this.i18n_message[code][this.currentLanguage];
        }
      }

      if (this.currentLanguage !== 'jp') {
        // console.log(`紐づけなし:${code}`);
      }
      return code;
    },
  },
};
